import { j as Zr } from "./jsx-runtime-944c88e2.js";
import { useQueryClient as Xr, useQuery as wr } from "@tanstack/react-query";
import { useState as Sr, useEffect as rn, useCallback as Ln, useMemo as Qr, createContext as ei } from "react";
import { g as ti } from "./domains-7d097fe4.js";
import { u as _r } from "./features-b5f79a23.js";
import { k as ni } from "./useAccount-78ba59e2.js";
import "./myasurion-shared.mixpanel.es.js";
import { a as Cn, c as at } from "./lodash-9598aa3c.js";
var ri = "Logging", ii = globalThis && globalThis.__values || function(n) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && n[t], i = 0;
  if (e)
    return e.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && i >= n.length && (n = void 0), { value: n && n[i++], done: !n };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Je = globalThis && globalThis.__read || function(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}, ze = globalThis && globalThis.__spreadArray || function(n, t, e) {
  if (e || arguments.length === 2)
    for (var i = 0, o = t.length, r; i < o; i++)
      (r || !(i in t)) && (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
  return n.concat(r || Array.prototype.slice.call(t));
}, jn = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5
}, Ie;
(function(n) {
  n.DEBUG = "DEBUG", n.ERROR = "ERROR", n.INFO = "INFO", n.WARN = "WARN", n.VERBOSE = "VERBOSE";
})(Ie || (Ie = {}));
var Ee = (
  /** @class */
  function() {
    function n(t, e) {
      e === void 0 && (e = Ie.WARN), this.name = t, this.level = e, this._pluggables = [];
    }
    return n.prototype._padding = function(t) {
      return t < 10 ? "0" + t : "" + t;
    }, n.prototype._ts = function() {
      var t = /* @__PURE__ */ new Date();
      return [this._padding(t.getMinutes()), this._padding(t.getSeconds())].join(":") + "." + t.getMilliseconds();
    }, n.prototype.configure = function(t) {
      return t ? (this._config = t, this._config) : this._config;
    }, n.prototype._log = function(t) {
      for (var e, i, o = [], r = 1; r < arguments.length; r++)
        o[r - 1] = arguments[r];
      var a = this.level;
      n.LOG_LEVEL && (a = n.LOG_LEVEL), typeof window < "u" && window.LOG_LEVEL && (a = window.LOG_LEVEL);
      var u = jn[a], h = jn[t];
      if (h >= u) {
        var s = console.log.bind(console);
        t === Ie.ERROR && console.error && (s = console.error.bind(console)), t === Ie.WARN && console.warn && (s = console.warn.bind(console));
        var l = "[".concat(t, "] ").concat(this._ts(), " ").concat(this.name), d = "";
        if (o.length === 1 && typeof o[0] == "string")
          d = "".concat(l, " - ").concat(o[0]), s(d);
        else if (o.length === 1)
          d = "".concat(l, " ").concat(o[0]), s(l, o[0]);
        else if (typeof o[0] == "string") {
          var v = o.slice(1);
          v.length === 1 && (v = v[0]), d = "".concat(l, " - ").concat(o[0], " ").concat(v), s("".concat(l, " - ").concat(o[0]), v);
        } else
          d = "".concat(l, " ").concat(o), s(l, o);
        try {
          for (var y = ii(this._pluggables), m = y.next(); !m.done; m = y.next()) {
            var S = m.value, b = { message: d, timestamp: Date.now() };
            S.pushLogs([b]);
          }
        } catch (E) {
          e = { error: E };
        } finally {
          try {
            m && !m.done && (i = y.return) && i.call(y);
          } finally {
            if (e)
              throw e.error;
          }
        }
      }
    }, n.prototype.log = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this._log.apply(this, ze([Ie.INFO], Je(t), !1));
    }, n.prototype.info = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this._log.apply(this, ze([Ie.INFO], Je(t), !1));
    }, n.prototype.warn = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this._log.apply(this, ze([Ie.WARN], Je(t), !1));
    }, n.prototype.error = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this._log.apply(this, ze([Ie.ERROR], Je(t), !1));
    }, n.prototype.debug = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this._log.apply(this, ze([Ie.DEBUG], Je(t), !1));
    }, n.prototype.verbose = function() {
      for (var t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this._log.apply(this, ze([Ie.VERBOSE], Je(t), !1));
    }, n.prototype.addPluggable = function(t) {
      t && t.getCategoryName() === ri && (this._pluggables.push(t), t.configure(this._config));
    }, n.prototype.listPluggables = function() {
      return this._pluggables;
    }, n.LOG_LEVEL = null, n;
  }()
), oi = globalThis && globalThis.__read || function(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}, Wt = new Ee("Amplify"), si = (
  /** @class */
  function() {
    function n() {
      this._components = [], this._config = {}, this._modules = {}, this.Auth = null, this.Analytics = null, this.API = null, this.Credentials = null, this.Storage = null, this.I18n = null, this.Cache = null, this.PubSub = null, this.Interactions = null, this.Pushnotification = null, this.UI = null, this.XR = null, this.Predictions = null, this.DataStore = null, this.Geo = null, this.Notifications = null, this.Logger = Ee, this.ServiceWorker = null;
    }
    return n.prototype.register = function(t) {
      Wt.debug("component registered in amplify", t), this._components.push(t), typeof t.getModuleName == "function" ? (this._modules[t.getModuleName()] = t, this[t.getModuleName()] = t) : Wt.debug("no getModuleName method for component", t), t.configure(this._config);
    }, n.prototype.configure = function(t) {
      var e = this;
      return t ? (this._config = Object.assign(this._config, t), Wt.debug("amplify config", this._config), Object.entries(this._modules).forEach(function(i) {
        var o = oi(i, 2);
        o[0];
        var r = o[1];
        Object.keys(r).forEach(function(a) {
          e._modules[a] && (r[a] = e._modules[a]);
        });
      }), this._components.map(function(i) {
        i.configure(e._config);
      }), this._config) : this._config;
    }, n.prototype.addPluggable = function(t) {
      t && t.getCategory && typeof t.getCategory == "function" && this._components.map(function(e) {
        e.addPluggable && typeof e.addPluggable == "function" && e.addPluggable(t);
      });
    }, n;
  }()
), Ot = new si(), z;
(function(n) {
  n.WebUnknown = "0", n.React = "1", n.NextJs = "2", n.Angular = "3", n.VueJs = "4", n.Nuxt = "5", n.Svelte = "6", n.ServerSideUnknown = "100", n.ReactSSR = "101", n.NextJsSSR = "102", n.AngularSSR = "103", n.VueJsSSR = "104", n.NuxtSSR = "105", n.SvelteSSR = "106", n.ReactNative = "201", n.Expo = "202";
})(z || (z = {}));
var on;
(function(n) {
  n.API = "api", n.Auth = "auth", n.Analytics = "analytics", n.DataStore = "datastore", n.Geo = "geo", n.InAppMessaging = "inappmessaging", n.Interactions = "interactions", n.Predictions = "predictions", n.PubSub = "pubsub", n.PushNotification = "pushnotification", n.Storage = "storage";
})(on || (on = {}));
var Kn;
(function(n) {
  n.Record = "1", n.UpdateEndpoint = "2";
})(Kn || (Kn = {}));
var Vn;
(function(n) {
  n.GraphQl = "1", n.Get = "2", n.Post = "3", n.Put = "4", n.Patch = "5", n.Del = "6", n.Head = "7";
})(Vn || (Vn = {}));
var sn;
(function(n) {
  n.FederatedSignIn = "30";
})(sn || (sn = {}));
var qn;
(function(n) {
  n.Subscribe = "1", n.GraphQl = "2";
})(qn || (qn = {}));
var Hn;
(function(n) {
  n.None = "0";
})(Hn || (Hn = {}));
var Gn;
(function(n) {
  n.None = "0";
})(Gn || (Gn = {}));
var $n;
(function(n) {
  n.None = "0";
})($n || ($n = {}));
var Wn;
(function(n) {
  n.Convert = "1", n.Identify = "2", n.Interpret = "3";
})(Wn || (Wn = {}));
var Yn;
(function(n) {
  n.Subscribe = "1";
})(Yn || (Yn = {}));
var Jn;
(function(n) {
  n.None = "0";
})(Jn || (Jn = {}));
var zn;
(function(n) {
  n.Put = "1", n.Get = "2", n.List = "3", n.Copy = "4", n.Remove = "5", n.GetProperties = "6";
})(zn || (zn = {}));
var br = "5.3.15", kt = function() {
  return typeof global < "u";
}, nt = function() {
  return typeof window < "u";
}, Ar = function() {
  return typeof document < "u";
}, En = function() {
  return typeof process < "u";
}, lt = function(n, t) {
  return !!Object.keys(n).find(function(e) {
    return e.startsWith(t);
  });
};
function ai() {
  var n = function(i) {
    return i.startsWith("_react") || i.startsWith("__react");
  }, t = function(i) {
    return Object.keys(i).find(n);
  }, e = function() {
    return Array.from(document.querySelectorAll("[id]"));
  };
  return Ar() && e().some(t);
}
function ui() {
  return En() && typeof process.env < "u" && !!Object.keys(process.env).find(function(n) {
    return n.includes("react");
  });
}
function ci() {
  return nt() && lt(window, "__VUE");
}
function fi() {
  return kt() && lt(global, "__VUE");
}
function li() {
  return nt() && lt(window, "__SVELTE");
}
function hi() {
  return En() && typeof process.env < "u" && !!Object.keys(process.env).find(function(n) {
    return n.includes("svelte");
  });
}
function di() {
  return nt() && window.next && typeof window.next == "object";
}
function gi() {
  return kt() && (lt(global, "__next") || lt(global, "__NEXT"));
}
function pi() {
  return nt() && // @ts-ignore
  (window.__NUXT__ !== void 0 || window.$nuxt !== void 0);
}
function vi() {
  return kt() && typeof global.__NUXT_PATHS__ < "u";
}
function yi() {
  var n = !!(Ar() && document.querySelector("[ng-version]")), t = !!// @ts-ignore
  (nt() && typeof window.ng < "u");
  return n || t;
}
function mi() {
  var n;
  return En() && typeof process.env == "object" && ((n = process.env.npm_lifecycle_script) === null || n === void 0 ? void 0 : n.startsWith("ng ")) || !1;
}
function wi() {
  return typeof navigator < "u" && typeof navigator.product < "u" && navigator.product === "ReactNative";
}
function Si() {
  return kt() && typeof global.expo < "u";
}
function _i() {
  return nt();
}
var bi = [
  // First, detect mobile
  { platform: z.Expo, detectionMethod: Si },
  { platform: z.ReactNative, detectionMethod: wi },
  // Next, detect web frameworks
  { platform: z.NextJs, detectionMethod: di },
  { platform: z.Nuxt, detectionMethod: pi },
  { platform: z.Angular, detectionMethod: yi },
  { platform: z.React, detectionMethod: ai },
  { platform: z.VueJs, detectionMethod: ci },
  { platform: z.Svelte, detectionMethod: li },
  { platform: z.WebUnknown, detectionMethod: _i },
  // Last, detect ssr frameworks
  { platform: z.NextJsSSR, detectionMethod: gi },
  { platform: z.NuxtSSR, detectionMethod: vi },
  { platform: z.ReactSSR, detectionMethod: ui },
  { platform: z.VueJsSSR, detectionMethod: fi },
  { platform: z.AngularSSR, detectionMethod: mi },
  { platform: z.SvelteSSR, detectionMethod: hi }
];
function Ai() {
  var n;
  return ((n = bi.find(function(t) {
    return t.detectionMethod();
  })) === null || n === void 0 ? void 0 : n.platform) || z.ServerSideUnknown;
}
var ut, bt = [], It = !1, Ii = 10, Ci = 10, Ei = 1e3, Tn = function() {
  if (!ut) {
    if (ut = Ai(), It)
      for (; bt.length; )
        bt.pop()();
    else
      bt.forEach(function(n) {
        return n();
      });
    Zn(z.ServerSideUnknown, Ii), Zn(z.WebUnknown, Ci);
  }
  return ut;
}, Ir = function(n) {
  It || bt.push(n);
};
function Ti() {
  ut = void 0;
}
function Zn(n, t) {
  ut === n && !It && setTimeout(function() {
    Ti(), It = !0, setTimeout(Tn, Ei);
  }, t);
}
var Ui = globalThis && globalThis.__read || function(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}, Cr = "aws-amplify", xi = (
  /** @class */
  function() {
    function n() {
      this.userAgent = "".concat(Cr, "/").concat(br);
    }
    return Object.defineProperty(n.prototype, "framework", {
      get: function() {
        return Tn();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "isReactNative", {
      get: function() {
        return this.framework === z.ReactNative || this.framework === z.Expo;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.observeFrameworkChanges = function(t) {
      Ir(t);
    }, n;
  }()
), Yt = new xi(), Pi = function(n) {
  var t = n === void 0 ? {} : n, e = t.category, i = t.action;
  t.framework;
  var o = [[Cr, br]];
  return e && o.push([e, i]), o.push(["framework", Tn()]), o;
}, Un = function(n) {
  var t = Pi(n), e = t.map(function(i) {
    var o = Ui(i, 2), r = o[0], a = o[1];
    return "".concat(r, "/").concat(a);
  }).join(" ");
  return e;
}, ct = globalThis && globalThis.__assign || function() {
  return ct = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, ct.apply(this, arguments);
}, Jt = globalThis && globalThis.__read || function(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}, Xn = globalThis && globalThis.__spreadArray || function(n, t, e) {
  if (e || arguments.length === 2)
    for (var i = 0, o = t.length, r; i < o; i++)
      (r || !(i in t)) && (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
  return n.concat(r || Array.prototype.slice.call(t));
}, De = new Ee("Hub"), Ri = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function Di(n) {
  return n.onHubCapsule !== void 0;
}
var Fi = (
  /** @class */
  function() {
    function n(t) {
      this.listeners = [], this.patterns = [], this.protectedChannels = [
        "core",
        "auth",
        "api",
        "analytics",
        "interactions",
        "pubsub",
        "storage",
        "ui",
        "xr"
      ], this.name = t;
    }
    return n.prototype._remove = function(t, e) {
      if (t instanceof RegExp) {
        var i = this.patterns.find(function(r) {
          var a = r.pattern;
          return a.source === t.source;
        });
        if (!i) {
          De.warn("No listeners for ".concat(t));
          return;
        }
        this.patterns = Xn([], Jt(this.patterns.filter(function(r) {
          return r !== i;
        })), !1);
      } else {
        var o = this.listeners[t];
        if (!o) {
          De.warn("No listeners for ".concat(t));
          return;
        }
        this.listeners[t] = Xn([], Jt(o.filter(function(r) {
          var a = r.callback;
          return a !== e;
        })), !1);
      }
    }, n.prototype.remove = function(t, e) {
      this._remove(t, e);
    }, n.prototype.dispatch = function(t, e, i, o) {
      if (i === void 0 && (i = ""), this.protectedChannels.indexOf(t) > -1) {
        var r = o === Ri;
        r || De.warn("WARNING: ".concat(t, " is protected and dispatching on it can have unintended consequences"));
      }
      var a = {
        channel: t,
        payload: ct({}, e),
        source: i,
        patternInfo: []
      };
      try {
        this._toListeners(a);
      } catch (u) {
        De.error(u);
      }
    }, n.prototype.listen = function(t, e, i) {
      var o = this;
      i === void 0 && (i = "noname");
      var r;
      if (Di(e))
        De.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback."), r = e.onHubCapsule.bind(e);
      else {
        if (typeof e != "function")
          throw new Error("No callback supplied to Hub");
        r = e;
      }
      if (t instanceof RegExp)
        this.patterns.push({
          pattern: t,
          callback: r
        });
      else {
        var a = this.listeners[t];
        a || (a = [], this.listeners[t] = a), a.push({
          name: i,
          callback: r
        });
      }
      return function() {
        o._remove(t, r);
      };
    }, n.prototype._toListeners = function(t) {
      var e = t.channel, i = t.payload, o = this.listeners[e];
      if (o && o.forEach(function(a) {
        De.debug("Dispatching to ".concat(e, " with "), i);
        try {
          a.callback(t);
        } catch (u) {
          De.error(u);
        }
      }), this.patterns.length > 0) {
        if (!i.message) {
          De.warn("Cannot perform pattern matching without a message key");
          return;
        }
        var r = i.message;
        this.patterns.forEach(function(a) {
          var u = r.match(a.pattern);
          if (u) {
            var h = Jt(u), s = h.slice(1), l = ct(ct({}, t), { patternInfo: s });
            try {
              a.callback(l);
            } catch (d) {
              De.error(d);
            }
          }
        });
      }
    }, n;
  }()
), xe = new Fi("__default__"), Oi = function(n) {
  if (n.isResolved)
    return n;
  var t = !0, e = !1, i = !1, o = n.then(function(r) {
    return i = !0, t = !1, r;
  }, function(r) {
    throw e = !0, t = !1, r;
  });
  return o.isFullfilled = function() {
    return i;
  }, o.isPending = function() {
    return t;
  }, o.isRejected = function() {
    return e;
  }, o;
}, pc = function() {
  if (typeof self > "u")
    return !1;
  var n = self;
  return typeof n.WorkerGlobalScope < "u" && self instanceof n.WorkerGlobalScope;
}, Oe = function() {
  var n = typeof window < "u" && typeof window.document < "u", t = typeof process < "u" && process.versions != null && process.versions.node != null;
  return {
    isBrowser: n,
    isNode: t
  };
}, ki = globalThis && globalThis.__extends || function() {
  var n = function(t, e) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var r in o)
        Object.prototype.hasOwnProperty.call(o, r) && (i[r] = o[r]);
    }, n(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    n(t, e);
    function i() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (i.prototype = e.prototype, new i());
  };
}(), Qn = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, zt = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Mi = globalThis && globalThis.__read || function(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}, Ni = globalThis && globalThis.__spreadArray || function(n, t, e) {
  if (e || arguments.length === 2)
    for (var i = 0, o = t.length, r; i < o; i++)
      (r || !(i in t)) && (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
  return n.concat(r || Array.prototype.slice.call(t));
}, yt = new Ee("Util"), Ge = (
  /** @class */
  function(n) {
    ki(t, n);
    function t(e) {
      var i = n.call(this, e) || this;
      return i.nonRetryable = !0, i;
    }
    return t;
  }(Error)
), Bi = function(n) {
  var t = "nonRetryable";
  return n && n[t];
};
function Li(n, t, e, i) {
  return Qn(this, void 0, void 0, function() {
    var o = this;
    return zt(this, function(r) {
      if (typeof n != "function")
        throw Error("functionToRetry must be a function");
      return [2, new Promise(function(a, u) {
        return Qn(o, void 0, void 0, function() {
          var h, s, l, d, v, y, m;
          return zt(this, function(S) {
            switch (S.label) {
              case 0:
                h = 0, s = !1, d = function() {
                }, i && i.then(function() {
                  s = !0, clearTimeout(l), d();
                }), y = function() {
                  var b, E, _, T;
                  return zt(this, function(x) {
                    switch (x.label) {
                      case 0:
                        h++, yt.debug("".concat(n.name, " attempt #").concat(h, " with this vars: ").concat(JSON.stringify(t))), x.label = 1;
                      case 1:
                        return x.trys.push([1, 3, , 7]), b = {}, E = a, [4, n.apply(void 0, Ni([], Mi(t), !1))];
                      case 2:
                        return [2, (b.value = E.apply(void 0, [x.sent()]), b)];
                      case 3:
                        return _ = x.sent(), v = _, yt.debug("error on ".concat(n.name), _), Bi(_) ? (yt.debug("".concat(n.name, " non retryable error"), _), [2, { value: u(_) }]) : (T = e(h, t, _), yt.debug("".concat(n.name, " retrying in ").concat(T, " ms")), T === !1 || s ? [2, { value: u(_) }] : [3, 4]);
                      case 4:
                        return [4, new Promise(function(D) {
                          d = D, l = setTimeout(d, T);
                        })];
                      case 5:
                        x.sent(), x.label = 6;
                      case 6:
                        return [3, 7];
                      case 7:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                }, S.label = 1;
              case 1:
                return s ? [3, 3] : [5, y()];
              case 2:
                return m = S.sent(), typeof m == "object" ? [2, m.value] : [3, 1];
              case 3:
                return u(v), [
                  2
                  /*return*/
                ];
            }
          });
        });
      })];
    });
  });
}
var Er = 5 * 60 * 1e3;
function Tr(n) {
  n === void 0 && (n = Er);
  var t = 100, e = 100;
  return function(i) {
    var o = Math.pow(2, i) * t + e * Math.random();
    return o > n ? !1 : o;
  };
}
var ji = function(n, t, e, i) {
  return e === void 0 && (e = Er), Li(n, t, Tr(e), i);
};
function Ki(n) {
  return n.split("").map(function(t) {
    return t.charCodeAt(0).toString(16).padStart(2, "0");
  }).join("");
}
function Vi(n) {
  return n.match(/.{2}/g).map(function(t) {
    return String.fromCharCode(parseInt(t, 16));
  }).join("");
}
var We = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var an = function(n, t) {
  return an = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, i) {
    e.__proto__ = i;
  } || function(e, i) {
    for (var o in i)
      i.hasOwnProperty(o) && (e[o] = i[o]);
  }, an(n, t);
};
function qi(n, t) {
  an(n, t);
  function e() {
    this.constructor = n;
  }
  n.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var un = function() {
  return un = Object.assign || function(t) {
    for (var e, i = 1, o = arguments.length; i < o; i++) {
      e = arguments[i];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, un.apply(this, arguments);
};
function Hi(n, t) {
  var e = {};
  for (var i in n)
    Object.prototype.hasOwnProperty.call(n, i) && t.indexOf(i) < 0 && (e[i] = n[i]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, i = Object.getOwnPropertySymbols(n); o < i.length; o++)
      t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, i[o]) && (e[i[o]] = n[i[o]]);
  return e;
}
function Gi(n, t, e, i) {
  var o = arguments.length, r = o < 3 ? t : i === null ? i = Object.getOwnPropertyDescriptor(t, e) : i, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    r = Reflect.decorate(n, t, e, i);
  else
    for (var u = n.length - 1; u >= 0; u--)
      (a = n[u]) && (r = (o < 3 ? a(r) : o > 3 ? a(t, e, r) : a(t, e)) || r);
  return o > 3 && r && Object.defineProperty(t, e, r), r;
}
function $i(n, t) {
  return function(e, i) {
    t(e, i, n);
  };
}
function Wi(n, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(n, t);
}
function Yi(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}
function Ji(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
function zi(n, t, e, i) {
  i === void 0 && (i = e), n[i] = t[e];
}
function Zi(n, t) {
  for (var e in n)
    e !== "default" && !t.hasOwnProperty(e) && (t[e] = n[e]);
}
function cn(n) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && n[t], i = 0;
  if (e)
    return e.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && i >= n.length && (n = void 0), { value: n && n[i++], done: !n };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ur(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}
function Xi() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n = n.concat(Ur(arguments[t]));
  return n;
}
function Qi() {
  for (var n = 0, t = 0, e = arguments.length; t < e; t++)
    n += arguments[t].length;
  for (var i = Array(n), o = 0, t = 0; t < e; t++)
    for (var r = arguments[t], a = 0, u = r.length; a < u; a++, o++)
      i[o] = r[a];
  return i;
}
function ht(n) {
  return this instanceof ht ? (this.v = n, this) : new ht(n);
}
function eo(n, t, e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = e.apply(n, t || []), o, r = [];
  return o = {}, a("next"), a("throw"), a("return"), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function a(v) {
    i[v] && (o[v] = function(y) {
      return new Promise(function(m, S) {
        r.push([v, y, m, S]) > 1 || u(v, y);
      });
    });
  }
  function u(v, y) {
    try {
      h(i[v](y));
    } catch (m) {
      d(r[0][3], m);
    }
  }
  function h(v) {
    v.value instanceof ht ? Promise.resolve(v.value.v).then(s, l) : d(r[0][2], v);
  }
  function s(v) {
    u("next", v);
  }
  function l(v) {
    u("throw", v);
  }
  function d(v, y) {
    v(y), r.shift(), r.length && u(r[0][0], r[0][1]);
  }
}
function to(n) {
  var t, e;
  return t = {}, i("next"), i("throw", function(o) {
    throw o;
  }), i("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function i(o, r) {
    t[o] = n[o] ? function(a) {
      return (e = !e) ? { value: ht(n[o](a)), done: o === "return" } : r ? r(a) : a;
    } : r;
  }
}
function no(n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = n[Symbol.asyncIterator], e;
  return t ? t.call(n) : (n = typeof cn == "function" ? cn(n) : n[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
    return this;
  }, e);
  function i(r) {
    e[r] = n[r] && function(a) {
      return new Promise(function(u, h) {
        a = n[r](a), o(u, h, a.done, a.value);
      });
    };
  }
  function o(r, a, u, h) {
    Promise.resolve(h).then(function(s) {
      r({ value: s, done: u });
    }, a);
  }
}
function ro(n, t) {
  return Object.defineProperty ? Object.defineProperty(n, "raw", { value: t }) : n.raw = t, n;
}
function io(n) {
  if (n && n.__esModule)
    return n;
  var t = {};
  if (n != null)
    for (var e in n)
      Object.hasOwnProperty.call(n, e) && (t[e] = n[e]);
  return t.default = n, t;
}
function oo(n) {
  return n && n.__esModule ? n : { default: n };
}
function so(n, t) {
  if (!t.has(n))
    throw new TypeError("attempted to get private field on non-instance");
  return t.get(n);
}
function ao(n, t, e) {
  if (!t.has(n))
    throw new TypeError("attempted to set private field on non-instance");
  return t.set(n, e), e;
}
const uo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return un;
  },
  __asyncDelegator: to,
  __asyncGenerator: eo,
  __asyncValues: no,
  __await: ht,
  __awaiter: Yi,
  __classPrivateFieldGet: so,
  __classPrivateFieldSet: ao,
  __createBinding: zi,
  __decorate: Gi,
  __exportStar: Zi,
  __extends: qi,
  __generator: Ji,
  __importDefault: oo,
  __importStar: io,
  __makeTemplateObject: ro,
  __metadata: Wi,
  __param: $i,
  __read: Ur,
  __rest: Hi,
  __spread: Xi,
  __spreadArrays: Qi,
  __values: cn
}, Symbol.toStringTag, { value: "Module" })), xr = /* @__PURE__ */ Cn(uo);
var Mt = {}, ge = {};
Object.defineProperty(ge, "__esModule", { value: !0 });
ge.MAX_HASHABLE_LENGTH = ge.INIT = ge.KEY = ge.DIGEST_LENGTH = ge.BLOCK_SIZE = void 0;
ge.BLOCK_SIZE = 64;
ge.DIGEST_LENGTH = 32;
ge.KEY = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
ge.INIT = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
];
ge.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
var Nt = {};
Object.defineProperty(Nt, "__esModule", { value: !0 });
Nt.RawSha256 = void 0;
var ye = ge, co = (
  /** @class */
  function() {
    function n() {
      this.state = Int32Array.from(ye.INIT), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return n.prototype.update = function(t) {
      if (this.finished)
        throw new Error("Attempted to update an already finished hash.");
      var e = 0, i = t.byteLength;
      if (this.bytesHashed += i, this.bytesHashed * 8 > ye.MAX_HASHABLE_LENGTH)
        throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; i > 0; )
        this.buffer[this.bufferLength++] = t[e++], i--, this.bufferLength === ye.BLOCK_SIZE && (this.hashBuffer(), this.bufferLength = 0);
    }, n.prototype.digest = function() {
      if (!this.finished) {
        var t = this.bytesHashed * 8, e = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), i = this.bufferLength;
        if (e.setUint8(this.bufferLength++, 128), i % ye.BLOCK_SIZE >= ye.BLOCK_SIZE - 8) {
          for (var o = this.bufferLength; o < ye.BLOCK_SIZE; o++)
            e.setUint8(o, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var o = this.bufferLength; o < ye.BLOCK_SIZE - 8; o++)
          e.setUint8(o, 0);
        e.setUint32(ye.BLOCK_SIZE - 8, Math.floor(t / 4294967296), !0), e.setUint32(ye.BLOCK_SIZE - 4, t), this.hashBuffer(), this.finished = !0;
      }
      for (var r = new Uint8Array(ye.DIGEST_LENGTH), o = 0; o < 8; o++)
        r[o * 4] = this.state[o] >>> 24 & 255, r[o * 4 + 1] = this.state[o] >>> 16 & 255, r[o * 4 + 2] = this.state[o] >>> 8 & 255, r[o * 4 + 3] = this.state[o] >>> 0 & 255;
      return r;
    }, n.prototype.hashBuffer = function() {
      for (var t = this, e = t.buffer, i = t.state, o = i[0], r = i[1], a = i[2], u = i[3], h = i[4], s = i[5], l = i[6], d = i[7], v = 0; v < ye.BLOCK_SIZE; v++) {
        if (v < 16)
          this.temp[v] = (e[v * 4] & 255) << 24 | (e[v * 4 + 1] & 255) << 16 | (e[v * 4 + 2] & 255) << 8 | e[v * 4 + 3] & 255;
        else {
          var y = this.temp[v - 2], m = (y >>> 17 | y << 15) ^ (y >>> 19 | y << 13) ^ y >>> 10;
          y = this.temp[v - 15];
          var S = (y >>> 7 | y << 25) ^ (y >>> 18 | y << 14) ^ y >>> 3;
          this.temp[v] = (m + this.temp[v - 7] | 0) + (S + this.temp[v - 16] | 0);
        }
        var b = (((h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7)) + (h & s ^ ~h & l) | 0) + (d + (ye.KEY[v] + this.temp[v] | 0) | 0) | 0, E = ((o >>> 2 | o << 30) ^ (o >>> 13 | o << 19) ^ (o >>> 22 | o << 10)) + (o & r ^ o & a ^ r & a) | 0;
        d = l, l = s, s = h, h = u + b | 0, u = a, a = r, r = o, o = b + E | 0;
      }
      i[0] += o, i[1] += r, i[2] += a, i[3] += u, i[4] += h, i[5] += s, i[6] += l, i[7] += d;
    }, n;
  }()
);
Nt.RawSha256 = co;
var Pr = {}, Bt = {}, fo = function(n) {
  for (var t = [], e = 0, i = n.length; e < i; e++) {
    var o = n.charCodeAt(e);
    if (o < 128)
      t.push(o);
    else if (o < 2048)
      t.push(o >> 6 | 192, o & 63 | 128);
    else if (e + 1 < n.length && (o & 64512) === 55296 && (n.charCodeAt(e + 1) & 64512) === 56320) {
      var r = 65536 + ((o & 1023) << 10) + (n.charCodeAt(++e) & 1023);
      t.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, r & 63 | 128);
    } else
      t.push(o >> 12 | 224, o >> 6 & 63 | 128, o & 63 | 128);
  }
  return Uint8Array.from(t);
}, lo = function(n) {
  for (var t = "", e = 0, i = n.length; e < i; e++) {
    var o = n[e];
    if (o < 128)
      t += String.fromCharCode(o);
    else if (192 <= o && o < 224) {
      var r = n[++e];
      t += String.fromCharCode((o & 31) << 6 | r & 63);
    } else if (240 <= o && o < 365) {
      var a = [o, n[++e], n[++e], n[++e]], u = "%" + a.map(function(h) {
        return h.toString(16);
      }).join("%");
      t += decodeURIComponent(u);
    } else
      t += String.fromCharCode((o & 15) << 12 | (n[++e] & 63) << 6 | n[++e] & 63);
  }
  return t;
};
function ho(n) {
  return new TextEncoder().encode(n);
}
function go(n) {
  return new TextDecoder("utf-8").decode(n);
}
var po = function(n) {
  return typeof TextEncoder == "function" ? ho(n) : fo(n);
}, vo = function(n) {
  return typeof TextDecoder == "function" ? go(n) : lo(n);
};
const yo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromUtf8: po,
  toUtf8: vo
}, Symbol.toStringTag, { value: "Module" })), mo = /* @__PURE__ */ Cn(yo);
Object.defineProperty(Bt, "__esModule", { value: !0 });
Bt.convertToBuffer = void 0;
var wo = mo, So = typeof Buffer < "u" && Buffer.from ? function(n) {
  return Buffer.from(n, "utf8");
} : wo.fromUtf8;
function _o(n) {
  return n instanceof Uint8Array ? n : typeof n == "string" ? So(n) : ArrayBuffer.isView(n) ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(n);
}
Bt.convertToBuffer = _o;
var Lt = {};
Object.defineProperty(Lt, "__esModule", { value: !0 });
Lt.isEmptyData = void 0;
function bo(n) {
  return typeof n == "string" ? n.length === 0 : n.byteLength === 0;
}
Lt.isEmptyData = bo;
var jt = {};
Object.defineProperty(jt, "__esModule", { value: !0 });
jt.numToUint8 = void 0;
function Ao(n) {
  return new Uint8Array([
    (n & 4278190080) >> 24,
    (n & 16711680) >> 16,
    (n & 65280) >> 8,
    n & 255
  ]);
}
jt.numToUint8 = Ao;
var Kt = {};
Object.defineProperty(Kt, "__esModule", { value: !0 });
Kt.uint32ArrayFrom = void 0;
function Io(n) {
  if (!Array.from) {
    for (var t = new Uint32Array(n.length), e = 0; e < n.length; )
      t[e] = n[e];
    return t;
  }
  return Uint32Array.from(n);
}
Kt.uint32ArrayFrom = Io;
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.uint32ArrayFrom = n.numToUint8 = n.isEmptyData = n.convertToBuffer = void 0;
  var t = Bt;
  Object.defineProperty(n, "convertToBuffer", { enumerable: !0, get: function() {
    return t.convertToBuffer;
  } });
  var e = Lt;
  Object.defineProperty(n, "isEmptyData", { enumerable: !0, get: function() {
    return e.isEmptyData;
  } });
  var i = jt;
  Object.defineProperty(n, "numToUint8", { enumerable: !0, get: function() {
    return i.numToUint8;
  } });
  var o = Kt;
  Object.defineProperty(n, "uint32ArrayFrom", { enumerable: !0, get: function() {
    return o.uint32ArrayFrom;
  } });
})(Pr);
Object.defineProperty(Mt, "__esModule", { value: !0 });
Mt.Sha256 = void 0;
var er = xr, Ct = ge, fn = Nt, ln = Pr, Co = (
  /** @class */
  function() {
    function n(t) {
      if (this.hash = new fn.RawSha256(), t) {
        this.outer = new fn.RawSha256();
        var e = Eo(t), i = new Uint8Array(Ct.BLOCK_SIZE);
        i.set(e);
        for (var o = 0; o < Ct.BLOCK_SIZE; o++)
          e[o] ^= 54, i[o] ^= 92;
        this.hash.update(e), this.outer.update(i);
        for (var o = 0; o < e.byteLength; o++)
          e[o] = 0;
      }
    }
    return n.prototype.update = function(t) {
      if (!((0, ln.isEmptyData)(t) || this.error))
        try {
          this.hash.update((0, ln.convertToBuffer)(t));
        } catch (e) {
          this.error = e;
        }
    }, n.prototype.digestSync = function() {
      if (this.error)
        throw this.error;
      return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
    }, n.prototype.digest = function() {
      return (0, er.__awaiter)(this, void 0, void 0, function() {
        return (0, er.__generator)(this, function(t) {
          return [2, this.digestSync()];
        });
      });
    }, n;
  }()
);
Mt.Sha256 = Co;
function Eo(n) {
  var t = (0, ln.convertToBuffer)(n);
  if (t.byteLength > Ct.BLOCK_SIZE) {
    var e = new fn.RawSha256();
    e.update(t), t = e.digest();
  }
  var i = new Uint8Array(Ct.BLOCK_SIZE);
  return i.set(t), i;
}
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var t = xr;
  (0, t.__exportStar)(Mt, n);
})(We);
var Et = globalThis && globalThis.__assign || function() {
  return Et = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Et.apply(this, arguments);
}, To = new Ee("Parser"), Rr = function(n) {
  var t = {};
  if (n.aws_mobile_analytics_app_id) {
    var e = {
      AWSPinpoint: {
        appId: n.aws_mobile_analytics_app_id,
        region: n.aws_mobile_analytics_app_region
      }
    };
    t.Analytics = e;
  }
  (n.aws_cognito_identity_pool_id || n.aws_user_pools_id) && (t.Auth = {
    userPoolId: n.aws_user_pools_id,
    userPoolWebClientId: n.aws_user_pools_web_client_id,
    region: n.aws_cognito_region,
    identityPoolId: n.aws_cognito_identity_pool_id,
    identityPoolRegion: n.aws_cognito_region,
    mandatorySignIn: n.aws_mandatory_sign_in === "enable",
    signUpVerificationMethod: n.aws_cognito_sign_up_verification_method || "code"
  });
  var i;
  return n.aws_user_files_s3_bucket ? i = {
    AWSS3: {
      bucket: n.aws_user_files_s3_bucket,
      region: n.aws_user_files_s3_bucket_region,
      dangerouslyConnectToHttpEndpointForTesting: n.aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
    }
  } : i = n ? n.Storage || n : {}, n.Logging && (t.Logging = Et(Et({}, n.Logging), { region: n.aws_project_region })), n.geo && (t.Geo = Object.assign({}, n.geo), n.geo.amazon_location_service && (t.Geo = {
    AmazonLocationService: n.geo.amazon_location_service
  })), t.Analytics = Object.assign({}, t.Analytics, n.Analytics), t.Auth = Object.assign({}, t.Auth, n.Auth), t.Storage = Object.assign({}, i), t.Logging = Object.assign({}, t.Logging, n.Logging), To.debug("parse config", n, "to amplifyconfig", t), t;
}, Uo = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, xo = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ne = new Ee("CognitoCredentials"), Po = new Promise(function(n, t) {
  if (!Oe().isBrowser)
    return Ne.debug("not in the browser, directly resolved"), n();
  var e = window.gapi && window.gapi.auth2 ? window.gapi.auth2 : null;
  if (e)
    return Ne.debug("google api already loaded"), n();
  setTimeout(function() {
    return n();
  }, 2e3);
}), Ro = (
  /** @class */
  function() {
    function n() {
      this.initialized = !1, this.refreshGoogleToken = this.refreshGoogleToken.bind(this), this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    return n.prototype.refreshGoogleToken = function() {
      return Uo(this, void 0, void 0, function() {
        return xo(this, function(t) {
          switch (t.label) {
            case 0:
              return this.initialized ? [3, 2] : (Ne.debug("need to wait for the Google SDK loaded"), [4, Po]);
            case 1:
              t.sent(), this.initialized = !0, Ne.debug("finish waiting"), t.label = 2;
            case 2:
              return [2, this._refreshGoogleTokenImpl()];
          }
        });
      });
    }, n.prototype._refreshGoogleTokenImpl = function() {
      var t = null;
      return Oe().isBrowser && (t = window.gapi && window.gapi.auth2 ? window.gapi.auth2 : null), t ? new Promise(function(e, i) {
        t.getAuthInstance().then(function(o) {
          o || (Ne.debug("google Auth undefined"), i(new Ge("google Auth undefined")));
          var r = o.currentUser.get();
          r.isSignedIn() ? (Ne.debug("refreshing the google access token"), r.reloadAuthResponse().then(function(a) {
            var u = a.id_token, h = a.expires_at;
            e({ token: u, expires_at: h });
          }).catch(function(a) {
            a && a.error === "network_error" ? i("Network error reloading google auth response") : i(new Ge("Failed to reload google auth response"));
          })) : i(new Ge("User is not signed in with Google"));
        }).catch(function(o) {
          Ne.debug("Failed to refresh google token", o), i(new Ge("Failed to refresh google token"));
        });
      }) : (Ne.debug("no gapi auth2 available"), Promise.reject("no gapi auth2 available"));
    }, n;
  }()
), Do = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, Fo = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, qe = new Ee("CognitoCredentials"), Oo = new Promise(function(n, t) {
  if (!Oe().isBrowser)
    return qe.debug("not in the browser, directly resolved"), n();
  var e = window.FB;
  if (e)
    return qe.debug("FB SDK already loaded"), n();
  setTimeout(function() {
    return n();
  }, 2e3);
}), ko = (
  /** @class */
  function() {
    function n() {
      this.initialized = !1, this.refreshFacebookToken = this.refreshFacebookToken.bind(this), this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    return n.prototype.refreshFacebookToken = function() {
      return Do(this, void 0, void 0, function() {
        return Fo(this, function(t) {
          switch (t.label) {
            case 0:
              return this.initialized ? [3, 2] : (qe.debug("need to wait for the Facebook SDK loaded"), [4, Oo]);
            case 1:
              t.sent(), this.initialized = !0, qe.debug("finish waiting"), t.label = 2;
            case 2:
              return [2, this._refreshFacebookTokenImpl()];
          }
        });
      });
    }, n.prototype._refreshFacebookTokenImpl = function() {
      var t = null;
      if (Oe().isBrowser && (t = window.FB), !t) {
        var e = "no fb sdk available";
        return qe.debug(e), Promise.reject(new Ge(e));
      }
      return new Promise(function(i, o) {
        t.getLoginStatus(function(r) {
          if (!r || !r.authResponse) {
            var a = "no response from facebook when refreshing the jwt token";
            qe.debug(a), o(new Ge(a));
          } else {
            var u = r.authResponse, h = u.accessToken, s = u.expiresIn, l = /* @__PURE__ */ new Date(), d = s * 1e3 + l.getTime();
            if (!h) {
              var a = "the jwtToken is undefined";
              qe.debug(a), o(new Ge(a));
            }
            i({
              token: h,
              expires_at: d
            });
          }
        }, { scope: "public_profile,email" });
      });
    }, n;
  }()
), Mo = new Ro(), No = new ko(), Ke = {}, Bo = (
  /** @class */
  function() {
    function n() {
    }
    return n.setItem = function(t, e) {
      return Ke[t] = e, Ke[t];
    }, n.getItem = function(t) {
      return Object.prototype.hasOwnProperty.call(Ke, t) ? Ke[t] : void 0;
    }, n.removeItem = function(t) {
      return delete Ke[t];
    }, n.clear = function() {
      return Ke = {}, Ke;
    }, n;
  }()
), Dr = (
  /** @class */
  function() {
    function n() {
      try {
        this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.amplify.test-ls", 1), this.storageWindow.removeItem("aws.amplify.test-ls");
      } catch {
        this.storageWindow = Bo;
      }
    }
    return n.prototype.getStorage = function() {
      return this.storageWindow;
    }, n;
  }()
), Fr = {
  id: "aws",
  outputs: {
    dnsSuffix: "amazonaws.com"
  },
  regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
  regions: ["aws-global"]
}, Lo = {
  partitions: [
    Fr,
    {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn"
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: ["aws-cn-global"]
    }
  ]
}, jo = globalThis && globalThis.__values || function(n) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && n[t], i = 0;
  if (e)
    return e.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && i >= n.length && (n = void 0), { value: n && n[i++], done: !n };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ko = function(n) {
  var t, e, i = Lo.partitions;
  try {
    for (var o = jo(i), r = o.next(); !r.done; r = o.next()) {
      var a = r.value, u = a.regions, h = a.outputs, s = a.regionRegex, l = new RegExp(s);
      if (u.includes(n) || l.test(n))
        return h.dnsSuffix;
    }
  } catch (d) {
    t = { error: d };
  } finally {
    try {
      r && !r.done && (e = o.return) && e.call(o);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return Fr.outputs.dnsSuffix;
};
function Vo(n, t) {
  return t = t || {}, new Promise(function(e, i) {
    var o = new XMLHttpRequest(), r = [], a = [], u = {}, h = function() {
      return { ok: (o.status / 100 | 0) == 2, statusText: o.statusText, status: o.status, url: o.responseURL, text: function() {
        return Promise.resolve(o.responseText);
      }, json: function() {
        return Promise.resolve(o.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([o.response]));
      }, clone: h, headers: { keys: function() {
        return r;
      }, entries: function() {
        return a;
      }, get: function(l) {
        return u[l.toLowerCase()];
      }, has: function(l) {
        return l.toLowerCase() in u;
      } } };
    };
    for (var s in o.open(t.method || "get", n, !0), o.onload = function() {
      o.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(l, d, v) {
        r.push(d = d.toLowerCase()), a.push([d, v]), u[d] = u[d] ? u[d] + "," + v : v;
      }), e(h());
    }, o.onerror = i, o.withCredentials = t.credentials == "include", t.headers)
      o.setRequestHeader(s, t.headers[s]);
    o.send(t.body || null);
  });
}
const qo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vo
}, Symbol.toStringTag, { value: "Module" })), tr = /* @__PURE__ */ Cn(qo);
self.fetch || (self.fetch = tr.default || tr);
var Zt = function(n) {
  var t;
  return function() {
    return t || (t = n()), t;
  };
}, Tt = globalThis && globalThis.__assign || function() {
  return Tt = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Tt.apply(this, arguments);
}, Ho = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, Go = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, $o = function(n) {
  return !["HEAD", "GET", "DELETE"].includes(n.toUpperCase());
}, Wo = function(n, t) {
  var e = n.url, i = n.method, o = n.headers, r = n.body, a = t.abortSignal;
  return Ho(void 0, void 0, void 0, function() {
    var u, h, s, l, d, v, y;
    return Go(this, function(m) {
      switch (m.label) {
        case 0:
          return m.trys.push([0, 2, , 3]), [4, fetch(e, {
            method: i,
            headers: o,
            body: $o(i) ? r : void 0,
            signal: a
          })];
        case 1:
          return u = m.sent(), [3, 3];
        case 2:
          throw h = m.sent(), h instanceof TypeError ? new Error("Network error") : h;
        case 3:
          return s = {}, (v = u.headers) === null || v === void 0 || v.forEach(function(S, b) {
            s[b.toLowerCase()] = S;
          }), l = {
            statusCode: u.status,
            headers: s,
            body: null
          }, d = Object.assign((y = u.body) !== null && y !== void 0 ? y : {}, {
            text: Zt(function() {
              return u.text();
            }),
            blob: Zt(function() {
              return u.blob();
            }),
            json: Zt(function() {
              return u.json();
            })
          }), [2, Tt(Tt({}, l), { body: d })];
      }
    });
  });
}, Ut = globalThis && globalThis.__assign || function() {
  return Ut = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Ut.apply(this, arguments);
}, Yo = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, Jo = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, zo = 3, Zo = function(n) {
  var t = n.maxAttempts, e = t === void 0 ? zo : t, i = n.retryDecider, o = n.computeDelay, r = n.abortSignal;
  if (e < 1)
    throw new Error("maxAttempts must be greater than 0");
  return function(a, u) {
    return function(s) {
      var l;
      return Yo(this, void 0, void 0, function() {
        var d, v, y, m, S, b;
        return Jo(this, function(E) {
          switch (E.label) {
            case 0:
              v = (l = u.attemptsCount) !== null && l !== void 0 ? l : 0, m = function() {
                if (y)
                  return nr(y, v), y;
                throw nr(d, v), d;
              }, E.label = 1;
            case 1:
              if (!(!(r != null && r.aborted) && v < e))
                return [3, 11];
              E.label = 2;
            case 2:
              return E.trys.push([2, 4, , 5]), [4, a(s)];
            case 3:
              return y = E.sent(), d = void 0, [3, 5];
            case 4:
              return S = E.sent(), d = S, y = void 0, [3, 5];
            case 5:
              return v = u.attemptsCount > v ? u.attemptsCount : v + 1, u.attemptsCount = v, [4, i(y, d)];
            case 6:
              return E.sent() ? !(r != null && r.aborted) && v < e ? (b = o(v), [4, Xo(b, r)]) : [3, 8] : [3, 9];
            case 7:
              E.sent(), E.label = 8;
            case 8:
              return [3, 1];
            case 9:
              return [2, m()];
            case 10:
              return [3, 1];
            case 11:
              if (r != null && r.aborted)
                throw new Error("Request aborted.");
              return [2, m()];
          }
        });
      });
    };
  };
}, Xo = function(n, t) {
  if (t != null && t.aborted)
    return Promise.resolve();
  var e, i, o = new Promise(function(r) {
    i = r, e = setTimeout(r, n);
  });
  return t == null || t.addEventListener("abort", function r(a) {
    clearTimeout(e), t == null || t.removeEventListener("abort", r), i();
  }), o;
}, nr = function(n, t) {
  var e;
  Object.prototype.toString.call(n) === "[object Object]" && (n.$metadata = Ut(Ut({}, (e = n.$metadata) !== null && e !== void 0 ? e : {}), { attempts: t }));
}, rr = 5 * 60 * 1e3, Qo = function(n) {
  var t = Tr(rr), e = t(n);
  return e === !1 ? rr : e;
}, es = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch",
  "BadRequestException"
  // API Gateway
], ts = function(n) {
  return es.includes(n);
}, ns = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, rs = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, is = function(n) {
  return function(t, e) {
    return ns(void 0, void 0, void 0, function() {
      var i, o, r, a;
      return rs(this, function(u) {
        switch (u.label) {
          case 0:
            return e == null ? [3, 1] : (o = e, [3, 3]);
          case 1:
            return [4, n(t)];
          case 2:
            o = u.sent(), u.label = 3;
          case 3:
            return i = ((a = o) !== null && a !== void 0 ? a : {}).name, r = t == null ? void 0 : t.statusCode, [2, us(e) || as(r, i) || ts(i) || cs(r, i)];
        }
      });
    });
  };
}, os = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException"
], ss = [
  "TimeoutError",
  "RequestTimeout",
  "RequestTimeoutException"
], as = function(n, t) {
  return n === 429 || os.includes(t);
}, us = function(n) {
  return (n == null ? void 0 : n.name) === "Network error";
}, cs = function(n, t) {
  return [500, 502, 503, 504].includes(n) || ss.includes(t);
}, fs = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, ls = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, hs = function(n) {
  var t = n.userAgentHeader, e = t === void 0 ? "x-amz-user-agent" : t, i = n.userAgentValue, o = i === void 0 ? "" : i;
  return function(r) {
    return function(u) {
      return fs(this, void 0, void 0, function() {
        var h, s, l;
        return ls(this, function(d) {
          switch (d.label) {
            case 0:
              return o.trim().length !== 0 ? [3, 2] : [4, r(u)];
            case 1:
              return h = d.sent(), [2, h];
            case 2:
              return s = e.toLowerCase(), u.headers[s] = u.headers[s] ? "".concat(u.headers[s], " ").concat(o) : o, [4, r(u)];
            case 3:
              return l = d.sent(), [2, l];
          }
        });
      });
    };
  };
}, Or = function(n, t) {
  return function(e, i) {
    for (var o = {}, r = function(s) {
      return n(s, i);
    }, a = t.length - 1; a >= 0; a--) {
      var u = t[a], h = u(i);
      r = h(r, o);
    }
    return r(e);
  };
}, ds = Or(Wo, [hs, Zo]), xt = globalThis && globalThis.__assign || function() {
  return xt = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, xt.apply(this, arguments);
}, Vt = function(n) {
  var t, e, i = n.headers, o = n.statusCode;
  return xt(xt({}, gs(n) ? n.$metadata : {}), { httpStatusCode: o, requestId: (e = (t = i["x-amzn-requestid"]) !== null && t !== void 0 ? t : i["x-amzn-request-id"]) !== null && e !== void 0 ? e : i["x-amz-request-id"], extendedRequestId: i["x-amz-id-2"], cfId: i["x-amz-cf-id"] });
}, gs = function(n) {
  return typeof (n == null ? void 0 : n.$metadata) == "object";
}, kr = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, Mr = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ps = globalThis && globalThis.__read || function(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}, xn = function(n) {
  return kr(void 0, void 0, void 0, function() {
    var t, e, i, o, r, a, u, h, s, l;
    return Mr(this, function(d) {
      switch (d.label) {
        case 0:
          return !n || n.statusCode < 300 ? [
            2
            /*return*/
          ] : [4, Pn(n)];
        case 1:
          return t = d.sent(), e = function(v) {
            var y = ps(v.toString().split(/[\,\:]+/), 1), m = y[0];
            return m.includes("#") ? m.split("#")[1] : m;
          }, i = e((h = (u = (a = n.headers["x-amzn-errortype"]) !== null && a !== void 0 ? a : t.code) !== null && u !== void 0 ? u : t.__type) !== null && h !== void 0 ? h : "UnknownError"), o = (l = (s = t.message) !== null && s !== void 0 ? s : t.Message) !== null && l !== void 0 ? l : "Unknown error", r = new Error(o), [2, Object.assign(r, {
            name: i,
            $metadata: Vt(n)
          })];
      }
    });
  });
}, Pn = function(n) {
  return kr(void 0, void 0, void 0, function() {
    var t;
    return Mr(this, function(e) {
      switch (e.label) {
        case 0:
          if (!n.body)
            throw new Error("Missing response payload");
          return [4, n.body.json()];
        case 1:
          return t = e.sent(), [2, Object.assign(t, {
            $metadata: Vt(n)
          })];
      }
    });
  });
}, vs = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, ys = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ms = "cognito-identity", ws = function(n) {
  var t = n.region;
  return {
    url: new URL("https://cognito-identity.".concat(t, ".").concat(Ko(t)))
  };
}, Ss = function() {
  return function(n, t) {
    return function(i) {
      return vs(this, void 0, void 0, function() {
        return ys(this, function(o) {
          return i.headers["cache-control"] = "no-store", [2, n(i)];
        });
      });
    };
  };
}, Nr = Or(ds, [Ss]), Rn = {
  service: ms,
  endpointResolver: ws,
  retryDecider: is(xn),
  computeDelay: Qo,
  userAgentValue: Un()
};
Ir(function() {
  Rn.userAgentValue = Un();
});
var Br = function(n) {
  return {
    "content-type": "application/x-amz-json-1.1",
    "x-amz-target": "AWSCognitoIdentityService.".concat(n)
  };
}, Lr = function(n, t, e) {
  var i = n.url;
  return {
    headers: t,
    url: i,
    body: e,
    method: "POST"
  };
}, ft = globalThis && globalThis.__assign || function() {
  return ft = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, ft.apply(this, arguments);
}, _s = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, bs = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, jr = function(n, t, e, i) {
  return function(o, r) {
    return _s(void 0, void 0, void 0, function() {
      var a, u, h, s;
      return bs(this, function(l) {
        switch (l.label) {
          case 0:
            return a = ft(ft({}, i), o), [4, a.endpointResolver(a, r)];
          case 1:
            return u = l.sent(), [4, t(r, u)];
          case 2:
            return h = l.sent(), [4, n(h, ft({}, a))];
          case 3:
            return s = l.sent(), [4, e(s)];
          case 4:
            return [2, l.sent()];
        }
      });
    });
  };
}, As = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, Is = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Cs = function(n, t) {
  var e = Br("GetId"), i = JSON.stringify(n);
  return Lr(t, e, i);
}, Es = function(n) {
  return As(void 0, void 0, void 0, function() {
    var t, e;
    return Is(this, function(i) {
      switch (i.label) {
        case 0:
          return n.statusCode >= 300 ? [4, xn(n)] : [3, 2];
        case 1:
          throw t = i.sent(), t;
        case 2:
          return [4, Pn(n)];
        case 3:
          return e = i.sent(), [2, {
            IdentityId: e.IdentityId,
            $metadata: Vt(n)
          }];
      }
    });
  });
}, mt = jr(Nr, Cs, Es, Rn), Ts = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, Us = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, xs = function(n, t) {
  var e = Br("GetCredentialsForIdentity"), i = JSON.stringify(n);
  return Lr(t, e, i);
}, Ps = function(n) {
  return Ts(void 0, void 0, void 0, function() {
    var t, e;
    return Us(this, function(i) {
      switch (i.label) {
        case 0:
          return n.statusCode >= 300 ? [4, xn(n)] : [3, 2];
        case 1:
          throw t = i.sent(), t;
        case 2:
          return [4, Pn(n)];
        case 3:
          return e = i.sent(), [2, {
            IdentityId: e.IdentityId,
            Credentials: Rs(e.Credentials),
            $metadata: Vt(n)
          }];
      }
    });
  });
}, Rs = function(n) {
  return n === void 0 && (n = {}), {
    AccessKeyId: n.AccessKeyId,
    SecretKey: n.SecretKey,
    SessionToken: n.SessionToken,
    Expiration: new Date(n.Expiration * 1e3)
  };
}, wt = jr(Nr, xs, Ps, Rn), Pt = globalThis && globalThis.__assign || function() {
  return Pt = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Pt.apply(this, arguments);
}, se = globalThis && globalThis.__awaiter || function(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}, ae = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (e = 0)), e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, k = new Ee("Credentials"), Ds = 50 * 60 * 1e3, Fs = "CognitoIdentityId-", Os = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default", ks = function(n, t, e) {
  xe.dispatch("core", { event: n, data: t, message: e }, "Credentials", Os);
}, Ms = (
  /** @class */
  function() {
    function n(t) {
      this._gettingCredPromise = null, this._refreshHandlers = {}, this.Auth = void 0, this.configure(t), this._refreshHandlers.google = Mo.refreshGoogleToken, this._refreshHandlers.facebook = No.refreshFacebookToken;
    }
    return n.prototype.getModuleName = function() {
      return "Credentials";
    }, n.prototype.getCredSource = function() {
      return this._credentials_source;
    }, n.prototype.configure = function(t) {
      if (!t)
        return this._config || {};
      this._config = Object.assign({}, this._config, t);
      var e = this._config.refreshHandlers;
      return e && (this._refreshHandlers = Pt(Pt({}, this._refreshHandlers), e)), this._storage = this._config.storage, this._storage || (this._storage = new Dr().getStorage()), this._storageSync = Promise.resolve(), typeof this._storage.sync == "function" && (this._storageSync = this._storage.sync()), ks("credentials_configured", null, "Credentials has been configured successfully"), this._config;
    }, n.prototype.get = function() {
      return k.debug("getting credentials"), this._pickupCredentials();
    }, n.prototype._getCognitoIdentityIdStorageKey = function(t) {
      return "".concat(Fs).concat(t);
    }, n.prototype._pickupCredentials = function() {
      return k.debug("picking up credentials"), !this._gettingCredPromise || !this._gettingCredPromise.isPending() ? (k.debug("getting new cred promise"), this._gettingCredPromise = Oi(this._keepAlive())) : k.debug("getting old cred promise"), this._gettingCredPromise;
    }, n.prototype._keepAlive = function() {
      return se(this, void 0, void 0, function() {
        var t, e, i, o, r, a, u, h;
        return ae(this, function(s) {
          switch (s.label) {
            case 0:
              if (k.debug("checking if credentials exists and not expired"), t = this._credentials, t && !this._isExpired(t) && !this._isPastTTL())
                return k.debug("credentials not changed and not expired, directly return"), [2, Promise.resolve(t)];
              if (k.debug("need to get a new credential or refresh the existing one"), e = this.Auth, i = e === void 0 ? Ot.Auth : e, !i || typeof i.currentUserCredentials != "function")
                return [2, this._setCredentialsForGuest()];
              if (!(!this._isExpired(t) && this._isPastTTL()))
                return [3, 6];
              k.debug("ttl has passed but token is not yet expired"), s.label = 1;
            case 1:
              return s.trys.push([1, 5, , 6]), [4, i.currentUserPoolUser()];
            case 2:
              return o = s.sent(), [4, i.currentSession()];
            case 3:
              return r = s.sent(), a = r.refreshToken, u = new Promise(function(l, d) {
                o.refreshSession(a, function(v, y) {
                  return v ? d(v) : l(y);
                });
              }), [4, u];
            case 4:
              return s.sent(), [3, 6];
            case 5:
              return h = s.sent(), k.debug("Error attempting to refreshing the session", h), [3, 6];
            case 6:
              return [2, i.currentUserCredentials()];
          }
        });
      });
    }, n.prototype.refreshFederatedToken = function(t) {
      k.debug("Getting federated credentials");
      var e = t.provider, i = t.user, o = t.token, r = t.identity_id, a = t.expires_at;
      a = new Date(a).getFullYear() === 1970 ? a * 1e3 : a;
      var u = this;
      return k.debug("checking if federated jwt token expired"), a > (/* @__PURE__ */ new Date()).getTime() ? (k.debug("token not expired"), this._setCredentialsFromFederation({
        provider: e,
        token: o,
        user: i,
        identity_id: r,
        expires_at: a
      })) : u._refreshHandlers[e] && typeof u._refreshHandlers[e] == "function" ? (k.debug("getting refreshed jwt token from federation provider"), this._providerRefreshWithRetry({
        refreshHandler: u._refreshHandlers[e],
        provider: e,
        user: i
      })) : (k.debug("no refresh handler for provider:", e), this.clear(), Promise.reject("no refresh handler for provider"));
    }, n.prototype._providerRefreshWithRetry = function(t) {
      var e = this, i = t.refreshHandler, o = t.provider, r = t.user, a = 10 * 1e3;
      return ji(i, [], a).then(function(u) {
        return k.debug("refresh federated token sucessfully", u), e._setCredentialsFromFederation({
          provider: o,
          token: u.token,
          user: r,
          identity_id: u.identity_id,
          expires_at: u.expires_at
        });
      }).catch(function(u) {
        var h = typeof u == "string" && u.toLowerCase().lastIndexOf("network error", u.length) === 0;
        return h || e.clear(), k.debug("refresh federated token failed", u), Promise.reject("refreshing federation token failed: " + u);
      });
    }, n.prototype._isExpired = function(t) {
      if (!t)
        return k.debug("no credentials for expiration check"), !0;
      k.debug("are these credentials expired?", t);
      var e = Date.now(), i = t.expiration;
      return i.getTime() <= e;
    }, n.prototype._isPastTTL = function() {
      return this._nextCredentialsRefresh <= Date.now();
    }, n.prototype._setCredentialsForGuest = function() {
      var t;
      return se(this, void 0, void 0, function() {
        var e, i, o, r, a, u, h, s, l, d, v = this;
        return ae(this, function(y) {
          switch (y.label) {
            case 0:
              return k.debug("setting credentials for guest"), !((t = this._config) === null || t === void 0) && t.identityPoolId || (this._config = Object.assign({}, this._config, Rr(this._config || {}).Auth)), e = this._config, i = e.identityPoolId, o = e.region, r = e.mandatorySignIn, a = e.identityPoolRegion, r ? [2, Promise.reject("cannot get guest credentials when mandatory signin enabled")] : i ? !a && !o ? (k.debug("region is not configured for getting the credentials"), [2, Promise.reject("region is not configured for getting the credentials")]) : (h = this, [4, this._getGuestIdentityId()]) : (k.debug("No Cognito Identity pool provided for unauthenticated access"), [2, Promise.reject("No Cognito Identity pool provided for unauthenticated access")]);
            case 1:
              return u = h._identityId = y.sent(), s = { region: a ?? o }, l = function() {
                return se(v, void 0, void 0, function() {
                  var m, S;
                  return ae(this, function(b) {
                    switch (b.label) {
                      case 0:
                        return u ? [3, 2] : [4, mt(s, {
                          IdentityPoolId: i
                        })];
                      case 1:
                        m = b.sent().IdentityId, this._identityId = m, b.label = 2;
                      case 2:
                        return [4, wt(s, {
                          IdentityId: this._identityId
                        })];
                      case 3:
                        return S = b.sent().Credentials, [2, {
                          identityId: this._identityId,
                          accessKeyId: S.AccessKeyId,
                          secretAccessKey: S.SecretKey,
                          sessionToken: S.SessionToken,
                          expiration: S.Expiration
                        }];
                    }
                  });
                });
              }, d = l().catch(function(m) {
                return se(v, void 0, void 0, function() {
                  return ae(this, function(S) {
                    throw m;
                  });
                });
              }), [2, this._loadCredentials(d, "guest", !1, null).then(function(m) {
                return m;
              }).catch(function(m) {
                return se(v, void 0, void 0, function() {
                  var S, b = this;
                  return ae(this, function(E) {
                    switch (E.label) {
                      case 0:
                        return m.name === "ResourceNotFoundException" && m.message === "Identity '".concat(u, "' not found.") ? (k.debug("Failed to load guest credentials"), [4, this._removeGuestIdentityId()]) : [3, 2];
                      case 1:
                        return E.sent(), S = function() {
                          return se(b, void 0, void 0, function() {
                            var _, T;
                            return ae(this, function(x) {
                              switch (x.label) {
                                case 0:
                                  return [4, mt(s, {
                                    IdentityPoolId: i
                                  })];
                                case 1:
                                  return _ = x.sent().IdentityId, this._identityId = _, [4, wt(s, {
                                    IdentityId: _
                                  })];
                                case 2:
                                  return T = x.sent().Credentials, [2, {
                                    identityId: _,
                                    accessKeyId: T.AccessKeyId,
                                    secretAccessKey: T.SecretKey,
                                    sessionToken: T.SessionToken,
                                    expiration: T.Expiration
                                  }];
                              }
                            });
                          });
                        }, d = S().catch(function(_) {
                          return se(b, void 0, void 0, function() {
                            return ae(this, function(T) {
                              throw _;
                            });
                          });
                        }), [2, this._loadCredentials(d, "guest", !1, null)];
                      case 2:
                        return [2, m];
                    }
                  });
                });
              })];
          }
        });
      });
    }, n.prototype._setCredentialsFromFederation = function(t) {
      var e = this, i = t.provider, o = t.token, r = t.identity_id, a = {
        google: "accounts.google.com",
        facebook: "graph.facebook.com",
        amazon: "www.amazon.com",
        developer: "cognito-identity.amazonaws.com"
      }, u = a[i] || i;
      if (!u)
        return Promise.reject("You must specify a federated provider");
      var h = {};
      h[u] = o;
      var s = this._config, l = s.identityPoolId, d = s.region, v = s.identityPoolRegion;
      if (!l)
        return k.debug("No Cognito Federated Identity pool provided"), Promise.reject("No Cognito Federated Identity pool provided");
      if (!v && !d)
        return k.debug("region is not configured for getting the credentials"), Promise.reject("region is not configured for getting the credentials");
      var y = { region: v ?? d }, m = function() {
        return se(e, void 0, void 0, function() {
          var b, E;
          return ae(this, function(_) {
            switch (_.label) {
              case 0:
                return r ? [3, 2] : [4, mt(y, {
                  IdentityPoolId: l,
                  Logins: h
                })];
              case 1:
                b = _.sent().IdentityId, r = b, _.label = 2;
              case 2:
                return [4, wt(y, {
                  IdentityId: r,
                  Logins: h
                })];
              case 3:
                return E = _.sent().Credentials, [2, {
                  identityId: r,
                  accessKeyId: E.AccessKeyId,
                  secretAccessKey: E.SecretKey,
                  sessionToken: E.SessionToken,
                  expiration: E.Expiration
                }];
            }
          });
        });
      }, S = m().catch(function(b) {
        return se(e, void 0, void 0, function() {
          return ae(this, function(E) {
            throw b;
          });
        });
      });
      return this._loadCredentials(S, "federated", !0, t);
    }, n.prototype._setCredentialsFromSession = function(t) {
      var e = this;
      k.debug("set credentials from session");
      var i = t.getIdToken().getJwtToken(), o = this._config, r = o.region, a = o.userPoolId, u = o.identityPoolId, h = o.identityPoolRegion;
      if (!u)
        return k.debug("No Cognito Federated Identity pool provided"), Promise.reject("No Cognito Federated Identity pool provided");
      if (!h && !r)
        return k.debug("region is not configured for getting the credentials"), Promise.reject("region is not configured for getting the credentials");
      var s = "cognito-idp." + r + ".amazonaws.com/" + a, l = {};
      l[s] = i;
      var d = { region: h ?? r }, v = function() {
        return se(e, void 0, void 0, function() {
          var m, S, b, E, _, T, x, D, O, N;
          return ae(this, function(M) {
            switch (M.label) {
              case 0:
                return [4, this._getGuestIdentityId()];
              case 1:
                return m = M.sent(), m ? [3, 3] : [4, mt(d, {
                  IdentityPoolId: u,
                  Logins: l
                })];
              case 2:
                b = M.sent().IdentityId, S = b, M.label = 3;
              case 3:
                return [4, wt(d, {
                  IdentityId: m || S,
                  Logins: l
                })];
              case 4:
                return E = M.sent(), _ = E.Credentials, T = _.AccessKeyId, x = _.Expiration, D = _.SecretKey, O = _.SessionToken, N = E.IdentityId, this._identityId = N, m ? (k.debug("The guest identity ".concat(m, " has been successfully linked to the logins")), m === N && k.debug("The guest identity ".concat(m, " has become the primary identity")), [4, this._removeGuestIdentityId()]) : [3, 6];
              case 5:
                M.sent(), M.label = 6;
              case 6:
                return [2, {
                  accessKeyId: T,
                  secretAccessKey: D,
                  sessionToken: O,
                  expiration: x,
                  identityId: N
                }];
            }
          });
        });
      }, y = v().catch(function(m) {
        return se(e, void 0, void 0, function() {
          return ae(this, function(S) {
            throw m;
          });
        });
      });
      return this._loadCredentials(y, "userPool", !0, null);
    }, n.prototype._loadCredentials = function(t, e, i, o) {
      var r = this, a = this;
      return new Promise(function(u, h) {
        t.then(function(s) {
          return se(r, void 0, void 0, function() {
            var l, d, v, y, m;
            return ae(this, function(S) {
              switch (S.label) {
                case 0:
                  if (k.debug("Load credentials successfully", s), this._identityId && !s.identityId && (s.identityId = this._identityId), a._credentials = s, a._credentials.authenticated = i, a._credentials_source = e, a._nextCredentialsRefresh = (/* @__PURE__ */ new Date()).getTime() + Ds, e === "federated") {
                    l = Object.assign({ id: this._credentials.identityId }, o.user), d = o.provider, v = o.token, y = o.expires_at, m = o.identity_id;
                    try {
                      this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                        provider: d,
                        token: v,
                        user: l,
                        expires_at: y,
                        identity_id: m
                      }));
                    } catch (b) {
                      k.debug("Failed to put federated info into auth storage", b);
                    }
                  }
                  return e !== "guest" ? [3, 2] : [4, this._setGuestIdentityId(s.identityId)];
                case 1:
                  S.sent(), S.label = 2;
                case 2:
                  return u(a._credentials), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }).catch(function(s) {
          if (s) {
            k.debug("Failed to load credentials", t), k.debug("Error loading credentials", s), h(s);
            return;
          }
        });
      });
    }, n.prototype.set = function(t, e) {
      return e === "session" ? this._setCredentialsFromSession(t) : e === "federation" ? this._setCredentialsFromFederation(t) : e === "guest" ? this._setCredentialsForGuest() : (k.debug("no source specified for setting credentials"), Promise.reject("invalid source"));
    }, n.prototype.clear = function() {
      return se(this, void 0, void 0, function() {
        return ae(this, function(t) {
          return this._credentials = null, this._credentials_source = null, k.debug("removing aws-amplify-federatedInfo from storage"), this._storage.removeItem("aws-amplify-federatedInfo"), [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype._getGuestIdentityId = function() {
      return se(this, void 0, void 0, function() {
        var t, e;
        return ae(this, function(i) {
          switch (i.label) {
            case 0:
              t = this._config.identityPoolId, i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, this._storageSync];
            case 2:
              return i.sent(), [2, this._storage.getItem(this._getCognitoIdentityIdStorageKey(t))];
            case 3:
              return e = i.sent(), k.debug("Failed to get the cached guest identityId", e), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype._setGuestIdentityId = function(t) {
      return se(this, void 0, void 0, function() {
        var e, i;
        return ae(this, function(o) {
          switch (o.label) {
            case 0:
              e = this._config.identityPoolId, o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this._storageSync];
            case 2:
              return o.sent(), this._storage.setItem(this._getCognitoIdentityIdStorageKey(e), t), [3, 4];
            case 3:
              return i = o.sent(), k.debug("Failed to cache guest identityId", i), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype._removeGuestIdentityId = function() {
      return se(this, void 0, void 0, function() {
        var t;
        return ae(this, function(e) {
          return t = this._config.identityPoolId, k.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(t), " from storage")), this._storage.removeItem(this._getCognitoIdentityIdStorageKey(t)), [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype.shear = function(t) {
      return {
        accessKeyId: t.accessKeyId,
        sessionToken: t.sessionToken,
        secretAccessKey: t.secretAccessKey,
        identityId: t.identityId,
        authenticated: t.authenticated
      };
    }, n;
  }()
), Kr = new Ms(null);
Ot.register(Kr);
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var Vr = Ls, ir = js, Ns = decodeURIComponent, Bs = encodeURIComponent, St = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function Ls(n, t) {
  if (typeof n != "string")
    throw new TypeError("argument str must be a string");
  for (var e = {}, i = t || {}, o = n.split(";"), r = i.decode || Ns, a = 0; a < o.length; a++) {
    var u = o[a], h = u.indexOf("=");
    if (!(h < 0)) {
      var s = u.substring(0, h).trim();
      if (e[s] == null) {
        var l = u.substring(h + 1, u.length).trim();
        l[0] === '"' && (l = l.slice(1, -1)), e[s] = Ks(l, r);
      }
    }
  }
  return e;
}
function js(n, t, e) {
  var i = e || {}, o = i.encode || Bs;
  if (typeof o != "function")
    throw new TypeError("option encode is invalid");
  if (!St.test(n))
    throw new TypeError("argument name is invalid");
  var r = o(t);
  if (r && !St.test(r))
    throw new TypeError("argument val is invalid");
  var a = n + "=" + r;
  if (i.maxAge != null) {
    var u = i.maxAge - 0;
    if (isNaN(u) || !isFinite(u))
      throw new TypeError("option maxAge is invalid");
    a += "; Max-Age=" + Math.floor(u);
  }
  if (i.domain) {
    if (!St.test(i.domain))
      throw new TypeError("option domain is invalid");
    a += "; Domain=" + i.domain;
  }
  if (i.path) {
    if (!St.test(i.path))
      throw new TypeError("option path is invalid");
    a += "; Path=" + i.path;
  }
  if (i.expires) {
    if (typeof i.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    a += "; Expires=" + i.expires.toUTCString();
  }
  if (i.httpOnly && (a += "; HttpOnly"), i.secure && (a += "; Secure"), i.sameSite) {
    var h = typeof i.sameSite == "string" ? i.sameSite.toLowerCase() : i.sameSite;
    switch (h) {
      case !0:
        a += "; SameSite=Strict";
        break;
      case "lax":
        a += "; SameSite=Lax";
        break;
      case "strict":
        a += "; SameSite=Strict";
        break;
      case "none":
        a += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return a;
}
function Ks(n, t) {
  try {
    return t(n);
  } catch {
    return n;
  }
}
function Vs() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function qs(n, t) {
  return typeof n == "string" ? Vr(n, t) : typeof n == "object" && n !== null ? n : {};
}
function Hs(n, t) {
  return typeof t > "u" && (t = !n || n[0] !== "{" && n[0] !== "[" && n[0] !== '"'), !t;
}
function or(n, t) {
  t === void 0 && (t = {});
  var e = Gs(n);
  if (Hs(e, t.doNotParse))
    try {
      return JSON.parse(e);
    } catch {
    }
  return n;
}
function Gs(n) {
  return n && n[0] === "j" && n[1] === ":" ? n.substr(2) : n;
}
var He = globalThis && globalThis.__assign || function() {
  return He = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, He.apply(this, arguments);
}, $s = (
  /** @class */
  function() {
    function n(t, e) {
      var i = this;
      this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = qs(t, e), new Promise(function() {
        i.HAS_DOCUMENT_COOKIE = Vs();
      }).catch(function() {
      });
    }
    return n.prototype._updateBrowserValues = function(t) {
      this.HAS_DOCUMENT_COOKIE && (this.cookies = Vr(document.cookie, t));
    }, n.prototype._emitChange = function(t) {
      for (var e = 0; e < this.changeListeners.length; ++e)
        this.changeListeners[e](t);
    }, n.prototype.get = function(t, e, i) {
      return e === void 0 && (e = {}), this._updateBrowserValues(i), or(this.cookies[t], e);
    }, n.prototype.getAll = function(t, e) {
      t === void 0 && (t = {}), this._updateBrowserValues(e);
      var i = {};
      for (var o in this.cookies)
        i[o] = or(this.cookies[o], t);
      return i;
    }, n.prototype.set = function(t, e, i) {
      var o;
      typeof e == "object" && (e = JSON.stringify(e)), this.cookies = He(He({}, this.cookies), (o = {}, o[t] = e, o)), this.HAS_DOCUMENT_COOKIE && (document.cookie = ir(t, e, i)), this._emitChange({ name: t, value: e, options: i });
    }, n.prototype.remove = function(t, e) {
      var i = e = He(He({}, e), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
      this.cookies = He({}, this.cookies), delete this.cookies[t], this.HAS_DOCUMENT_COOKIE && (document.cookie = ir(t, "", i)), this._emitChange({ name: t, value: void 0, options: e });
    }, n.prototype.addChangeListener = function(t) {
      this.changeListeners.push(t);
    }, n.prototype.removeChangeListener = function(t) {
      var e = this.changeListeners.indexOf(t);
      e >= 0 && this.changeListeners.splice(e, 1);
    }, n;
  }()
);
const Xt = $s;
var Rt = globalThis && globalThis.__assign || function() {
  return Rt = Object.assign || function(n) {
    for (var t, e = 1, i = arguments.length; e < i; e++) {
      t = arguments[e];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Rt.apply(this, arguments);
}, sr = Oe().isBrowser, Ws = 365 * 24 * 60 * 60 * 1e3, Ys = (
  /** @class */
  function() {
    function n(t) {
      t === void 0 && (t = {}), this.cookies = new Xt(), this.store = sr ? window.localStorage : /* @__PURE__ */ Object.create(null), this.cookies = t.req ? new Xt(decodeURIComponent(t.req.headers.cookie)) : new Xt(), Object.assign(this.store, this.cookies.getAll());
    }
    return Object.defineProperty(n.prototype, "length", {
      get: function() {
        return Object.entries(this.store).length;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.clear = function() {
      var t = this;
      Array.from(new Array(this.length)).map(function(e, i) {
        return t.key(i);
      }).forEach(function(e) {
        return t.removeItem(e);
      });
    }, n.prototype.getItem = function(t) {
      return this.getLocalItem(t);
    }, n.prototype.getLocalItem = function(t) {
      return Object.prototype.hasOwnProperty.call(this.store, t) ? this.store[t] : null;
    }, n.prototype.getUniversalItem = function(t) {
      return this.cookies.get(t);
    }, n.prototype.key = function(t) {
      return Object.keys(this.store)[t];
    }, n.prototype.removeItem = function(t) {
      this.removeLocalItem(t), this.removeUniversalItem(t);
    }, n.prototype.removeLocalItem = function(t) {
      delete this.store[t];
    }, n.prototype.removeUniversalItem = function(t) {
      this.cookies.remove(t, {
        path: "/"
      });
    }, n.prototype.setItem = function(t, e) {
      this.setLocalItem(t, e);
      var i = t.split(".").pop(), o = [
        "LastAuthUser",
        "accessToken",
        // refreshToken originates on the client, but SSR pages won't fail when this expires
        // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
        "refreshToken",
        // Required for CognitoUserSession
        "idToken"
        // userData is used when `Auth.currentAuthenticatedUser({ bypassCache: false })`.
        // Can be persisted to speed up calls to `Auth.currentAuthenticatedUser()`
        // 'userData',
        // Ignoring clockDrift on the server for now, but needs testing
        // 'clockDrift',
      ];
      o.includes(i ?? "") && this.setUniversalItem(t, e, {
        expires: new Date(Date.now() + Ws)
      });
    }, n.prototype.setLocalItem = function(t, e) {
      this.store[t] = e;
    }, n.prototype.setUniversalItem = function(t, e, i) {
      i === void 0 && (i = {}), this.cookies.set(t, e, Rt(Rt({}, i), {
        path: "/",
        // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
        sameSite: !0,
        // Allow unsecure requests to http://localhost:3000/ when in development.
        secure: !(sr && window.location.hostname === "localhost")
      }));
    }, n;
  }()
), Js = typeof Symbol < "u" && typeof Symbol.for == "function", vc = Js ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", zs = "x-amz-user-agent";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var hn = function(n, t) {
  return hn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, i) {
    e.__proto__ = i;
  } || function(e, i) {
    for (var o in i)
      i.hasOwnProperty(o) && (e[o] = i[o]);
  }, hn(n, t);
};
function qr(n, t) {
  hn(n, t);
  function e() {
    this.constructor = n;
  }
  n.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var ne = function() {
  return ne = Object.assign || function(t) {
    for (var e, i = 1, o = arguments.length; i < o; i++) {
      e = arguments[i];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, ne.apply(this, arguments);
};
function j(n, t, e, i) {
  function o(r) {
    return r instanceof e ? r : new e(function(a) {
      a(r);
    });
  }
  return new (e || (e = Promise))(function(r, a) {
    function u(l) {
      try {
        s(i.next(l));
      } catch (d) {
        a(d);
      }
    }
    function h(l) {
      try {
        s(i.throw(l));
      } catch (d) {
        a(d);
      }
    }
    function s(l) {
      l.done ? r(l.value) : o(l.value).then(u, h);
    }
    s((i = i.apply(n, t || [])).next());
  });
}
function K(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, i, o, r, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return h([s, l]);
    };
  }
  function h(s) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (i = 1, o && (r = s[0] & 2 ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done)
          return r;
        switch (o = 0, r && (s = [s[0] & 2, r.value]), s[0]) {
          case 0:
          case 1:
            r = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!r || s[1] > r[0] && s[1] < r[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = s;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(s);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (l) {
        s = [6, l], o = 0;
      } finally {
        i = r = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
function Fe(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var i = e.call(n), o, r = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = i.next()).done; )
      r.push(o.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      o && !o.done && (e = i.return) && e.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return r;
}
var Dt;
(function(n) {
  n.Cognito = "COGNITO", n.Google = "Google", n.Facebook = "Facebook", n.Amazon = "LoginWithAmazon", n.Apple = "SignInWithApple";
})(Dt || (Dt = {}));
function Qt(n) {
  var t = ["provider"];
  return n && !!t.find(function(e) {
    return n.hasOwnProperty(e);
  });
}
function Zs(n) {
  var t = ["customProvider"];
  return n && !!t.find(function(e) {
    return n.hasOwnProperty(e);
  });
}
function Xs(n) {
  var t = ["customState"];
  return n && !!t.find(function(e) {
    return n.hasOwnProperty(e);
  });
}
function $e(n) {
  return n.redirectSignIn !== void 0;
}
var V;
(function(n) {
  n.NoConfig = "noConfig", n.MissingAuthConfig = "missingAuthConfig", n.EmptyUsername = "emptyUsername", n.InvalidUsername = "invalidUsername", n.EmptyPassword = "emptyPassword", n.EmptyCode = "emptyCode", n.SignUpError = "signUpError", n.NoMFA = "noMFA", n.InvalidMFA = "invalidMFA", n.EmptyChallengeResponse = "emptyChallengeResponse", n.NoUserSession = "noUserSession", n.Default = "default", n.DeviceConfig = "deviceConfig", n.NetworkError = "networkError", n.AutoSignInError = "autoSignInError";
})(V || (V = {}));
function Qs(n) {
  return !!n.username;
}
var ar;
(function(n) {
  n.API_KEY = "API_KEY", n.AWS_IAM = "AWS_IAM", n.OPENID_CONNECT = "OPENID_CONNECT", n.AMAZON_COGNITO_USER_POOLS = "AMAZON_COGNITO_USER_POOLS", n.AWS_LAMBDA = "AWS_LAMBDA";
})(ar || (ar = {}));
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var ur = /* @__PURE__ */ function() {
  function n(e) {
    var i = e || {}, o = i.ValidationData, r = i.Username, a = i.Password, u = i.AuthParameters, h = i.ClientMetadata;
    this.validationData = o || {}, this.authParameters = u || {}, this.clientMetadata = h || {}, this.username = r, this.password = a;
  }
  var t = n.prototype;
  return t.getUsername = function() {
    return this.username;
  }, t.getPassword = function() {
    return this.password;
  }, t.getValidationData = function() {
    return this.validationData;
  }, t.getAuthParameters = function() {
    return this.authParameters;
  }, t.getClientMetadata = function() {
    return this.clientMetadata;
  }, n;
}(), G = {}, qt = {};
qt.byteLength = na;
qt.toByteArray = ia;
qt.fromByteArray = aa;
var Re = [], me = [], ea = typeof Uint8Array < "u" ? Uint8Array : Array, en = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ze = 0, ta = en.length; Ze < ta; ++Ze)
  Re[Ze] = en[Ze], me[en.charCodeAt(Ze)] = Ze;
me["-".charCodeAt(0)] = 62;
me["_".charCodeAt(0)] = 63;
function Hr(n) {
  var t = n.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var e = n.indexOf("=");
  e === -1 && (e = t);
  var i = e === t ? 0 : 4 - e % 4;
  return [e, i];
}
function na(n) {
  var t = Hr(n), e = t[0], i = t[1];
  return (e + i) * 3 / 4 - i;
}
function ra(n, t, e) {
  return (t + e) * 3 / 4 - e;
}
function ia(n) {
  var t, e = Hr(n), i = e[0], o = e[1], r = new ea(ra(n, i, o)), a = 0, u = o > 0 ? i - 4 : i, h;
  for (h = 0; h < u; h += 4)
    t = me[n.charCodeAt(h)] << 18 | me[n.charCodeAt(h + 1)] << 12 | me[n.charCodeAt(h + 2)] << 6 | me[n.charCodeAt(h + 3)], r[a++] = t >> 16 & 255, r[a++] = t >> 8 & 255, r[a++] = t & 255;
  return o === 2 && (t = me[n.charCodeAt(h)] << 2 | me[n.charCodeAt(h + 1)] >> 4, r[a++] = t & 255), o === 1 && (t = me[n.charCodeAt(h)] << 10 | me[n.charCodeAt(h + 1)] << 4 | me[n.charCodeAt(h + 2)] >> 2, r[a++] = t >> 8 & 255, r[a++] = t & 255), r;
}
function oa(n) {
  return Re[n >> 18 & 63] + Re[n >> 12 & 63] + Re[n >> 6 & 63] + Re[n & 63];
}
function sa(n, t, e) {
  for (var i, o = [], r = t; r < e; r += 3)
    i = (n[r] << 16 & 16711680) + (n[r + 1] << 8 & 65280) + (n[r + 2] & 255), o.push(oa(i));
  return o.join("");
}
function aa(n) {
  for (var t, e = n.length, i = e % 3, o = [], r = 16383, a = 0, u = e - i; a < u; a += r)
    o.push(sa(n, a, a + r > u ? u : a + r));
  return i === 1 ? (t = n[e - 1], o.push(
    Re[t >> 2] + Re[t << 4 & 63] + "=="
  )) : i === 2 && (t = (n[e - 2] << 8) + n[e - 1], o.push(
    Re[t >> 10] + Re[t >> 4 & 63] + Re[t << 2 & 63] + "="
  )), o.join("");
}
var Dn = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Dn.read = function(n, t, e, i, o) {
  var r, a, u = o * 8 - i - 1, h = (1 << u) - 1, s = h >> 1, l = -7, d = e ? o - 1 : 0, v = e ? -1 : 1, y = n[t + d];
  for (d += v, r = y & (1 << -l) - 1, y >>= -l, l += u; l > 0; r = r * 256 + n[t + d], d += v, l -= 8)
    ;
  for (a = r & (1 << -l) - 1, r >>= -l, l += i; l > 0; a = a * 256 + n[t + d], d += v, l -= 8)
    ;
  if (r === 0)
    r = 1 - s;
  else {
    if (r === h)
      return a ? NaN : (y ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, i), r = r - s;
  }
  return (y ? -1 : 1) * a * Math.pow(2, r - i);
};
Dn.write = function(n, t, e, i, o, r) {
  var a, u, h, s = r * 8 - o - 1, l = (1 << s) - 1, d = l >> 1, v = o === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = i ? 0 : r - 1, m = i ? 1 : -1, S = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (u = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (h = Math.pow(2, -a)) < 1 && (a--, h *= 2), a + d >= 1 ? t += v / h : t += v * Math.pow(2, 1 - d), t * h >= 2 && (a++, h /= 2), a + d >= l ? (u = 0, a = l) : a + d >= 1 ? (u = (t * h - 1) * Math.pow(2, o), a = a + d) : (u = t * Math.pow(2, d - 1) * Math.pow(2, o), a = 0)); o >= 8; n[e + y] = u & 255, y += m, u /= 256, o -= 8)
    ;
  for (a = a << o | u, s += o; s > 0; n[e + y] = a & 255, y += m, a /= 256, s -= 8)
    ;
  n[e + y - m] |= S * 128;
};
var ua = {}.toString, ca = Array.isArray || function(n) {
  return ua.call(n) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
(function(n) {
  var t = qt, e = Dn, i = ca;
  n.Buffer = u, n.SlowBuffer = E, n.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = at.TYPED_ARRAY_SUPPORT !== void 0 ? at.TYPED_ARRAY_SUPPORT : o(), n.kMaxLength = r();
  function o() {
    try {
      var g = new Uint8Array(1);
      return g.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
        return 42;
      } }, g.foo() === 42 && // typed array instances can be augmented
      typeof g.subarray == "function" && // chrome 9-10 lack `subarray`
      g.subarray(1, 1).byteLength === 0;
    } catch {
      return !1;
    }
  }
  function r() {
    return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function a(g, c) {
    if (r() < c)
      throw new RangeError("Invalid typed array length");
    return u.TYPED_ARRAY_SUPPORT ? (g = new Uint8Array(c), g.__proto__ = u.prototype) : (g === null && (g = new u(c)), g.length = c), g;
  }
  function u(g, c, f) {
    if (!u.TYPED_ARRAY_SUPPORT && !(this instanceof u))
      return new u(g, c, f);
    if (typeof g == "number") {
      if (typeof c == "string")
        throw new Error(
          "If encoding is specified then the first argument must be a string"
        );
      return d(this, g);
    }
    return h(this, g, c, f);
  }
  u.poolSize = 8192, u._augment = function(g) {
    return g.__proto__ = u.prototype, g;
  };
  function h(g, c, f, p) {
    if (typeof c == "number")
      throw new TypeError('"value" argument must not be a number');
    return typeof ArrayBuffer < "u" && c instanceof ArrayBuffer ? m(g, c, f, p) : typeof c == "string" ? v(g, c, f) : S(g, c);
  }
  u.from = function(g, c, f) {
    return h(null, g, c, f);
  }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
    value: null,
    configurable: !0
  }));
  function s(g) {
    if (typeof g != "number")
      throw new TypeError('"size" argument must be a number');
    if (g < 0)
      throw new RangeError('"size" argument must not be negative');
  }
  function l(g, c, f, p) {
    return s(c), c <= 0 ? a(g, c) : f !== void 0 ? typeof p == "string" ? a(g, c).fill(f, p) : a(g, c).fill(f) : a(g, c);
  }
  u.alloc = function(g, c, f) {
    return l(null, g, c, f);
  };
  function d(g, c) {
    if (s(c), g = a(g, c < 0 ? 0 : b(c) | 0), !u.TYPED_ARRAY_SUPPORT)
      for (var f = 0; f < c; ++f)
        g[f] = 0;
    return g;
  }
  u.allocUnsafe = function(g) {
    return d(null, g);
  }, u.allocUnsafeSlow = function(g) {
    return d(null, g);
  };
  function v(g, c, f) {
    if ((typeof f != "string" || f === "") && (f = "utf8"), !u.isEncoding(f))
      throw new TypeError('"encoding" must be a valid string encoding');
    var p = _(c, f) | 0;
    g = a(g, p);
    var w = g.write(c, f);
    return w !== p && (g = g.slice(0, w)), g;
  }
  function y(g, c) {
    var f = c.length < 0 ? 0 : b(c.length) | 0;
    g = a(g, f);
    for (var p = 0; p < f; p += 1)
      g[p] = c[p] & 255;
    return g;
  }
  function m(g, c, f, p) {
    if (c.byteLength, f < 0 || c.byteLength < f)
      throw new RangeError("'offset' is out of bounds");
    if (c.byteLength < f + (p || 0))
      throw new RangeError("'length' is out of bounds");
    return f === void 0 && p === void 0 ? c = new Uint8Array(c) : p === void 0 ? c = new Uint8Array(c, f) : c = new Uint8Array(c, f, p), u.TYPED_ARRAY_SUPPORT ? (g = c, g.__proto__ = u.prototype) : g = y(g, c), g;
  }
  function S(g, c) {
    if (u.isBuffer(c)) {
      var f = b(c.length) | 0;
      return g = a(g, f), g.length === 0 || c.copy(g, 0, 0, f), g;
    }
    if (c) {
      if (typeof ArrayBuffer < "u" && c.buffer instanceof ArrayBuffer || "length" in c)
        return typeof c.length != "number" || zr(c.length) ? a(g, 0) : y(g, c);
      if (c.type === "Buffer" && i(c.data))
        return y(g, c.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
  }
  function b(g) {
    if (g >= r())
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + r().toString(16) + " bytes");
    return g | 0;
  }
  function E(g) {
    return +g != g && (g = 0), u.alloc(+g);
  }
  u.isBuffer = function(c) {
    return !!(c != null && c._isBuffer);
  }, u.compare = function(c, f) {
    if (!u.isBuffer(c) || !u.isBuffer(f))
      throw new TypeError("Arguments must be Buffers");
    if (c === f)
      return 0;
    for (var p = c.length, w = f.length, A = 0, C = Math.min(p, w); A < C; ++A)
      if (c[A] !== f[A]) {
        p = c[A], w = f[A];
        break;
      }
    return p < w ? -1 : w < p ? 1 : 0;
  }, u.isEncoding = function(c) {
    switch (String(c).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(c, f) {
    if (!i(c))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (c.length === 0)
      return u.alloc(0);
    var p;
    if (f === void 0)
      for (f = 0, p = 0; p < c.length; ++p)
        f += c[p].length;
    var w = u.allocUnsafe(f), A = 0;
    for (p = 0; p < c.length; ++p) {
      var C = c[p];
      if (!u.isBuffer(C))
        throw new TypeError('"list" argument must be an Array of Buffers');
      C.copy(w, A), A += C.length;
    }
    return w;
  };
  function _(g, c) {
    if (u.isBuffer(g))
      return g.length;
    if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(g) || g instanceof ArrayBuffer))
      return g.byteLength;
    typeof g != "string" && (g = "" + g);
    var f = g.length;
    if (f === 0)
      return 0;
    for (var p = !1; ; )
      switch (c) {
        case "ascii":
        case "latin1":
        case "binary":
          return f;
        case "utf8":
        case "utf-8":
        case void 0:
          return ee(g).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return f * 2;
        case "hex":
          return f >>> 1;
        case "base64":
          return Ue(g).length;
        default:
          if (p)
            return ee(g).length;
          c = ("" + c).toLowerCase(), p = !0;
      }
  }
  u.byteLength = _;
  function T(g, c, f) {
    var p = !1;
    if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((f === void 0 || f > this.length) && (f = this.length), f <= 0) || (f >>>= 0, c >>>= 0, f <= c))
      return "";
    for (g || (g = "utf8"); ; )
      switch (g) {
        case "hex":
          return $t(this, c, f);
        case "utf8":
        case "utf-8":
          return pe(this, c, f);
        case "ascii":
          return Ye(this, c, f);
        case "latin1":
        case "binary":
          return Gt(this, c, f);
        case "base64":
          return ce(this, c, f);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return R(this, c, f);
        default:
          if (p)
            throw new TypeError("Unknown encoding: " + g);
          g = (g + "").toLowerCase(), p = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function x(g, c, f) {
    var p = g[c];
    g[c] = g[f], g[f] = p;
  }
  u.prototype.swap16 = function() {
    var c = this.length;
    if (c % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var f = 0; f < c; f += 2)
      x(this, f, f + 1);
    return this;
  }, u.prototype.swap32 = function() {
    var c = this.length;
    if (c % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var f = 0; f < c; f += 4)
      x(this, f, f + 3), x(this, f + 1, f + 2);
    return this;
  }, u.prototype.swap64 = function() {
    var c = this.length;
    if (c % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var f = 0; f < c; f += 8)
      x(this, f, f + 7), x(this, f + 1, f + 6), x(this, f + 2, f + 5), x(this, f + 3, f + 4);
    return this;
  }, u.prototype.toString = function() {
    var c = this.length | 0;
    return c === 0 ? "" : arguments.length === 0 ? pe(this, 0, c) : T.apply(this, arguments);
  }, u.prototype.equals = function(c) {
    if (!u.isBuffer(c))
      throw new TypeError("Argument must be a Buffer");
    return this === c ? !0 : u.compare(this, c) === 0;
  }, u.prototype.inspect = function() {
    var c = "", f = n.INSPECT_MAX_BYTES;
    return this.length > 0 && (c = this.toString("hex", 0, f).match(/.{2}/g).join(" "), this.length > f && (c += " ... ")), "<Buffer " + c + ">";
  }, u.prototype.compare = function(c, f, p, w, A) {
    if (!u.isBuffer(c))
      throw new TypeError("Argument must be a Buffer");
    if (f === void 0 && (f = 0), p === void 0 && (p = c ? c.length : 0), w === void 0 && (w = 0), A === void 0 && (A = this.length), f < 0 || p > c.length || w < 0 || A > this.length)
      throw new RangeError("out of range index");
    if (w >= A && f >= p)
      return 0;
    if (w >= A)
      return -1;
    if (f >= p)
      return 1;
    if (f >>>= 0, p >>>= 0, w >>>= 0, A >>>= 0, this === c)
      return 0;
    for (var C = A - w, L = p - f, W = Math.min(C, L), Y = this.slice(w, A), oe = c.slice(f, p), J = 0; J < W; ++J)
      if (Y[J] !== oe[J]) {
        C = Y[J], L = oe[J];
        break;
      }
    return C < L ? -1 : L < C ? 1 : 0;
  };
  function D(g, c, f, p, w) {
    if (g.length === 0)
      return -1;
    if (typeof f == "string" ? (p = f, f = 0) : f > 2147483647 ? f = 2147483647 : f < -2147483648 && (f = -2147483648), f = +f, isNaN(f) && (f = w ? 0 : g.length - 1), f < 0 && (f = g.length + f), f >= g.length) {
      if (w)
        return -1;
      f = g.length - 1;
    } else if (f < 0)
      if (w)
        f = 0;
      else
        return -1;
    if (typeof c == "string" && (c = u.from(c, p)), u.isBuffer(c))
      return c.length === 0 ? -1 : O(g, c, f, p, w);
    if (typeof c == "number")
      return c = c & 255, u.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? w ? Uint8Array.prototype.indexOf.call(g, c, f) : Uint8Array.prototype.lastIndexOf.call(g, c, f) : O(g, [c], f, p, w);
    throw new TypeError("val must be string, number or Buffer");
  }
  function O(g, c, f, p, w) {
    var A = 1, C = g.length, L = c.length;
    if (p !== void 0 && (p = String(p).toLowerCase(), p === "ucs2" || p === "ucs-2" || p === "utf16le" || p === "utf-16le")) {
      if (g.length < 2 || c.length < 2)
        return -1;
      A = 2, C /= 2, L /= 2, f /= 2;
    }
    function W(Nn, Bn) {
      return A === 1 ? Nn[Bn] : Nn.readUInt16BE(Bn * A);
    }
    var Y;
    if (w) {
      var oe = -1;
      for (Y = f; Y < C; Y++)
        if (W(g, Y) === W(c, oe === -1 ? 0 : Y - oe)) {
          if (oe === -1 && (oe = Y), Y - oe + 1 === L)
            return oe * A;
        } else
          oe !== -1 && (Y -= Y - oe), oe = -1;
    } else
      for (f + L > C && (f = C - L), Y = f; Y >= 0; Y--) {
        for (var J = !0, vt = 0; vt < L; vt++)
          if (W(g, Y + vt) !== W(c, vt)) {
            J = !1;
            break;
          }
        if (J)
          return Y;
      }
    return -1;
  }
  u.prototype.includes = function(c, f, p) {
    return this.indexOf(c, f, p) !== -1;
  }, u.prototype.indexOf = function(c, f, p) {
    return D(this, c, f, p, !0);
  }, u.prototype.lastIndexOf = function(c, f, p) {
    return D(this, c, f, p, !1);
  };
  function N(g, c, f, p) {
    f = Number(f) || 0;
    var w = g.length - f;
    p ? (p = Number(p), p > w && (p = w)) : p = w;
    var A = c.length;
    if (A % 2 !== 0)
      throw new TypeError("Invalid hex string");
    p > A / 2 && (p = A / 2);
    for (var C = 0; C < p; ++C) {
      var L = parseInt(c.substr(C * 2, 2), 16);
      if (isNaN(L))
        return C;
      g[f + C] = L;
    }
    return C;
  }
  function M(g, c, f, p) {
    return ke(ee(c, g.length - f), g, f, p);
  }
  function H(g, c, f, p) {
    return ke(de(c), g, f, p);
  }
  function re(g, c, f, p) {
    return H(g, c, f, p);
  }
  function le(g, c, f, p) {
    return ke(Ue(c), g, f, p);
  }
  function _e(g, c, f, p) {
    return ke(Te(c, g.length - f), g, f, p);
  }
  u.prototype.write = function(c, f, p, w) {
    if (f === void 0)
      w = "utf8", p = this.length, f = 0;
    else if (p === void 0 && typeof f == "string")
      w = f, p = this.length, f = 0;
    else if (isFinite(f))
      f = f | 0, isFinite(p) ? (p = p | 0, w === void 0 && (w = "utf8")) : (w = p, p = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var A = this.length - f;
    if ((p === void 0 || p > A) && (p = A), c.length > 0 && (p < 0 || f < 0) || f > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    w || (w = "utf8");
    for (var C = !1; ; )
      switch (w) {
        case "hex":
          return N(this, c, f, p);
        case "utf8":
        case "utf-8":
          return M(this, c, f, p);
        case "ascii":
          return H(this, c, f, p);
        case "latin1":
        case "binary":
          return re(this, c, f, p);
        case "base64":
          return le(this, c, f, p);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return _e(this, c, f, p);
        default:
          if (C)
            throw new TypeError("Unknown encoding: " + w);
          w = ("" + w).toLowerCase(), C = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ce(g, c, f) {
    return c === 0 && f === g.length ? t.fromByteArray(g) : t.fromByteArray(g.slice(c, f));
  }
  function pe(g, c, f) {
    f = Math.min(g.length, f);
    for (var p = [], w = c; w < f; ) {
      var A = g[w], C = null, L = A > 239 ? 4 : A > 223 ? 3 : A > 191 ? 2 : 1;
      if (w + L <= f) {
        var W, Y, oe, J;
        switch (L) {
          case 1:
            A < 128 && (C = A);
            break;
          case 2:
            W = g[w + 1], (W & 192) === 128 && (J = (A & 31) << 6 | W & 63, J > 127 && (C = J));
            break;
          case 3:
            W = g[w + 1], Y = g[w + 2], (W & 192) === 128 && (Y & 192) === 128 && (J = (A & 15) << 12 | (W & 63) << 6 | Y & 63, J > 2047 && (J < 55296 || J > 57343) && (C = J));
            break;
          case 4:
            W = g[w + 1], Y = g[w + 2], oe = g[w + 3], (W & 192) === 128 && (Y & 192) === 128 && (oe & 192) === 128 && (J = (A & 15) << 18 | (W & 63) << 12 | (Y & 63) << 6 | oe & 63, J > 65535 && J < 1114112 && (C = J));
        }
      }
      C === null ? (C = 65533, L = 1) : C > 65535 && (C -= 65536, p.push(C >>> 10 & 1023 | 55296), C = 56320 | C & 1023), p.push(C), w += L;
    }
    return be(p);
  }
  var fe = 4096;
  function be(g) {
    var c = g.length;
    if (c <= fe)
      return String.fromCharCode.apply(String, g);
    for (var f = "", p = 0; p < c; )
      f += String.fromCharCode.apply(
        String,
        g.slice(p, p += fe)
      );
    return f;
  }
  function Ye(g, c, f) {
    var p = "";
    f = Math.min(g.length, f);
    for (var w = c; w < f; ++w)
      p += String.fromCharCode(g[w] & 127);
    return p;
  }
  function Gt(g, c, f) {
    var p = "";
    f = Math.min(g.length, f);
    for (var w = c; w < f; ++w)
      p += String.fromCharCode(g[w]);
    return p;
  }
  function $t(g, c, f) {
    var p = g.length;
    (!c || c < 0) && (c = 0), (!f || f < 0 || f > p) && (f = p);
    for (var w = "", A = c; A < f; ++A)
      w += Q(g[A]);
    return w;
  }
  function R(g, c, f) {
    for (var p = g.slice(c, f), w = "", A = 0; A < p.length; A += 2)
      w += String.fromCharCode(p[A] + p[A + 1] * 256);
    return w;
  }
  u.prototype.slice = function(c, f) {
    var p = this.length;
    c = ~~c, f = f === void 0 ? p : ~~f, c < 0 ? (c += p, c < 0 && (c = 0)) : c > p && (c = p), f < 0 ? (f += p, f < 0 && (f = 0)) : f > p && (f = p), f < c && (f = c);
    var w;
    if (u.TYPED_ARRAY_SUPPORT)
      w = this.subarray(c, f), w.__proto__ = u.prototype;
    else {
      var A = f - c;
      w = new u(A, void 0);
      for (var C = 0; C < A; ++C)
        w[C] = this[C + c];
    }
    return w;
  };
  function P(g, c, f) {
    if (g % 1 !== 0 || g < 0)
      throw new RangeError("offset is not uint");
    if (g + c > f)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUIntLE = function(c, f, p) {
    c = c | 0, f = f | 0, p || P(c, f, this.length);
    for (var w = this[c], A = 1, C = 0; ++C < f && (A *= 256); )
      w += this[c + C] * A;
    return w;
  }, u.prototype.readUIntBE = function(c, f, p) {
    c = c | 0, f = f | 0, p || P(c, f, this.length);
    for (var w = this[c + --f], A = 1; f > 0 && (A *= 256); )
      w += this[c + --f] * A;
    return w;
  }, u.prototype.readUInt8 = function(c, f) {
    return f || P(c, 1, this.length), this[c];
  }, u.prototype.readUInt16LE = function(c, f) {
    return f || P(c, 2, this.length), this[c] | this[c + 1] << 8;
  }, u.prototype.readUInt16BE = function(c, f) {
    return f || P(c, 2, this.length), this[c] << 8 | this[c + 1];
  }, u.prototype.readUInt32LE = function(c, f) {
    return f || P(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
  }, u.prototype.readUInt32BE = function(c, f) {
    return f || P(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
  }, u.prototype.readIntLE = function(c, f, p) {
    c = c | 0, f = f | 0, p || P(c, f, this.length);
    for (var w = this[c], A = 1, C = 0; ++C < f && (A *= 256); )
      w += this[c + C] * A;
    return A *= 128, w >= A && (w -= Math.pow(2, 8 * f)), w;
  }, u.prototype.readIntBE = function(c, f, p) {
    c = c | 0, f = f | 0, p || P(c, f, this.length);
    for (var w = f, A = 1, C = this[c + --w]; w > 0 && (A *= 256); )
      C += this[c + --w] * A;
    return A *= 128, C >= A && (C -= Math.pow(2, 8 * f)), C;
  }, u.prototype.readInt8 = function(c, f) {
    return f || P(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
  }, u.prototype.readInt16LE = function(c, f) {
    f || P(c, 2, this.length);
    var p = this[c] | this[c + 1] << 8;
    return p & 32768 ? p | 4294901760 : p;
  }, u.prototype.readInt16BE = function(c, f) {
    f || P(c, 2, this.length);
    var p = this[c + 1] | this[c] << 8;
    return p & 32768 ? p | 4294901760 : p;
  }, u.prototype.readInt32LE = function(c, f) {
    return f || P(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
  }, u.prototype.readInt32BE = function(c, f) {
    return f || P(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
  }, u.prototype.readFloatLE = function(c, f) {
    return f || P(c, 4, this.length), e.read(this, c, !0, 23, 4);
  }, u.prototype.readFloatBE = function(c, f) {
    return f || P(c, 4, this.length), e.read(this, c, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(c, f) {
    return f || P(c, 8, this.length), e.read(this, c, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(c, f) {
    return f || P(c, 8, this.length), e.read(this, c, !1, 52, 8);
  };
  function F(g, c, f, p, w, A) {
    if (!u.isBuffer(g))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (c > w || c < A)
      throw new RangeError('"value" argument is out of bounds');
    if (f + p > g.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUIntLE = function(c, f, p, w) {
    if (c = +c, f = f | 0, p = p | 0, !w) {
      var A = Math.pow(2, 8 * p) - 1;
      F(this, c, f, p, A, 0);
    }
    var C = 1, L = 0;
    for (this[f] = c & 255; ++L < p && (C *= 256); )
      this[f + L] = c / C & 255;
    return f + p;
  }, u.prototype.writeUIntBE = function(c, f, p, w) {
    if (c = +c, f = f | 0, p = p | 0, !w) {
      var A = Math.pow(2, 8 * p) - 1;
      F(this, c, f, p, A, 0);
    }
    var C = p - 1, L = 1;
    for (this[f + C] = c & 255; --C >= 0 && (L *= 256); )
      this[f + C] = c / L & 255;
    return f + p;
  }, u.prototype.writeUInt8 = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (c = Math.floor(c)), this[f] = c & 255, f + 1;
  };
  function q(g, c, f, p) {
    c < 0 && (c = 65535 + c + 1);
    for (var w = 0, A = Math.min(g.length - f, 2); w < A; ++w)
      g[f + w] = (c & 255 << 8 * (p ? w : 1 - w)) >>> (p ? w : 1 - w) * 8;
  }
  u.prototype.writeUInt16LE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[f] = c & 255, this[f + 1] = c >>> 8) : q(this, c, f, !0), f + 2;
  }, u.prototype.writeUInt16BE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[f] = c >>> 8, this[f + 1] = c & 255) : q(this, c, f, !1), f + 2;
  };
  function $(g, c, f, p) {
    c < 0 && (c = 4294967295 + c + 1);
    for (var w = 0, A = Math.min(g.length - f, 4); w < A; ++w)
      g[f + w] = c >>> (p ? w : 3 - w) * 8 & 255;
  }
  u.prototype.writeUInt32LE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[f + 3] = c >>> 24, this[f + 2] = c >>> 16, this[f + 1] = c >>> 8, this[f] = c & 255) : $(this, c, f, !0), f + 4;
  }, u.prototype.writeUInt32BE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[f] = c >>> 24, this[f + 1] = c >>> 16, this[f + 2] = c >>> 8, this[f + 3] = c & 255) : $(this, c, f, !1), f + 4;
  }, u.prototype.writeIntLE = function(c, f, p, w) {
    if (c = +c, f = f | 0, !w) {
      var A = Math.pow(2, 8 * p - 1);
      F(this, c, f, p, A - 1, -A);
    }
    var C = 0, L = 1, W = 0;
    for (this[f] = c & 255; ++C < p && (L *= 256); )
      c < 0 && W === 0 && this[f + C - 1] !== 0 && (W = 1), this[f + C] = (c / L >> 0) - W & 255;
    return f + p;
  }, u.prototype.writeIntBE = function(c, f, p, w) {
    if (c = +c, f = f | 0, !w) {
      var A = Math.pow(2, 8 * p - 1);
      F(this, c, f, p, A - 1, -A);
    }
    var C = p - 1, L = 1, W = 0;
    for (this[f + C] = c & 255; --C >= 0 && (L *= 256); )
      c < 0 && W === 0 && this[f + C + 1] !== 0 && (W = 1), this[f + C] = (c / L >> 0) - W & 255;
    return f + p;
  }, u.prototype.writeInt8 = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (c = Math.floor(c)), c < 0 && (c = 255 + c + 1), this[f] = c & 255, f + 1;
  }, u.prototype.writeInt16LE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[f] = c & 255, this[f + 1] = c >>> 8) : q(this, c, f, !0), f + 2;
  }, u.prototype.writeInt16BE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[f] = c >>> 8, this[f + 1] = c & 255) : q(this, c, f, !1), f + 2;
  }, u.prototype.writeInt32LE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[f] = c & 255, this[f + 1] = c >>> 8, this[f + 2] = c >>> 16, this[f + 3] = c >>> 24) : $(this, c, f, !0), f + 4;
  }, u.prototype.writeInt32BE = function(c, f, p) {
    return c = +c, f = f | 0, p || F(this, c, f, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), u.TYPED_ARRAY_SUPPORT ? (this[f] = c >>> 24, this[f + 1] = c >>> 16, this[f + 2] = c >>> 8, this[f + 3] = c & 255) : $(this, c, f, !1), f + 4;
  };
  function X(g, c, f, p, w, A) {
    if (f + p > g.length)
      throw new RangeError("Index out of range");
    if (f < 0)
      throw new RangeError("Index out of range");
  }
  function Z(g, c, f, p, w) {
    return w || X(g, c, f, 4), e.write(g, c, f, p, 23, 4), f + 4;
  }
  u.prototype.writeFloatLE = function(c, f, p) {
    return Z(this, c, f, !0, p);
  }, u.prototype.writeFloatBE = function(c, f, p) {
    return Z(this, c, f, !1, p);
  };
  function ie(g, c, f, p, w) {
    return w || X(g, c, f, 8), e.write(g, c, f, p, 52, 8), f + 8;
  }
  u.prototype.writeDoubleLE = function(c, f, p) {
    return ie(this, c, f, !0, p);
  }, u.prototype.writeDoubleBE = function(c, f, p) {
    return ie(this, c, f, !1, p);
  }, u.prototype.copy = function(c, f, p, w) {
    if (p || (p = 0), !w && w !== 0 && (w = this.length), f >= c.length && (f = c.length), f || (f = 0), w > 0 && w < p && (w = p), w === p || c.length === 0 || this.length === 0)
      return 0;
    if (f < 0)
      throw new RangeError("targetStart out of bounds");
    if (p < 0 || p >= this.length)
      throw new RangeError("sourceStart out of bounds");
    if (w < 0)
      throw new RangeError("sourceEnd out of bounds");
    w > this.length && (w = this.length), c.length - f < w - p && (w = c.length - f + p);
    var A = w - p, C;
    if (this === c && p < f && f < w)
      for (C = A - 1; C >= 0; --C)
        c[C + f] = this[C + p];
    else if (A < 1e3 || !u.TYPED_ARRAY_SUPPORT)
      for (C = 0; C < A; ++C)
        c[C + f] = this[C + p];
    else
      Uint8Array.prototype.set.call(
        c,
        this.subarray(p, p + A),
        f
      );
    return A;
  }, u.prototype.fill = function(c, f, p, w) {
    if (typeof c == "string") {
      if (typeof f == "string" ? (w = f, f = 0, p = this.length) : typeof p == "string" && (w = p, p = this.length), c.length === 1) {
        var A = c.charCodeAt(0);
        A < 256 && (c = A);
      }
      if (w !== void 0 && typeof w != "string")
        throw new TypeError("encoding must be a string");
      if (typeof w == "string" && !u.isEncoding(w))
        throw new TypeError("Unknown encoding: " + w);
    } else
      typeof c == "number" && (c = c & 255);
    if (f < 0 || this.length < f || this.length < p)
      throw new RangeError("Out of range index");
    if (p <= f)
      return this;
    f = f >>> 0, p = p === void 0 ? this.length : p >>> 0, c || (c = 0);
    var C;
    if (typeof c == "number")
      for (C = f; C < p; ++C)
        this[C] = c;
    else {
      var L = u.isBuffer(c) ? c : ee(new u(c, w).toString()), W = L.length;
      for (C = 0; C < p - f; ++C)
        this[C + f] = L[C % W];
    }
    return this;
  };
  var he = /[^+\/0-9A-Za-z-_]/g;
  function ve(g) {
    if (g = Ae(g).replace(he, ""), g.length < 2)
      return "";
    for (; g.length % 4 !== 0; )
      g = g + "=";
    return g;
  }
  function Ae(g) {
    return g.trim ? g.trim() : g.replace(/^\s+|\s+$/g, "");
  }
  function Q(g) {
    return g < 16 ? "0" + g.toString(16) : g.toString(16);
  }
  function ee(g, c) {
    c = c || 1 / 0;
    for (var f, p = g.length, w = null, A = [], C = 0; C < p; ++C) {
      if (f = g.charCodeAt(C), f > 55295 && f < 57344) {
        if (!w) {
          if (f > 56319) {
            (c -= 3) > -1 && A.push(239, 191, 189);
            continue;
          } else if (C + 1 === p) {
            (c -= 3) > -1 && A.push(239, 191, 189);
            continue;
          }
          w = f;
          continue;
        }
        if (f < 56320) {
          (c -= 3) > -1 && A.push(239, 191, 189), w = f;
          continue;
        }
        f = (w - 55296 << 10 | f - 56320) + 65536;
      } else
        w && (c -= 3) > -1 && A.push(239, 191, 189);
      if (w = null, f < 128) {
        if ((c -= 1) < 0)
          break;
        A.push(f);
      } else if (f < 2048) {
        if ((c -= 2) < 0)
          break;
        A.push(
          f >> 6 | 192,
          f & 63 | 128
        );
      } else if (f < 65536) {
        if ((c -= 3) < 0)
          break;
        A.push(
          f >> 12 | 224,
          f >> 6 & 63 | 128,
          f & 63 | 128
        );
      } else if (f < 1114112) {
        if ((c -= 4) < 0)
          break;
        A.push(
          f >> 18 | 240,
          f >> 12 & 63 | 128,
          f >> 6 & 63 | 128,
          f & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return A;
  }
  function de(g) {
    for (var c = [], f = 0; f < g.length; ++f)
      c.push(g.charCodeAt(f) & 255);
    return c;
  }
  function Te(g, c) {
    for (var f, p, w, A = [], C = 0; C < g.length && !((c -= 2) < 0); ++C)
      f = g.charCodeAt(C), p = f >> 8, w = f % 256, A.push(w), A.push(p);
    return A;
  }
  function Ue(g) {
    return t.toByteArray(ve(g));
  }
  function ke(g, c, f, p) {
    for (var w = 0; w < p && !(w + f >= c.length || w >= g.length); ++w)
      c[w + f] = g[w];
    return w;
  }
  function zr(g) {
    return g !== g;
  }
})(G);
var we;
typeof window < "u" && window.crypto && (we = window.crypto);
!we && typeof window < "u" && window.msCrypto && (we = window.msCrypto);
!we && typeof global < "u" && global.crypto && (we = global.crypto);
if (!we && typeof require == "function")
  try {
    we = require("crypto");
  } catch {
  }
function fa() {
  if (we) {
    if (typeof we.getRandomValues == "function")
      try {
        return we.getRandomValues(new Uint32Array(1))[0];
      } catch {
      }
    if (typeof we.randomBytes == "function")
      try {
        return we.randomBytes(4).readInt32LE();
      } catch {
      }
  }
  throw new Error("Native crypto module could not be used to get secure random number.");
}
function la(n) {
  for (var t = n.words, e = n.sigBytes, i = [], o = 0; o < e; o++) {
    var r = t[o >>> 2] >>> 24 - o % 4 * 8 & 255;
    i.push((r >>> 4).toString(16)), i.push((r & 15).toString(16));
  }
  return i.join("");
}
var ha = /* @__PURE__ */ function() {
  function n(e, i) {
    e = this.words = e || [], i != null ? this.sigBytes = i : this.sigBytes = e.length * 4;
  }
  var t = n.prototype;
  return t.random = function(i) {
    for (var o = [], r = 0; r < i; r += 4)
      o.push(fa());
    return new n(o, i);
  }, t.toString = function() {
    return la(this);
  }, n;
}();
function U(n, t) {
  n != null && this.fromString(n, t);
}
function ue() {
  return new U(null);
}
var je, da = 244837814094590, cr = (da & 16777215) == 15715070;
function ga(n, t, e, i, o, r) {
  for (; --r >= 0; ) {
    var a = t * this[n++] + e[i] + o;
    o = Math.floor(a / 67108864), e[i++] = a & 67108863;
  }
  return o;
}
function pa(n, t, e, i, o, r) {
  for (var a = t & 32767, u = t >> 15; --r >= 0; ) {
    var h = this[n] & 32767, s = this[n++] >> 15, l = u * h + s * a;
    h = a * h + ((l & 32767) << 15) + e[i] + (o & 1073741823), o = (h >>> 30) + (l >>> 15) + u * s + (o >>> 30), e[i++] = h & 1073741823;
  }
  return o;
}
function va(n, t, e, i, o, r) {
  for (var a = t & 16383, u = t >> 14; --r >= 0; ) {
    var h = this[n] & 16383, s = this[n++] >> 14, l = u * h + s * a;
    h = a * h + ((l & 16383) << 14) + e[i] + o, o = (h >> 28) + (l >> 14) + u * s, e[i++] = h & 268435455;
  }
  return o;
}
var fr = typeof navigator < "u";
fr && cr && navigator.appName == "Microsoft Internet Explorer" ? (U.prototype.am = pa, je = 30) : fr && cr && navigator.appName != "Netscape" ? (U.prototype.am = ga, je = 26) : (U.prototype.am = va, je = 28);
U.prototype.DB = je;
U.prototype.DM = (1 << je) - 1;
U.prototype.DV = 1 << je;
var Fn = 52;
U.prototype.FV = Math.pow(2, Fn);
U.prototype.F1 = Fn - je;
U.prototype.F2 = 2 * je - Fn;
var ya = "0123456789abcdefghijklmnopqrstuvwxyz", Ht = new Array(), rt, Se;
rt = "0".charCodeAt(0);
for (Se = 0; Se <= 9; ++Se)
  Ht[rt++] = Se;
rt = "a".charCodeAt(0);
for (Se = 10; Se < 36; ++Se)
  Ht[rt++] = Se;
rt = "A".charCodeAt(0);
for (Se = 10; Se < 36; ++Se)
  Ht[rt++] = Se;
function lr(n) {
  return ya.charAt(n);
}
function ma(n, t) {
  var e = Ht[n.charCodeAt(t)];
  return e ?? -1;
}
function wa(n) {
  for (var t = this.t - 1; t >= 0; --t)
    n[t] = this[t];
  n.t = this.t, n.s = this.s;
}
function Sa(n) {
  this.t = 1, this.s = n < 0 ? -1 : 0, n > 0 ? this[0] = n : n < -1 ? this[0] = n + this.DV : this.t = 0;
}
function On(n) {
  var t = ue();
  return t.fromInt(n), t;
}
function _a(n, t) {
  var e;
  if (t == 16)
    e = 4;
  else if (t == 8)
    e = 3;
  else if (t == 2)
    e = 1;
  else if (t == 32)
    e = 5;
  else if (t == 4)
    e = 2;
  else
    throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0, this.s = 0;
  for (var i = n.length, o = !1, r = 0; --i >= 0; ) {
    var a = ma(n, i);
    if (a < 0) {
      n.charAt(i) == "-" && (o = !0);
      continue;
    }
    o = !1, r == 0 ? this[this.t++] = a : r + e > this.DB ? (this[this.t - 1] |= (a & (1 << this.DB - r) - 1) << r, this[this.t++] = a >> this.DB - r) : this[this.t - 1] |= a << r, r += e, r >= this.DB && (r -= this.DB);
  }
  this.clamp(), o && U.ZERO.subTo(this, this);
}
function ba() {
  for (var n = this.s & this.DM; this.t > 0 && this[this.t - 1] == n; )
    --this.t;
}
function Aa(n) {
  if (this.s < 0)
    return "-" + this.negate().toString(n);
  var t;
  if (n == 16)
    t = 4;
  else if (n == 8)
    t = 3;
  else if (n == 2)
    t = 1;
  else if (n == 32)
    t = 5;
  else if (n == 4)
    t = 2;
  else
    throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  var e = (1 << t) - 1, i, o = !1, r = "", a = this.t, u = this.DB - a * this.DB % t;
  if (a-- > 0)
    for (u < this.DB && (i = this[a] >> u) > 0 && (o = !0, r = lr(i)); a >= 0; )
      u < t ? (i = (this[a] & (1 << u) - 1) << t - u, i |= this[--a] >> (u += this.DB - t)) : (i = this[a] >> (u -= t) & e, u <= 0 && (u += this.DB, --a)), i > 0 && (o = !0), o && (r += lr(i));
  return o ? r : "0";
}
function Ia() {
  var n = ue();
  return U.ZERO.subTo(this, n), n;
}
function Ca() {
  return this.s < 0 ? this.negate() : this;
}
function Ea(n) {
  var t = this.s - n.s;
  if (t != 0)
    return t;
  var e = this.t;
  if (t = e - n.t, t != 0)
    return this.s < 0 ? -t : t;
  for (; --e >= 0; )
    if ((t = this[e] - n[e]) != 0)
      return t;
  return 0;
}
function kn(n) {
  var t = 1, e;
  return (e = n >>> 16) != 0 && (n = e, t += 16), (e = n >> 8) != 0 && (n = e, t += 8), (e = n >> 4) != 0 && (n = e, t += 4), (e = n >> 2) != 0 && (n = e, t += 2), (e = n >> 1) != 0 && (n = e, t += 1), t;
}
function Ta() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + kn(this[this.t - 1] ^ this.s & this.DM);
}
function Ua(n, t) {
  var e;
  for (e = this.t - 1; e >= 0; --e)
    t[e + n] = this[e];
  for (e = n - 1; e >= 0; --e)
    t[e] = 0;
  t.t = this.t + n, t.s = this.s;
}
function xa(n, t) {
  for (var e = n; e < this.t; ++e)
    t[e - n] = this[e];
  t.t = Math.max(this.t - n, 0), t.s = this.s;
}
function Pa(n, t) {
  var e = n % this.DB, i = this.DB - e, o = (1 << i) - 1, r = Math.floor(n / this.DB), a = this.s << e & this.DM, u;
  for (u = this.t - 1; u >= 0; --u)
    t[u + r + 1] = this[u] >> i | a, a = (this[u] & o) << e;
  for (u = r - 1; u >= 0; --u)
    t[u] = 0;
  t[r] = a, t.t = this.t + r + 1, t.s = this.s, t.clamp();
}
function Ra(n, t) {
  t.s = this.s;
  var e = Math.floor(n / this.DB);
  if (e >= this.t) {
    t.t = 0;
    return;
  }
  var i = n % this.DB, o = this.DB - i, r = (1 << i) - 1;
  t[0] = this[e] >> i;
  for (var a = e + 1; a < this.t; ++a)
    t[a - e - 1] |= (this[a] & r) << o, t[a - e] = this[a] >> i;
  i > 0 && (t[this.t - e - 1] |= (this.s & r) << o), t.t = this.t - e, t.clamp();
}
function Da(n, t) {
  for (var e = 0, i = 0, o = Math.min(n.t, this.t); e < o; )
    i += this[e] - n[e], t[e++] = i & this.DM, i >>= this.DB;
  if (n.t < this.t) {
    for (i -= n.s; e < this.t; )
      i += this[e], t[e++] = i & this.DM, i >>= this.DB;
    i += this.s;
  } else {
    for (i += this.s; e < n.t; )
      i -= n[e], t[e++] = i & this.DM, i >>= this.DB;
    i -= n.s;
  }
  t.s = i < 0 ? -1 : 0, i < -1 ? t[e++] = this.DV + i : i > 0 && (t[e++] = i), t.t = e, t.clamp();
}
function Fa(n, t) {
  var e = this.abs(), i = n.abs(), o = e.t;
  for (t.t = o + i.t; --o >= 0; )
    t[o] = 0;
  for (o = 0; o < i.t; ++o)
    t[o + e.t] = e.am(0, i[o], t, o, 0, e.t);
  t.s = 0, t.clamp(), this.s != n.s && U.ZERO.subTo(t, t);
}
function Oa(n) {
  for (var t = this.abs(), e = n.t = 2 * t.t; --e >= 0; )
    n[e] = 0;
  for (e = 0; e < t.t - 1; ++e) {
    var i = t.am(e, t[e], n, 2 * e, 0, 1);
    (n[e + t.t] += t.am(e + 1, 2 * t[e], n, 2 * e + 1, i, t.t - e - 1)) >= t.DV && (n[e + t.t] -= t.DV, n[e + t.t + 1] = 1);
  }
  n.t > 0 && (n[n.t - 1] += t.am(e, t[e], n, 2 * e, 0, 1)), n.s = 0, n.clamp();
}
function ka(n, t, e) {
  var i = n.abs();
  if (!(i.t <= 0)) {
    var o = this.abs();
    if (o.t < i.t) {
      t != null && t.fromInt(0), e != null && this.copyTo(e);
      return;
    }
    e == null && (e = ue());
    var r = ue(), a = this.s, u = n.s, h = this.DB - kn(i[i.t - 1]);
    h > 0 ? (i.lShiftTo(h, r), o.lShiftTo(h, e)) : (i.copyTo(r), o.copyTo(e));
    var s = r.t, l = r[s - 1];
    if (l != 0) {
      var d = l * (1 << this.F1) + (s > 1 ? r[s - 2] >> this.F2 : 0), v = this.FV / d, y = (1 << this.F1) / d, m = 1 << this.F2, S = e.t, b = S - s, E = t ?? ue();
      for (r.dlShiftTo(b, E), e.compareTo(E) >= 0 && (e[e.t++] = 1, e.subTo(E, e)), U.ONE.dlShiftTo(s, E), E.subTo(r, r); r.t < s; )
        r[r.t++] = 0;
      for (; --b >= 0; ) {
        var _ = e[--S] == l ? this.DM : Math.floor(e[S] * v + (e[S - 1] + m) * y);
        if ((e[S] += r.am(0, _, e, b, 0, s)) < _)
          for (r.dlShiftTo(b, E), e.subTo(E, e); e[S] < --_; )
            e.subTo(E, e);
      }
      t != null && (e.drShiftTo(s, t), a != u && U.ZERO.subTo(t, t)), e.t = s, e.clamp(), h > 0 && e.rShiftTo(h, e), a < 0 && U.ZERO.subTo(e, e);
    }
  }
}
function Ma(n) {
  var t = ue();
  return this.abs().divRemTo(n, null, t), this.s < 0 && t.compareTo(U.ZERO) > 0 && n.subTo(t, t), t;
}
function Na() {
  if (this.t < 1)
    return 0;
  var n = this[0];
  if (!(n & 1))
    return 0;
  var t = n & 3;
  return t = t * (2 - (n & 15) * t) & 15, t = t * (2 - (n & 255) * t) & 255, t = t * (2 - ((n & 65535) * t & 65535)) & 65535, t = t * (2 - n * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
}
function Ba(n) {
  return this.compareTo(n) == 0;
}
function La(n, t) {
  for (var e = 0, i = 0, o = Math.min(n.t, this.t); e < o; )
    i += this[e] + n[e], t[e++] = i & this.DM, i >>= this.DB;
  if (n.t < this.t) {
    for (i += n.s; e < this.t; )
      i += this[e], t[e++] = i & this.DM, i >>= this.DB;
    i += this.s;
  } else {
    for (i += this.s; e < n.t; )
      i += n[e], t[e++] = i & this.DM, i >>= this.DB;
    i += n.s;
  }
  t.s = i < 0 ? -1 : 0, i > 0 ? t[e++] = i : i < -1 && (t[e++] = this.DV + i), t.t = e, t.clamp();
}
function ja(n) {
  var t = ue();
  return this.addTo(n, t), t;
}
function Ka(n) {
  var t = ue();
  return this.subTo(n, t), t;
}
function Va(n) {
  var t = ue();
  return this.multiplyTo(n, t), t;
}
function qa(n) {
  var t = ue();
  return this.divRemTo(n, t, null), t;
}
function it(n) {
  this.m = n, this.mp = n.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << n.DB - 15) - 1, this.mt2 = 2 * n.t;
}
function Ha(n) {
  var t = ue();
  return n.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), n.s < 0 && t.compareTo(U.ZERO) > 0 && this.m.subTo(t, t), t;
}
function Ga(n) {
  var t = ue();
  return n.copyTo(t), this.reduce(t), t;
}
function $a(n) {
  for (; n.t <= this.mt2; )
    n[n.t++] = 0;
  for (var t = 0; t < this.m.t; ++t) {
    var e = n[t] & 32767, i = e * this.mpl + ((e * this.mph + (n[t] >> 15) * this.mpl & this.um) << 15) & n.DM;
    for (e = t + this.m.t, n[e] += this.m.am(0, i, n, t, 0, this.m.t); n[e] >= n.DV; )
      n[e] -= n.DV, n[++e]++;
  }
  n.clamp(), n.drShiftTo(this.m.t, n), n.compareTo(this.m) >= 0 && n.subTo(this.m, n);
}
function Wa(n, t) {
  n.squareTo(t), this.reduce(t);
}
function Ya(n, t, e) {
  n.multiplyTo(t, e), this.reduce(e);
}
it.prototype.convert = Ha;
it.prototype.revert = Ga;
it.prototype.reduce = $a;
it.prototype.mulTo = Ya;
it.prototype.sqrTo = Wa;
function Ja(n, t, e) {
  var i = n.bitLength(), o, r = On(1), a = new it(t);
  if (i <= 0)
    return r;
  i < 18 ? o = 1 : i < 48 ? o = 3 : i < 144 ? o = 4 : i < 768 ? o = 5 : o = 6;
  var u = new Array(), h = 3, s = o - 1, l = (1 << o) - 1;
  if (u[1] = a.convert(this), o > 1) {
    var d = ue();
    for (a.sqrTo(u[1], d); h <= l; )
      u[h] = ue(), a.mulTo(d, u[h - 2], u[h]), h += 2;
  }
  var v = n.t - 1, y, m = !0, S = ue(), b;
  for (i = kn(n[v]) - 1; v >= 0; ) {
    for (i >= s ? y = n[v] >> i - s & l : (y = (n[v] & (1 << i + 1) - 1) << s - i, v > 0 && (y |= n[v - 1] >> this.DB + i - s)), h = o; !(y & 1); )
      y >>= 1, --h;
    if ((i -= h) < 0 && (i += this.DB, --v), m)
      u[y].copyTo(r), m = !1;
    else {
      for (; h > 1; )
        a.sqrTo(r, S), a.sqrTo(S, r), h -= 2;
      h > 0 ? a.sqrTo(r, S) : (b = r, r = S, S = b), a.mulTo(S, u[y], r);
    }
    for (; v >= 0 && !(n[v] & 1 << i); )
      a.sqrTo(r, S), b = r, r = S, S = b, --i < 0 && (i = this.DB - 1, --v);
  }
  var E = a.revert(r);
  return e(null, E), E;
}
U.prototype.copyTo = wa;
U.prototype.fromInt = Sa;
U.prototype.fromString = _a;
U.prototype.clamp = ba;
U.prototype.dlShiftTo = Ua;
U.prototype.drShiftTo = xa;
U.prototype.lShiftTo = Pa;
U.prototype.rShiftTo = Ra;
U.prototype.subTo = Da;
U.prototype.multiplyTo = Fa;
U.prototype.squareTo = Oa;
U.prototype.divRemTo = ka;
U.prototype.invDigit = Na;
U.prototype.addTo = La;
U.prototype.toString = Aa;
U.prototype.negate = Ia;
U.prototype.abs = Ca;
U.prototype.compareTo = Ea;
U.prototype.bitLength = Ta;
U.prototype.mod = Ma;
U.prototype.equals = Ba;
U.prototype.add = ja;
U.prototype.subtract = Ka;
U.prototype.multiply = Va;
U.prototype.divide = qa;
U.prototype.modPow = Ja;
U.ZERO = On(0);
U.ONE = On(1);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
function tn(n) {
  return G.Buffer.from(new ha().random(n).toString(), "hex");
}
var za = /^[89a-f]/i, Za = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF", Xa = "userAttributes.", Xe = /* @__PURE__ */ function() {
  function n(e) {
    this.N = new U(Za, 16), this.g = new U("2", 16), this.k = new U(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16), this.smallAValue = this.generateRandomSmallA(), this.getLargeAValue(function() {
    }), this.infoBits = G.Buffer.from("Caldera Derived Key", "utf8"), this.poolName = e;
  }
  var t = n.prototype;
  return t.getSmallAValue = function() {
    return this.smallAValue;
  }, t.getLargeAValue = function(i) {
    var o = this;
    this.largeAValue ? i(null, this.largeAValue) : this.calculateA(this.smallAValue, function(r, a) {
      r && i(r, null), o.largeAValue = a, i(null, o.largeAValue);
    });
  }, t.generateRandomSmallA = function() {
    var i = tn(128).toString("hex"), o = new U(i, 16);
    return o;
  }, t.generateRandomString = function() {
    return tn(40).toString("base64");
  }, t.getRandomPassword = function() {
    return this.randomPassword;
  }, t.getSaltDevices = function() {
    return this.SaltToHashDevices;
  }, t.getVerifierDevices = function() {
    return this.verifierDevices;
  }, t.generateHashDevice = function(i, o, r) {
    var a = this;
    this.randomPassword = this.generateRandomString();
    var u = "" + i + o + ":" + this.randomPassword, h = this.hash(u), s = tn(16).toString("hex");
    this.SaltToHashDevices = this.padHex(new U(s, 16)), this.g.modPow(new U(this.hexHash(this.SaltToHashDevices + h), 16), this.N, function(l, d) {
      l && r(l, null), a.verifierDevices = a.padHex(d), r(null, null);
    });
  }, t.calculateA = function(i, o) {
    var r = this;
    this.g.modPow(i, this.N, function(a, u) {
      a && o(a, null), u.mod(r.N).equals(U.ZERO) && o(new Error("Illegal paramater. A mod N cannot be 0."), null), o(null, u);
    });
  }, t.calculateU = function(i, o) {
    this.UHexHash = this.hexHash(this.padHex(i) + this.padHex(o));
    var r = new U(this.UHexHash, 16);
    return r;
  }, t.hash = function(i) {
    var o = new We.Sha256();
    o.update(i);
    var r = o.digestSync(), a = G.Buffer.from(r).toString("hex");
    return new Array(64 - a.length).join("0") + a;
  }, t.hexHash = function(i) {
    return this.hash(G.Buffer.from(i, "hex"));
  }, t.computehkdf = function(i, o) {
    var r = G.Buffer.concat([this.infoBits, G.Buffer.from(String.fromCharCode(1), "utf8")]), a = new We.Sha256(o);
    a.update(i);
    var u = a.digestSync(), h = new We.Sha256(u);
    h.update(r);
    var s = h.digestSync(), l = s, d = l.slice(0, 16);
    return d;
  }, t.getPasswordAuthenticationKey = function(i, o, r, a, u) {
    var h = this;
    if (r.mod(this.N).equals(U.ZERO))
      throw new Error("B cannot be zero.");
    if (this.UValue = this.calculateU(this.largeAValue, r), this.UValue.equals(U.ZERO))
      throw new Error("U cannot be zero.");
    var s = "" + this.poolName + i + ":" + o, l = this.hash(s), d = new U(this.hexHash(this.padHex(a) + l), 16);
    this.calculateS(d, r, function(v, y) {
      v && u(v, null);
      var m = h.computehkdf(G.Buffer.from(h.padHex(y), "hex"), G.Buffer.from(h.padHex(h.UValue), "hex"));
      u(null, m);
    });
  }, t.calculateS = function(i, o, r) {
    var a = this;
    this.g.modPow(i, this.N, function(u, h) {
      u && r(u, null);
      var s = o.subtract(a.k.multiply(h));
      s.modPow(a.smallAValue.add(a.UValue.multiply(i)), a.N, function(l, d) {
        l && r(l, null), r(null, d.mod(a.N));
      });
    });
  }, t.getNewPasswordRequiredChallengeUserAttributePrefix = function() {
    return Xa;
  }, t.padHex = function(i) {
    if (!(i instanceof U))
      throw new Error("Not a BigInteger");
    var o = i.compareTo(U.ZERO) < 0, r = i.abs().toString(16);
    if (r = r.length % 2 !== 0 ? "0" + r : r, r = za.test(r) ? "00" + r : r, o) {
      var a = r.split("").map(function(h) {
        var s = ~parseInt(h, 16) & 15;
        return "0123456789ABCDEF".charAt(s);
      }).join(""), u = new U(a, 16).add(U.ONE);
      r = u.toString(16), r.toUpperCase().startsWith("FF8") && (r = r.substring(2));
    }
    return r;
  }, n;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Gr = /* @__PURE__ */ function() {
  function n(e) {
    this.jwtToken = e || "", this.payload = this.decodePayload();
  }
  var t = n.prototype;
  return t.getJwtToken = function() {
    return this.jwtToken;
  }, t.getExpiration = function() {
    return this.payload.exp;
  }, t.getIssuedAt = function() {
    return this.payload.iat;
  }, t.decodePayload = function() {
    var i = this.jwtToken.split(".")[1];
    try {
      return JSON.parse(G.Buffer.from(i, "base64").toString("utf8"));
    } catch {
      return {};
    }
  }, n;
}();
function Qa(n, t) {
  n.prototype = Object.create(t.prototype), n.prototype.constructor = n, dn(n, t);
}
function dn(n, t) {
  return dn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, o) {
    return i.__proto__ = o, i;
  }, dn(n, t);
}
var gn = /* @__PURE__ */ function(n) {
  Qa(t, n);
  function t(e) {
    var i = e === void 0 ? {} : e, o = i.AccessToken;
    return n.call(this, o || "") || this;
  }
  return t;
}(Gr);
function eu(n, t) {
  n.prototype = Object.create(t.prototype), n.prototype.constructor = n, pn(n, t);
}
function pn(n, t) {
  return pn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, o) {
    return i.__proto__ = o, i;
  }, pn(n, t);
}
var vn = /* @__PURE__ */ function(n) {
  eu(t, n);
  function t(e) {
    var i = e === void 0 ? {} : e, o = i.IdToken;
    return n.call(this, o || "") || this;
  }
  return t;
}(Gr);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var yn = /* @__PURE__ */ function() {
  function n(e) {
    var i = e === void 0 ? {} : e, o = i.RefreshToken;
    this.token = o || "";
  }
  var t = n.prototype;
  return t.getToken = function() {
    return this.token;
  }, n;
}(), tu = "5.0.4";
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var nu = "aws-amplify/" + tu, $r = {
  userAgent: nu,
  isReactNative: typeof navigator < "u" && navigator.product === "ReactNative"
}, ru = function() {
  return $r.userAgent;
};
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var mn = /* @__PURE__ */ function() {
  function n(e) {
    var i = e === void 0 ? {} : e, o = i.IdToken, r = i.RefreshToken, a = i.AccessToken, u = i.ClockDrift;
    if (a == null || o == null)
      throw new Error("Id token and Access Token must be present.");
    this.idToken = o, this.refreshToken = r, this.accessToken = a, this.clockDrift = u === void 0 ? this.calculateClockDrift() : u;
  }
  var t = n.prototype;
  return t.getIdToken = function() {
    return this.idToken;
  }, t.getRefreshToken = function() {
    return this.refreshToken;
  }, t.getAccessToken = function() {
    return this.accessToken;
  }, t.getClockDrift = function() {
    return this.clockDrift;
  }, t.calculateClockDrift = function() {
    var i = Math.floor(/* @__PURE__ */ new Date() / 1e3), o = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
    return i - o;
  }, t.isValid = function() {
    var i = Math.floor(/* @__PURE__ */ new Date() / 1e3), o = i - this.clockDrift;
    return o < this.accessToken.getExpiration() && o < this.idToken.getExpiration();
  }, n;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var iu = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], ou = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], hr = /* @__PURE__ */ function() {
  function n() {
  }
  var t = n.prototype;
  return t.getNowString = function() {
    var i = /* @__PURE__ */ new Date(), o = ou[i.getUTCDay()], r = iu[i.getUTCMonth()], a = i.getUTCDate(), u = i.getUTCHours();
    u < 10 && (u = "0" + u);
    var h = i.getUTCMinutes();
    h < 10 && (h = "0" + h);
    var s = i.getUTCSeconds();
    s < 10 && (s = "0" + s);
    var l = i.getUTCFullYear(), d = o + " " + r + " " + a + " " + u + ":" + h + ":" + s + " UTC " + l;
    return d;
  }, n;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var et = /* @__PURE__ */ function() {
  function n(e) {
    var i = e === void 0 ? {} : e, o = i.Name, r = i.Value;
    this.Name = o || "", this.Value = r || "";
  }
  var t = n.prototype;
  return t.getValue = function() {
    return this.Value;
  }, t.setValue = function(i) {
    return this.Value = i, this;
  }, t.getName = function() {
    return this.Name;
  }, t.setName = function(i) {
    return this.Name = i, this;
  }, t.toString = function() {
    return JSON.stringify(this);
  }, t.toJSON = function() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  }, n;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Ve = {}, su = /* @__PURE__ */ function() {
  function n() {
  }
  return n.setItem = function(e, i) {
    return Ve[e] = i, Ve[e];
  }, n.getItem = function(e) {
    return Object.prototype.hasOwnProperty.call(Ve, e) ? Ve[e] : void 0;
  }, n.removeItem = function(e) {
    return delete Ve[e];
  }, n.clear = function() {
    return Ve = {}, Ve;
  }, n;
}(), Wr = /* @__PURE__ */ function() {
  function n() {
    try {
      this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.cognito.test-ls", 1), this.storageWindow.removeItem("aws.cognito.test-ls");
    } catch {
      this.storageWindow = su;
    }
  }
  var t = n.prototype;
  return t.getStorage = function() {
    return this.storageWindow;
  }, n;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var au = typeof navigator < "u", dr = au ? $r.isReactNative ? "react-native" : navigator.userAgent : "nodejs", wn = /* @__PURE__ */ function() {
  function n(e) {
    if (e == null || e.Username == null || e.Pool == null)
      throw new Error("Username and Pool information are required.");
    this.username = e.Username || "", this.pool = e.Pool, this.Session = null, this.client = e.Pool.client, this.signInUserSession = null, this.authenticationFlowType = "USER_SRP_AUTH", this.storage = e.Storage || new Wr().getStorage(), this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId(), this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
  }
  var t = n.prototype;
  return t.setSignInUserSession = function(i) {
    this.clearCachedUserData(), this.signInUserSession = i, this.cacheTokens();
  }, t.getSignInUserSession = function() {
    return this.signInUserSession;
  }, t.getUsername = function() {
    return this.username;
  }, t.getAuthenticationFlowType = function() {
    return this.authenticationFlowType;
  }, t.setAuthenticationFlowType = function(i) {
    this.authenticationFlowType = i;
  }, t.initiateAuth = function(i, o) {
    var r = this, a = i.getAuthParameters();
    a.USERNAME = this.username;
    var u = Object.keys(i.getValidationData()).length !== 0 ? i.getValidationData() : i.getClientMetadata(), h = {
      AuthFlow: "CUSTOM_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: a,
      ClientMetadata: u
    };
    this.getUserContextData() && (h.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", h, function(s, l) {
      if (s)
        return o.onFailure(s);
      var d = l.ChallengeName, v = l.ChallengeParameters;
      return d === "CUSTOM_CHALLENGE" ? (r.Session = l.Session, o.customChallenge(v)) : (r.signInUserSession = r.getCognitoUserSession(l.AuthenticationResult), r.cacheTokens(), o.onSuccess(r.signInUserSession));
    });
  }, t.authenticateUser = function(i, o) {
    return this.authenticationFlowType === "USER_PASSWORD_AUTH" ? this.authenticateUserPlainUsernamePassword(i, o) : this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH" ? this.authenticateUserDefaultAuth(i, o) : o.onFailure(new Error("Authentication flow type is invalid."));
  }, t.authenticateUserDefaultAuth = function(i, o) {
    var r = this, a = new Xe(this.pool.getUserPoolName()), u = new hr(), h, s, l = {};
    this.deviceKey != null && (l.DEVICE_KEY = this.deviceKey), l.USERNAME = this.username, a.getLargeAValue(function(d, v) {
      d && o.onFailure(d), l.SRP_A = v.toString(16), r.authenticationFlowType === "CUSTOM_AUTH" && (l.CHALLENGE_NAME = "SRP_A");
      var y = Object.keys(i.getValidationData()).length !== 0 ? i.getValidationData() : i.getClientMetadata(), m = {
        AuthFlow: r.authenticationFlowType,
        ClientId: r.pool.getClientId(),
        AuthParameters: l,
        ClientMetadata: y
      };
      r.getUserContextData(r.username) && (m.UserContextData = r.getUserContextData(r.username)), r.client.request("InitiateAuth", m, function(S, b) {
        if (S)
          return o.onFailure(S);
        var E = b.ChallengeParameters;
        r.username = E.USER_ID_FOR_SRP, r.userDataKey = r.keyPrefix + "." + r.username + ".userData", h = new U(E.SRP_B, 16), s = new U(E.SALT, 16), r.getCachedDeviceKeyAndPassword(), a.getPasswordAuthenticationKey(r.username, i.getPassword(), h, s, function(_, T) {
          _ && o.onFailure(_);
          var x = u.getNowString(), D = G.Buffer.concat([G.Buffer.from(r.pool.getUserPoolName(), "utf8"), G.Buffer.from(r.username, "utf8"), G.Buffer.from(E.SECRET_BLOCK, "base64"), G.Buffer.from(x, "utf8")]), O = new We.Sha256(T);
          O.update(D);
          var N = O.digestSync(), M = G.Buffer.from(N).toString("base64"), H = {};
          H.USERNAME = r.username, H.PASSWORD_CLAIM_SECRET_BLOCK = E.SECRET_BLOCK, H.TIMESTAMP = x, H.PASSWORD_CLAIM_SIGNATURE = M, r.deviceKey != null && (H.DEVICE_KEY = r.deviceKey);
          var re = function _e(ce, pe) {
            return r.client.request("RespondToAuthChallenge", ce, function(fe, be) {
              return fe && fe.code === "ResourceNotFoundException" && fe.message.toLowerCase().indexOf("device") !== -1 ? (H.DEVICE_KEY = null, r.deviceKey = null, r.randomPassword = null, r.deviceGroupKey = null, r.clearCachedDeviceKeyAndPassword(), _e(ce, pe)) : pe(fe, be);
            });
          }, le = {
            ChallengeName: "PASSWORD_VERIFIER",
            ClientId: r.pool.getClientId(),
            ChallengeResponses: H,
            Session: b.Session,
            ClientMetadata: y
          };
          r.getUserContextData() && (le.UserContextData = r.getUserContextData()), re(le, function(_e, ce) {
            return _e ? o.onFailure(_e) : r.authenticateUserInternal(ce, a, o);
          });
        });
      });
    });
  }, t.authenticateUserPlainUsernamePassword = function(i, o) {
    var r = this, a = {};
    if (a.USERNAME = this.username, a.PASSWORD = i.getPassword(), !a.PASSWORD) {
      o.onFailure(new Error("PASSWORD parameter is required"));
      return;
    }
    var u = new Xe(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword(), this.deviceKey != null && (a.DEVICE_KEY = this.deviceKey);
    var h = Object.keys(i.getValidationData()).length !== 0 ? i.getValidationData() : i.getClientMetadata(), s = {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: a,
      ClientMetadata: h
    };
    this.getUserContextData(this.username) && (s.UserContextData = this.getUserContextData(this.username)), this.client.request("InitiateAuth", s, function(l, d) {
      return l ? o.onFailure(l) : r.authenticateUserInternal(d, u, o);
    });
  }, t.authenticateUserInternal = function(i, o, r) {
    var a = this, u = i.ChallengeName, h = i.ChallengeParameters;
    if (u === "SMS_MFA")
      return this.Session = i.Session, r.mfaRequired(u, h);
    if (u === "SELECT_MFA_TYPE")
      return this.Session = i.Session, r.selectMFAType(u, h);
    if (u === "MFA_SETUP")
      return this.Session = i.Session, r.mfaSetup(u, h);
    if (u === "SOFTWARE_TOKEN_MFA")
      return this.Session = i.Session, r.totpRequired(u, h);
    if (u === "CUSTOM_CHALLENGE")
      return this.Session = i.Session, r.customChallenge(h);
    if (u === "NEW_PASSWORD_REQUIRED") {
      this.Session = i.Session;
      var s = null, l = null, d = [], v = o.getNewPasswordRequiredChallengeUserAttributePrefix();
      if (h && (s = JSON.parse(i.ChallengeParameters.userAttributes), l = JSON.parse(i.ChallengeParameters.requiredAttributes)), l)
        for (var y = 0; y < l.length; y++)
          d[y] = l[y].substr(v.length);
      return r.newPasswordRequired(s, d);
    }
    if (u === "DEVICE_SRP_AUTH") {
      this.Session = i.Session, this.getDeviceResponse(r);
      return;
    }
    this.signInUserSession = this.getCognitoUserSession(i.AuthenticationResult), this.challengeName = u, this.cacheTokens();
    var m = i.AuthenticationResult.NewDeviceMetadata;
    if (m == null)
      return r.onSuccess(this.signInUserSession);
    o.generateHashDevice(i.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, i.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(S) {
      if (S)
        return r.onFailure(S);
      var b = {
        Salt: G.Buffer.from(o.getSaltDevices(), "hex").toString("base64"),
        PasswordVerifier: G.Buffer.from(o.getVerifierDevices(), "hex").toString("base64")
      };
      a.verifierDevices = b.PasswordVerifier, a.deviceGroupKey = m.DeviceGroupKey, a.randomPassword = o.getRandomPassword(), a.client.request("ConfirmDevice", {
        DeviceKey: m.DeviceKey,
        AccessToken: a.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: b,
        DeviceName: dr
      }, function(E, _) {
        return E ? r.onFailure(E) : (a.deviceKey = i.AuthenticationResult.NewDeviceMetadata.DeviceKey, a.cacheDeviceKeyAndPassword(), _.UserConfirmationNecessary === !0 ? r.onSuccess(a.signInUserSession, _.UserConfirmationNecessary) : r.onSuccess(a.signInUserSession));
      });
    });
  }, t.completeNewPasswordChallenge = function(i, o, r, a) {
    var u = this;
    if (!i)
      return r.onFailure(new Error("New password is required."));
    var h = new Xe(this.pool.getUserPoolName()), s = h.getNewPasswordRequiredChallengeUserAttributePrefix(), l = {};
    o && Object.keys(o).forEach(function(v) {
      l[s + v] = o[v];
    }), l.NEW_PASSWORD = i, l.USERNAME = this.username;
    var d = {
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      ClientId: this.pool.getClientId(),
      ChallengeResponses: l,
      Session: this.Session,
      ClientMetadata: a
    };
    this.getUserContextData() && (d.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", d, function(v, y) {
      return v ? r.onFailure(v) : u.authenticateUserInternal(y, h, r);
    });
  }, t.getDeviceResponse = function(i, o) {
    var r = this, a = new Xe(this.deviceGroupKey), u = new hr(), h = {};
    h.USERNAME = this.username, h.DEVICE_KEY = this.deviceKey, a.getLargeAValue(function(s, l) {
      s && i.onFailure(s), h.SRP_A = l.toString(16);
      var d = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: r.pool.getClientId(),
        ChallengeResponses: h,
        ClientMetadata: o,
        Session: r.Session
      };
      r.getUserContextData() && (d.UserContextData = r.getUserContextData()), r.client.request("RespondToAuthChallenge", d, function(v, y) {
        if (v)
          return i.onFailure(v);
        var m = y.ChallengeParameters, S = new U(m.SRP_B, 16), b = new U(m.SALT, 16);
        a.getPasswordAuthenticationKey(r.deviceKey, r.randomPassword, S, b, function(E, _) {
          if (E)
            return i.onFailure(E);
          var T = u.getNowString(), x = G.Buffer.concat([G.Buffer.from(r.deviceGroupKey, "utf8"), G.Buffer.from(r.deviceKey, "utf8"), G.Buffer.from(m.SECRET_BLOCK, "base64"), G.Buffer.from(T, "utf8")]), D = new We.Sha256(_);
          D.update(x);
          var O = D.digestSync(), N = G.Buffer.from(O).toString("base64"), M = {};
          M.USERNAME = r.username, M.PASSWORD_CLAIM_SECRET_BLOCK = m.SECRET_BLOCK, M.TIMESTAMP = T, M.PASSWORD_CLAIM_SIGNATURE = N, M.DEVICE_KEY = r.deviceKey;
          var H = {
            ChallengeName: "DEVICE_PASSWORD_VERIFIER",
            ClientId: r.pool.getClientId(),
            ChallengeResponses: M,
            Session: y.Session
          };
          r.getUserContextData() && (H.UserContextData = r.getUserContextData()), r.client.request("RespondToAuthChallenge", H, function(re, le) {
            return re ? i.onFailure(re) : (r.signInUserSession = r.getCognitoUserSession(le.AuthenticationResult), r.cacheTokens(), i.onSuccess(r.signInUserSession));
          });
        });
      });
    });
  }, t.confirmRegistration = function(i, o, r, a) {
    var u = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: i,
      Username: this.username,
      ForceAliasCreation: o,
      ClientMetadata: a
    };
    this.getUserContextData() && (u.UserContextData = this.getUserContextData()), this.client.request("ConfirmSignUp", u, function(h) {
      return h ? r(h, null) : r(null, "SUCCESS");
    });
  }, t.sendCustomChallengeAnswer = function(i, o, r) {
    var a = this, u = {};
    u.USERNAME = this.username, u.ANSWER = i;
    var h = new Xe(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword(), this.deviceKey != null && (u.DEVICE_KEY = this.deviceKey);
    var s = {
      ChallengeName: "CUSTOM_CHALLENGE",
      ChallengeResponses: u,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: r
    };
    this.getUserContextData() && (s.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", s, function(l, d) {
      return l ? o.onFailure(l) : a.authenticateUserInternal(d, h, o);
    });
  }, t.sendMFACode = function(i, o, r, a) {
    var u = this, h = {};
    h.USERNAME = this.username, h.SMS_MFA_CODE = i;
    var s = r || "SMS_MFA";
    s === "SOFTWARE_TOKEN_MFA" && (h.SOFTWARE_TOKEN_MFA_CODE = i), this.deviceKey != null && (h.DEVICE_KEY = this.deviceKey);
    var l = {
      ChallengeName: s,
      ChallengeResponses: h,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: a
    };
    this.getUserContextData() && (l.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", l, function(d, v) {
      if (d)
        return o.onFailure(d);
      var y = v.ChallengeName;
      if (y === "DEVICE_SRP_AUTH") {
        u.getDeviceResponse(o);
        return;
      }
      if (u.signInUserSession = u.getCognitoUserSession(v.AuthenticationResult), u.cacheTokens(), v.AuthenticationResult.NewDeviceMetadata == null)
        return o.onSuccess(u.signInUserSession);
      var m = new Xe(u.pool.getUserPoolName());
      m.generateHashDevice(v.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, v.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(S) {
        if (S)
          return o.onFailure(S);
        var b = {
          Salt: G.Buffer.from(m.getSaltDevices(), "hex").toString("base64"),
          PasswordVerifier: G.Buffer.from(m.getVerifierDevices(), "hex").toString("base64")
        };
        u.verifierDevices = b.PasswordVerifier, u.deviceGroupKey = v.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, u.randomPassword = m.getRandomPassword(), u.client.request("ConfirmDevice", {
          DeviceKey: v.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: u.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: b,
          DeviceName: dr
        }, function(E, _) {
          return E ? o.onFailure(E) : (u.deviceKey = v.AuthenticationResult.NewDeviceMetadata.DeviceKey, u.cacheDeviceKeyAndPassword(), _.UserConfirmationNecessary === !0 ? o.onSuccess(u.signInUserSession, _.UserConfirmationNecessary) : o.onSuccess(u.signInUserSession));
        });
      });
    });
  }, t.changePassword = function(i, o, r, a) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return r(new Error("User is not authenticated"), null);
    this.client.request("ChangePassword", {
      PreviousPassword: i,
      ProposedPassword: o,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: a
    }, function(u) {
      return u ? r(u, null) : r(null, "SUCCESS");
    });
  }, t.enableMFA = function(i) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i(new Error("User is not authenticated"), null);
    var o = [], r = {
      DeliveryMedium: "SMS",
      AttributeName: "phone_number"
    };
    o.push(r), this.client.request("SetUserSettings", {
      MFAOptions: o,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(a) {
      return a ? i(a, null) : i(null, "SUCCESS");
    });
  }, t.setUserMfaPreference = function(i, o, r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r(new Error("User is not authenticated"), null);
    this.client.request("SetUserMFAPreference", {
      SMSMfaSettings: i,
      SoftwareTokenMfaSettings: o,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(a) {
      return a ? r(a, null) : r(null, "SUCCESS");
    });
  }, t.disableMFA = function(i) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i(new Error("User is not authenticated"), null);
    var o = [];
    this.client.request("SetUserSettings", {
      MFAOptions: o,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(r) {
      return r ? i(r, null) : i(null, "SUCCESS");
    });
  }, t.deleteUser = function(i, o) {
    var r = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i(new Error("User is not authenticated"), null);
    this.client.request("DeleteUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: o
    }, function(a) {
      return a ? i(a, null) : (r.clearCachedUser(), i(null, "SUCCESS"));
    });
  }, t.updateAttributes = function(i, o, r) {
    var a = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return o(new Error("User is not authenticated"), null);
    this.client.request("UpdateUserAttributes", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: i,
      ClientMetadata: r
    }, function(u, h) {
      return u ? o(u, null) : a.getUserData(function() {
        return o(null, "SUCCESS", h);
      }, {
        bypassCache: !0
      });
    });
  }, t.getUserAttributes = function(i) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return i(new Error("User is not authenticated"), null);
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(o, r) {
      if (o)
        return i(o, null);
      for (var a = [], u = 0; u < r.UserAttributes.length; u++) {
        var h = {
          Name: r.UserAttributes[u].Name,
          Value: r.UserAttributes[u].Value
        }, s = new et(h);
        a.push(s);
      }
      return i(null, a);
    });
  }, t.getMFAOptions = function(i) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return i(new Error("User is not authenticated"), null);
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(o, r) {
      return o ? i(o, null) : i(null, r.MFAOptions);
    });
  }, t.createGetUserRequest = function() {
    return this.client.promisifyRequest("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    });
  }, t.refreshSessionIfPossible = function(i) {
    var o = this;
    return i === void 0 && (i = {}), new Promise(function(r) {
      var a = o.signInUserSession.getRefreshToken();
      a && a.getToken() ? o.refreshSession(a, r, i.clientMetadata) : r();
    });
  }, t.getUserData = function(i, o) {
    var r = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return this.clearCachedUserData(), i(new Error("User is not authenticated"), null);
    var a = this.getUserDataFromCache();
    if (!a) {
      this.fetchUserData().then(function(u) {
        i(null, u);
      }).catch(i);
      return;
    }
    if (this.isFetchUserDataAndTokenRequired(o)) {
      this.fetchUserData().then(function(u) {
        return r.refreshSessionIfPossible(o).then(function() {
          return u;
        });
      }).then(function(u) {
        return i(null, u);
      }).catch(i);
      return;
    }
    try {
      i(null, JSON.parse(a));
      return;
    } catch (u) {
      this.clearCachedUserData(), i(u, null);
      return;
    }
  }, t.getUserDataFromCache = function() {
    var i = this.storage.getItem(this.userDataKey);
    return i;
  }, t.isFetchUserDataAndTokenRequired = function(i) {
    var o = i || {}, r = o.bypassCache, a = r === void 0 ? !1 : r;
    return a;
  }, t.fetchUserData = function() {
    var i = this;
    return this.createGetUserRequest().then(function(o) {
      return i.cacheUserData(o), o;
    });
  }, t.deleteAttributes = function(i, o) {
    var r = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return o(new Error("User is not authenticated"), null);
    this.client.request("DeleteUserAttributes", {
      UserAttributeNames: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(a) {
      return a ? o(a, null) : r.getUserData(function() {
        return o(null, "SUCCESS");
      }, {
        bypassCache: !0
      });
    });
  }, t.resendConfirmationCode = function(i, o) {
    var r = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: o
    };
    this.client.request("ResendConfirmationCode", r, function(a, u) {
      return a ? i(a, null) : i(null, u);
    });
  }, t.getSession = function(i, o) {
    if (o === void 0 && (o = {}), this.username == null)
      return i(new Error("Username is null. Cannot retrieve a new session"), null);
    if (this.signInUserSession != null && this.signInUserSession.isValid())
      return i(null, this.signInUserSession);
    var r = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, a = r + ".idToken", u = r + ".accessToken", h = r + ".refreshToken", s = r + ".clockDrift";
    if (this.storage.getItem(a)) {
      var l = new vn({
        IdToken: this.storage.getItem(a)
      }), d = new gn({
        AccessToken: this.storage.getItem(u)
      }), v = new yn({
        RefreshToken: this.storage.getItem(h)
      }), y = parseInt(this.storage.getItem(s), 0) || 0, m = {
        IdToken: l,
        AccessToken: d,
        RefreshToken: v,
        ClockDrift: y
      }, S = new mn(m);
      if (S.isValid())
        return this.signInUserSession = S, i(null, this.signInUserSession);
      if (!v.getToken())
        return i(new Error("Cannot retrieve a new session. Please authenticate."), null);
      this.refreshSession(v, i, o.clientMetadata);
    } else
      i(new Error("Local storage is missing an ID Token, Please authenticate"), null);
  }, t.refreshSession = function(i, o, r) {
    var a = this, u = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(o) : o, h = {};
    h.REFRESH_TOKEN = i.getToken();
    var s = "CognitoIdentityServiceProvider." + this.pool.getClientId(), l = s + ".LastAuthUser";
    if (this.storage.getItem(l)) {
      this.username = this.storage.getItem(l);
      var d = s + "." + this.username + ".deviceKey";
      this.deviceKey = this.storage.getItem(d), h.DEVICE_KEY = this.deviceKey;
    }
    var v = {
      ClientId: this.pool.getClientId(),
      AuthFlow: "REFRESH_TOKEN_AUTH",
      AuthParameters: h,
      ClientMetadata: r
    };
    this.getUserContextData() && (v.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", v, function(y, m) {
      if (y)
        return y.code === "NotAuthorizedException" && a.clearCachedUser(), u(y, null);
      if (m) {
        var S = m.AuthenticationResult;
        return Object.prototype.hasOwnProperty.call(S, "RefreshToken") || (S.RefreshToken = i.getToken()), a.signInUserSession = a.getCognitoUserSession(S), a.cacheTokens(), u(null, a.signInUserSession);
      }
    });
  }, t.cacheTokens = function() {
    var i = "CognitoIdentityServiceProvider." + this.pool.getClientId(), o = i + "." + this.username + ".idToken", r = i + "." + this.username + ".accessToken", a = i + "." + this.username + ".refreshToken", u = i + "." + this.username + ".clockDrift", h = i + ".LastAuthUser";
    this.storage.setItem(o, this.signInUserSession.getIdToken().getJwtToken()), this.storage.setItem(r, this.signInUserSession.getAccessToken().getJwtToken()), this.storage.setItem(a, this.signInUserSession.getRefreshToken().getToken()), this.storage.setItem(u, "" + this.signInUserSession.getClockDrift()), this.storage.setItem(h, this.username);
  }, t.cacheUserData = function(i) {
    this.storage.setItem(this.userDataKey, JSON.stringify(i));
  }, t.clearCachedUserData = function() {
    this.storage.removeItem(this.userDataKey);
  }, t.clearCachedUser = function() {
    this.clearCachedTokens(), this.clearCachedUserData();
  }, t.cacheDeviceKeyAndPassword = function() {
    var i = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, o = i + ".deviceKey", r = i + ".randomPasswordKey", a = i + ".deviceGroupKey";
    this.storage.setItem(o, this.deviceKey), this.storage.setItem(r, this.randomPassword), this.storage.setItem(a, this.deviceGroupKey);
  }, t.getCachedDeviceKeyAndPassword = function() {
    var i = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, o = i + ".deviceKey", r = i + ".randomPasswordKey", a = i + ".deviceGroupKey";
    this.storage.getItem(o) && (this.deviceKey = this.storage.getItem(o), this.randomPassword = this.storage.getItem(r), this.deviceGroupKey = this.storage.getItem(a));
  }, t.clearCachedDeviceKeyAndPassword = function() {
    var i = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, o = i + ".deviceKey", r = i + ".randomPasswordKey", a = i + ".deviceGroupKey";
    this.storage.removeItem(o), this.storage.removeItem(r), this.storage.removeItem(a);
  }, t.clearCachedTokens = function() {
    var i = "CognitoIdentityServiceProvider." + this.pool.getClientId(), o = i + "." + this.username + ".idToken", r = i + "." + this.username + ".accessToken", a = i + "." + this.username + ".refreshToken", u = i + ".LastAuthUser", h = i + "." + this.username + ".clockDrift";
    this.storage.removeItem(o), this.storage.removeItem(r), this.storage.removeItem(a), this.storage.removeItem(u), this.storage.removeItem(h);
  }, t.getCognitoUserSession = function(i) {
    var o = new vn(i), r = new gn(i), a = new yn(i), u = {
      IdToken: o,
      AccessToken: r,
      RefreshToken: a
    };
    return new mn(u);
  }, t.forgotPassword = function(i, o) {
    var r = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: o
    };
    this.getUserContextData() && (r.UserContextData = this.getUserContextData()), this.client.request("ForgotPassword", r, function(a, u) {
      return a ? i.onFailure(a) : typeof i.inputVerificationCode == "function" ? i.inputVerificationCode(u) : i.onSuccess(u);
    });
  }, t.confirmPassword = function(i, o, r, a) {
    var u = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: i,
      Password: o,
      ClientMetadata: a
    };
    this.getUserContextData() && (u.UserContextData = this.getUserContextData()), this.client.request("ConfirmForgotPassword", u, function(h) {
      return h ? r.onFailure(h) : r.onSuccess("SUCCESS");
    });
  }, t.getAttributeVerificationCode = function(i, o, r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return o.onFailure(new Error("User is not authenticated"));
    this.client.request("GetUserAttributeVerificationCode", {
      AttributeName: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: r
    }, function(a, u) {
      return a ? o.onFailure(a) : typeof o.inputVerificationCode == "function" ? o.inputVerificationCode(u) : o.onSuccess("SUCCESS");
    });
  }, t.verifyAttribute = function(i, o, r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r.onFailure(new Error("User is not authenticated"));
    this.client.request("VerifyUserAttribute", {
      AttributeName: i,
      Code: o,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(a) {
      return a ? r.onFailure(a) : r.onSuccess("SUCCESS");
    });
  }, t.getDevice = function(i) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i.onFailure(new Error("User is not authenticated"));
    this.client.request("GetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function(o, r) {
      return o ? i.onFailure(o) : i.onSuccess(r);
    });
  }, t.forgetSpecificDevice = function(i, o) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return o.onFailure(new Error("User is not authenticated"));
    this.client.request("ForgetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: i
    }, function(r) {
      return r ? o.onFailure(r) : o.onSuccess("SUCCESS");
    });
  }, t.forgetDevice = function(i) {
    var o = this;
    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: i.onFailure,
      onSuccess: function(a) {
        return o.deviceKey = null, o.deviceGroupKey = null, o.randomPassword = null, o.clearCachedDeviceKeyAndPassword(), i.onSuccess(a);
      }
    });
  }, t.setDeviceStatusRemembered = function(i) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i.onFailure(new Error("User is not authenticated"));
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "remembered"
    }, function(o) {
      return o ? i.onFailure(o) : i.onSuccess("SUCCESS");
    });
  }, t.setDeviceStatusNotRemembered = function(i) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i.onFailure(new Error("User is not authenticated"));
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "not_remembered"
    }, function(o) {
      return o ? i.onFailure(o) : i.onSuccess("SUCCESS");
    });
  }, t.listDevices = function(i, o, r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r.onFailure(new Error("User is not authenticated"));
    var a = {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: i
    };
    o && (a.PaginationToken = o), this.client.request("ListDevices", a, function(u, h) {
      return u ? r.onFailure(u) : r.onSuccess(h);
    });
  }, t.globalSignOut = function(i) {
    var o = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i.onFailure(new Error("User is not authenticated"));
    this.client.request("GlobalSignOut", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(r) {
      return r ? i.onFailure(r) : (o.clearCachedUser(), i.onSuccess("SUCCESS"));
    });
  }, t.signOut = function(i) {
    var o = this;
    if (!i || typeof i != "function") {
      this.cleanClientData();
      return;
    }
    this.getSession(function(r, a) {
      if (r)
        return i(r);
      o.revokeTokens(function(u) {
        o.cleanClientData(), i(u);
      });
    });
  }, t.revokeTokens = function(i) {
    if (i === void 0 && (i = function() {
    }), typeof i != "function")
      throw new Error("Invalid revokeTokenCallback. It should be a function.");
    if (!this.signInUserSession) {
      var o = new Error("User is not authenticated");
      return i(o);
    }
    if (!this.signInUserSession.getAccessToken()) {
      var r = new Error("No Access token available");
      return i(r);
    }
    var a = this.signInUserSession.getRefreshToken().getToken(), u = this.signInUserSession.getAccessToken();
    if (this.isSessionRevocable(u) && a)
      return this.revokeToken({
        token: a,
        callback: i
      });
    i();
  }, t.isSessionRevocable = function(i) {
    if (i && typeof i.decodePayload == "function")
      try {
        var o = i.decodePayload(), r = o.origin_jti;
        return !!r;
      } catch {
      }
    return !1;
  }, t.cleanClientData = function() {
    this.signInUserSession = null, this.clearCachedUser();
  }, t.revokeToken = function(i) {
    var o = i.token, r = i.callback;
    this.client.requestWithRetry("RevokeToken", {
      Token: o,
      ClientId: this.pool.getClientId()
    }, function(a) {
      if (a)
        return r(a);
      r();
    });
  }, t.sendMFASelectionAnswer = function(i, o) {
    var r = this, a = {};
    a.USERNAME = this.username, a.ANSWER = i;
    var u = {
      ChallengeName: "SELECT_MFA_TYPE",
      ChallengeResponses: a,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    this.getUserContextData() && (u.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", u, function(h, s) {
      if (h)
        return o.onFailure(h);
      if (r.Session = s.Session, i === "SMS_MFA")
        return o.mfaRequired(s.ChallengeName, s.ChallengeParameters);
      if (i === "SOFTWARE_TOKEN_MFA")
        return o.totpRequired(s.ChallengeName, s.ChallengeParameters);
    });
  }, t.getUserContextData = function() {
    var i = this.pool;
    return i.getUserContextData(this.username);
  }, t.associateSoftwareToken = function(i) {
    var o = this;
    this.signInUserSession != null && this.signInUserSession.isValid() ? this.client.request("AssociateSoftwareToken", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(r, a) {
      return r ? i.onFailure(r) : i.associateSecretCode(a.SecretCode);
    }) : this.client.request("AssociateSoftwareToken", {
      Session: this.Session
    }, function(r, a) {
      return r ? i.onFailure(r) : (o.Session = a.Session, i.associateSecretCode(a.SecretCode));
    });
  }, t.verifySoftwareToken = function(i, o, r) {
    var a = this;
    this.signInUserSession != null && this.signInUserSession.isValid() ? this.client.request("VerifySoftwareToken", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserCode: i,
      FriendlyDeviceName: o
    }, function(u, h) {
      return u ? r.onFailure(u) : r.onSuccess(h);
    }) : this.client.request("VerifySoftwareToken", {
      Session: this.Session,
      UserCode: i,
      FriendlyDeviceName: o
    }, function(u, h) {
      if (u)
        return r.onFailure(u);
      a.Session = h.Session;
      var s = {};
      s.USERNAME = a.username;
      var l = {
        ChallengeName: "MFA_SETUP",
        ClientId: a.pool.getClientId(),
        ChallengeResponses: s,
        Session: a.Session
      };
      a.getUserContextData() && (l.UserContextData = a.getUserContextData()), a.client.request("RespondToAuthChallenge", l, function(d, v) {
        return d ? r.onFailure(d) : (a.signInUserSession = a.getCognitoUserSession(v.AuthenticationResult), a.cacheTokens(), r.onSuccess(a.signInUserSession));
      });
    });
  }, n;
}(), uu = "auth";
function Le() {
}
Le.prototype.userAgent = ru();
var cu = function() {
  Le.category = uu;
}, gr = function(t) {
  Le.framework = t;
}, fu = function(t) {
  var e = Le.category ? " " + Le.category : "", i = Le.framework ? " framework/" + Le.framework : "", o = "" + Le.prototype.userAgent + e + i;
  return o;
};
function lu(n, t) {
  n.prototype = Object.create(t.prototype), n.prototype.constructor = n, dt(n, t);
}
function Sn(n) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Sn = function(i) {
    if (i === null || !du(i))
      return i;
    if (typeof i != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(i))
        return t.get(i);
      t.set(i, o);
    }
    function o() {
      return At(i, arguments, _n(this).constructor);
    }
    return o.prototype = Object.create(i.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), dt(o, i);
  }, Sn(n);
}
function At(n, t, e) {
  return hu() ? At = Reflect.construct.bind() : At = function(o, r, a) {
    var u = [null];
    u.push.apply(u, r);
    var h = Function.bind.apply(o, u), s = new h();
    return a && dt(s, a.prototype), s;
  }, At.apply(null, arguments);
}
function hu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function du(n) {
  try {
    return Function.toString.call(n).indexOf("[native code]") !== -1;
  } catch {
    return typeof n == "function";
  }
}
function dt(n, t) {
  return dt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, o) {
    return i.__proto__ = o, i;
  }, dt(n, t);
}
function _n(n) {
  return _n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, _n(n);
}
var gu = /* @__PURE__ */ function(n) {
  lu(t, n);
  function t(e, i, o, r) {
    var a;
    return a = n.call(this, e) || this, a.code = i, a.name = o, a.statusCode = r, a;
  }
  return t;
}(/* @__PURE__ */ Sn(Error)), pu = /* @__PURE__ */ function() {
  function n(e, i, o) {
    this.endpoint = i || "https://cognito-idp." + e + ".amazonaws.com/";
    var r = o || {}, a = r.credentials;
    this.fetchOptions = a ? {
      credentials: a
    } : {};
  }
  var t = n.prototype;
  return t.promisifyRequest = function(i, o) {
    var r = this;
    return new Promise(function(a, u) {
      r.request(i, o, function(h, s) {
        h ? u(new gu(h.message, h.code, h.name, h.statusCode)) : a(s);
      });
    });
  }, t.requestWithRetry = function(i, o, r) {
    var a = this, u = 5 * 1e3;
    wu(function(h) {
      return new Promise(function(s, l) {
        a.request(i, h, function(d, v) {
          d ? l(d) : s(v);
        });
      });
    }, [o], u).then(function(h) {
      return r(null, h);
    }).catch(function(h) {
      return r(h);
    });
  }, t.request = function(i, o, r) {
    var a = {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService." + i,
      "X-Amz-User-Agent": fu(),
      "Cache-Control": "no-store"
    }, u = Object.assign({}, this.fetchOptions, {
      headers: a,
      method: "POST",
      mode: "cors",
      body: JSON.stringify(o)
    }), h;
    fetch(this.endpoint, u).then(function(s) {
      return h = s, s;
    }, function(s) {
      throw s instanceof TypeError ? new Error("Network error") : s;
    }).then(function(s) {
      return s.json().catch(function() {
        return {};
      });
    }).then(function(s) {
      if (h.ok)
        return r(null, s);
      var l = (s.__type || s.code).split("#").pop(), d = new Error(s.message || s.Message || null);
      return d.name = l, d.code = l, r(d);
    }).catch(function(s) {
      if (h && h.headers && h.headers.get("x-amzn-errortype"))
        try {
          var l = h.headers.get("x-amzn-errortype").split(":")[0], d = new Error(h.status ? h.status.toString() : null);
          return d.code = l, d.name = l, d.statusCode = h.status, r(d);
        } catch {
          return r(s);
        }
      else
        s instanceof Error && s.message === "Network error" && (s.code = "NetworkError");
      return r(s);
    });
  }, n;
}(), _t = {
  debug: function() {
  }
}, vu = function(t) {
  var e = "nonRetryable";
  return t && t[e];
};
function Yr(n, t, e, i) {
  if (i === void 0 && (i = 1), typeof n != "function")
    throw Error("functionToRetry must be a function");
  return _t.debug(n.name + " attempt #" + i + " with args: " + JSON.stringify(t)), n.apply(void 0, t).catch(function(o) {
    if (_t.debug("error on " + n.name, o), vu(o))
      throw _t.debug(n.name + " non retryable error", o), o;
    var r = e(i, t, o);
    if (_t.debug(n.name + " retrying in " + r + " ms"), r !== !1)
      return new Promise(function(a) {
        return setTimeout(a, r);
      }).then(function() {
        return Yr(n, t, e, i + 1);
      });
    throw o;
  });
}
function yu(n) {
  var t = 100, e = 100;
  return function(i) {
    var o = Math.pow(2, i) * t + e * Math.random();
    return o > n ? !1 : o;
  };
}
var mu = 5 * 60 * 1e3;
function wu(n, t, e) {
  return e === void 0 && (e = mu), Yr(n, t, yu(e));
}
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Su = 55, _u = /* @__PURE__ */ function() {
  function n(e, i) {
    var o = e || {}, r = o.UserPoolId, a = o.ClientId, u = o.endpoint, h = o.fetchOptions, s = o.AdvancedSecurityDataCollectionFlag;
    if (!r || !a)
      throw new Error("Both UserPoolId and ClientId are required.");
    if (r.length > Su || !/^[\w-]+_[0-9a-zA-Z]+$/.test(r))
      throw new Error("Invalid UserPoolId format.");
    var l = r.split("_")[0];
    this.userPoolId = r, this.clientId = a, this.client = new pu(l, u, h), this.advancedSecurityDataCollectionFlag = s !== !1, this.storage = e.Storage || new Wr().getStorage(), i && (this.wrapRefreshSessionCallback = i);
  }
  var t = n.prototype;
  return t.getUserPoolId = function() {
    return this.userPoolId;
  }, t.getUserPoolName = function() {
    return this.getUserPoolId().split("_")[1];
  }, t.getClientId = function() {
    return this.clientId;
  }, t.signUp = function(i, o, r, a, u, h) {
    var s = this, l = {
      ClientId: this.clientId,
      Username: i,
      Password: o,
      UserAttributes: r,
      ValidationData: a,
      ClientMetadata: h
    };
    this.getUserContextData(i) && (l.UserContextData = this.getUserContextData(i)), this.client.request("SignUp", l, function(d, v) {
      if (d)
        return u(d, null);
      var y = {
        Username: i,
        Pool: s,
        Storage: s.storage
      }, m = {
        user: new wn(y),
        userConfirmed: v.UserConfirmed,
        userSub: v.UserSub,
        codeDeliveryDetails: v.CodeDeliveryDetails
      };
      return u(null, m);
    });
  }, t.getCurrentUser = function() {
    var i = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser", o = this.storage.getItem(i);
    if (o) {
      var r = {
        Username: o,
        Pool: this,
        Storage: this.storage
      };
      return new wn(r);
    }
    return null;
  }, t.getUserContextData = function(i) {
    if (!(typeof AmazonCognitoAdvancedSecurityData > "u")) {
      var o = AmazonCognitoAdvancedSecurityData;
      if (this.advancedSecurityDataCollectionFlag) {
        var r = o.getData(i, this.userPoolId, this.clientId);
        if (r) {
          var a = {
            EncodedData: r
          };
          return a;
        }
      }
      return {};
    }
  }, n;
}(), Jr = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(n, t) {
  (function(e) {
    var i;
    if (n.exports = e(), i = !0, !i) {
      var o = window.Cookies, r = window.Cookies = e();
      r.noConflict = function() {
        return window.Cookies = o, r;
      };
    }
  })(function() {
    function e() {
      for (var r = 0, a = {}; r < arguments.length; r++) {
        var u = arguments[r];
        for (var h in u)
          a[h] = u[h];
      }
      return a;
    }
    function i(r) {
      return r.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function o(r) {
      function a() {
      }
      function u(s, l, d) {
        if (!(typeof document > "u")) {
          d = e({
            path: "/"
          }, a.defaults, d), typeof d.expires == "number" && (d.expires = new Date(/* @__PURE__ */ new Date() * 1 + d.expires * 864e5)), d.expires = d.expires ? d.expires.toUTCString() : "";
          try {
            var v = JSON.stringify(l);
            /^[\{\[]/.test(v) && (l = v);
          } catch {
          }
          l = r.write ? r.write(l, s) : encodeURIComponent(String(l)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), s = encodeURIComponent(String(s)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var y = "";
          for (var m in d)
            d[m] && (y += "; " + m, d[m] !== !0 && (y += "=" + d[m].split(";")[0]));
          return document.cookie = s + "=" + l + y;
        }
      }
      function h(s, l) {
        if (!(typeof document > "u")) {
          for (var d = {}, v = document.cookie ? document.cookie.split("; ") : [], y = 0; y < v.length; y++) {
            var m = v[y].split("="), S = m.slice(1).join("=");
            !l && S.charAt(0) === '"' && (S = S.slice(1, -1));
            try {
              var b = i(m[0]);
              if (S = (r.read || r)(S, b) || i(S), l)
                try {
                  S = JSON.parse(S);
                } catch {
                }
              if (d[b] = S, s === b)
                break;
            } catch {
            }
          }
          return s ? d[s] : d;
        }
      }
      return a.set = u, a.get = function(s) {
        return h(
          s,
          !1
          /* read as raw */
        );
      }, a.getJSON = function(s) {
        return h(
          s,
          !0
          /* read as json */
        );
      }, a.remove = function(s, l) {
        u(s, "", e(l, {
          expires: -1
        }));
      }, a.defaults = {}, a.withConverter = o, a;
    }
    return o(function() {
    });
  });
})(Jr);
var ot = Jr.exports, bu = /* @__PURE__ */ function() {
  function n(e) {
    if (e === void 0 && (e = {}), e.domain && (this.domain = e.domain), e.path ? this.path = e.path : this.path = "/", Object.prototype.hasOwnProperty.call(e, "expires") ? this.expires = e.expires : this.expires = 365, Object.prototype.hasOwnProperty.call(e, "secure") ? this.secure = e.secure : this.secure = !0, Object.prototype.hasOwnProperty.call(e, "sameSite")) {
      if (!["strict", "lax", "none"].includes(e.sameSite))
        throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
      if (e.sameSite === "none" && !this.secure)
        throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
      this.sameSite = e.sameSite;
    } else
      this.sameSite = null;
  }
  var t = n.prototype;
  return t.setItem = function(i, o) {
    var r = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    return this.sameSite && (r.sameSite = this.sameSite), ot.set(i, o, r), ot.get(i);
  }, t.getItem = function(i) {
    return ot.get(i);
  }, t.removeItem = function(i) {
    var o = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    return this.sameSite && (o.sameSite = this.sameSite), ot.remove(i, o);
  }, t.clear = function() {
    for (var i = ot.get(), o = Object.keys(i).length, r = 0; r < o; ++r)
      this.removeItem(Object.keys(i)[r]);
    return {};
  }, n;
}(), Ft = { exports: {} };
/*! https://mths.be/punycode v1.3.2 by @mathias */
Ft.exports;
(function(n, t) {
  (function(e) {
    var i = t && !t.nodeType && t, o = n && !n.nodeType && n, r = typeof at == "object" && at;
    (r.global === r || r.window === r || r.self === r) && (e = r);
    var a, u = 2147483647, h = 36, s = 1, l = 26, d = 38, v = 700, y = 72, m = 128, S = "-", b = /^xn--/, E = /[^\x20-\x7E]/, _ = /[\x2E\u3002\uFF0E\uFF61]/g, T = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, x = h - s, D = Math.floor, O = String.fromCharCode, N;
    function M(R) {
      throw RangeError(T[R]);
    }
    function H(R, P) {
      for (var F = R.length, q = []; F--; )
        q[F] = P(R[F]);
      return q;
    }
    function re(R, P) {
      var F = R.split("@"), q = "";
      F.length > 1 && (q = F[0] + "@", R = F[1]), R = R.replace(_, ".");
      var $ = R.split("."), X = H($, P).join(".");
      return q + X;
    }
    function le(R) {
      for (var P = [], F = 0, q = R.length, $, X; F < q; )
        $ = R.charCodeAt(F++), $ >= 55296 && $ <= 56319 && F < q ? (X = R.charCodeAt(F++), (X & 64512) == 56320 ? P.push((($ & 1023) << 10) + (X & 1023) + 65536) : (P.push($), F--)) : P.push($);
      return P;
    }
    function _e(R) {
      return H(R, function(P) {
        var F = "";
        return P > 65535 && (P -= 65536, F += O(P >>> 10 & 1023 | 55296), P = 56320 | P & 1023), F += O(P), F;
      }).join("");
    }
    function ce(R) {
      return R - 48 < 10 ? R - 22 : R - 65 < 26 ? R - 65 : R - 97 < 26 ? R - 97 : h;
    }
    function pe(R, P) {
      return R + 22 + 75 * (R < 26) - ((P != 0) << 5);
    }
    function fe(R, P, F) {
      var q = 0;
      for (R = F ? D(R / v) : R >> 1, R += D(R / P); R > x * l >> 1; q += h)
        R = D(R / x);
      return D(q + (x + 1) * R / (R + d));
    }
    function be(R) {
      var P = [], F = R.length, q, $ = 0, X = m, Z = y, ie, he, ve, Ae, Q, ee, de, Te, Ue;
      for (ie = R.lastIndexOf(S), ie < 0 && (ie = 0), he = 0; he < ie; ++he)
        R.charCodeAt(he) >= 128 && M("not-basic"), P.push(R.charCodeAt(he));
      for (ve = ie > 0 ? ie + 1 : 0; ve < F; ) {
        for (Ae = $, Q = 1, ee = h; ve >= F && M("invalid-input"), de = ce(R.charCodeAt(ve++)), (de >= h || de > D((u - $) / Q)) && M("overflow"), $ += de * Q, Te = ee <= Z ? s : ee >= Z + l ? l : ee - Z, !(de < Te); ee += h)
          Ue = h - Te, Q > D(u / Ue) && M("overflow"), Q *= Ue;
        q = P.length + 1, Z = fe($ - Ae, q, Ae == 0), D($ / q) > u - X && M("overflow"), X += D($ / q), $ %= q, P.splice($++, 0, X);
      }
      return _e(P);
    }
    function Ye(R) {
      var P, F, q, $, X, Z, ie, he, ve, Ae, Q, ee = [], de, Te, Ue, ke;
      for (R = le(R), de = R.length, P = m, F = 0, X = y, Z = 0; Z < de; ++Z)
        Q = R[Z], Q < 128 && ee.push(O(Q));
      for (q = $ = ee.length, $ && ee.push(S); q < de; ) {
        for (ie = u, Z = 0; Z < de; ++Z)
          Q = R[Z], Q >= P && Q < ie && (ie = Q);
        for (Te = q + 1, ie - P > D((u - F) / Te) && M("overflow"), F += (ie - P) * Te, P = ie, Z = 0; Z < de; ++Z)
          if (Q = R[Z], Q < P && ++F > u && M("overflow"), Q == P) {
            for (he = F, ve = h; Ae = ve <= X ? s : ve >= X + l ? l : ve - X, !(he < Ae); ve += h)
              ke = he - Ae, Ue = h - Ae, ee.push(
                O(pe(Ae + ke % Ue, 0))
              ), he = D(ke / Ue);
            ee.push(O(pe(he, 0))), X = fe(F, Te, q == $), F = 0, ++q;
          }
        ++F, ++P;
      }
      return ee.join("");
    }
    function Gt(R) {
      return re(R, function(P) {
        return b.test(P) ? be(P.slice(4).toLowerCase()) : P;
      });
    }
    function $t(R) {
      return re(R, function(P) {
        return E.test(P) ? "xn--" + Ye(P) : P;
      });
    }
    if (a = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      version: "1.3.2",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      ucs2: {
        decode: le,
        encode: _e
      },
      decode: be,
      encode: Ye,
      toASCII: $t,
      toUnicode: Gt
    }, i && o)
      if (n.exports == i)
        o.exports = a;
      else
        for (N in a)
          a.hasOwnProperty(N) && (i[N] = a[N]);
    else
      e.punycode = a;
  })(at);
})(Ft, Ft.exports);
var Au = Ft.exports, Iu = {
  isString: function(n) {
    return typeof n == "string";
  },
  isObject: function(n) {
    return typeof n == "object" && n !== null;
  },
  isNull: function(n) {
    return n === null;
  },
  isNullOrUndefined: function(n) {
    return n == null;
  }
}, gt = {};
function Cu(n, t) {
  return Object.prototype.hasOwnProperty.call(n, t);
}
var Eu = function(n, t, e, i) {
  t = t || "&", e = e || "=";
  var o = {};
  if (typeof n != "string" || n.length === 0)
    return o;
  var r = /\+/g;
  n = n.split(t);
  var a = 1e3;
  i && typeof i.maxKeys == "number" && (a = i.maxKeys);
  var u = n.length;
  a > 0 && u > a && (u = a);
  for (var h = 0; h < u; ++h) {
    var s = n[h].replace(r, "%20"), l = s.indexOf(e), d, v, y, m;
    l >= 0 ? (d = s.substr(0, l), v = s.substr(l + 1)) : (d = s, v = ""), y = decodeURIComponent(d), m = decodeURIComponent(v), Cu(o, y) ? Array.isArray(o[y]) ? o[y].push(m) : o[y] = [o[y], m] : o[y] = m;
  }
  return o;
}, st = function(n) {
  switch (typeof n) {
    case "string":
      return n;
    case "boolean":
      return n ? "true" : "false";
    case "number":
      return isFinite(n) ? n : "";
    default:
      return "";
  }
}, Tu = function(n, t, e, i) {
  return t = t || "&", e = e || "=", n === null && (n = void 0), typeof n == "object" ? Object.keys(n).map(function(o) {
    var r = encodeURIComponent(st(o)) + e;
    return Array.isArray(n[o]) ? n[o].map(function(a) {
      return r + encodeURIComponent(st(a));
    }).join(t) : r + encodeURIComponent(st(n[o]));
  }).join(t) : i ? encodeURIComponent(st(i)) + e + encodeURIComponent(st(n)) : "";
};
gt.decode = gt.parse = Eu;
gt.encode = gt.stringify = Tu;
var Uu = Au, Pe = Iu, Be = Mn, yc = Nu;
function Ce() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
var xu = /^([a-z0-9.+-]+:)/i, Pu = /:[0-9]*$/, Ru = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, Du = ["<", ">", '"', "`", " ", "\r", `
`, "	"], Fu = ["{", "}", "|", "\\", "^", "`"].concat(Du), bn = ["'"].concat(Fu), pr = ["%", "/", "?", ";", "#"].concat(bn), vr = ["/", "?", "#"], Ou = 255, yr = /^[+a-z0-9A-Z_-]{0,63}$/, ku = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, Mu = {
  javascript: !0,
  "javascript:": !0
}, An = {
  javascript: !0,
  "javascript:": !0
}, tt = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
}, In = gt;
function Mn(n, t, e) {
  if (n && Pe.isObject(n) && n instanceof Ce)
    return n;
  var i = new Ce();
  return i.parse(n, t, e), i;
}
Ce.prototype.parse = function(n, t, e) {
  if (!Pe.isString(n))
    throw new TypeError("Parameter 'url' must be a string, not " + typeof n);
  var i = n.indexOf("?"), o = i !== -1 && i < n.indexOf("#") ? "?" : "#", r = n.split(o), a = /\\/g;
  r[0] = r[0].replace(a, "/"), n = r.join(o);
  var u = n;
  if (u = u.trim(), !e && n.split("#").length === 1) {
    var h = Ru.exec(u);
    if (h)
      return this.path = u, this.href = u, this.pathname = h[1], h[2] ? (this.search = h[2], t ? this.query = In.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
  }
  var s = xu.exec(u);
  if (s) {
    s = s[0];
    var l = s.toLowerCase();
    this.protocol = l, u = u.substr(s.length);
  }
  if (e || s || u.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var d = u.substr(0, 2) === "//";
    d && !(s && An[s]) && (u = u.substr(2), this.slashes = !0);
  }
  if (!An[s] && (d || s && !tt[s])) {
    for (var v = -1, y = 0; y < vr.length; y++) {
      var m = u.indexOf(vr[y]);
      m !== -1 && (v === -1 || m < v) && (v = m);
    }
    var S, b;
    v === -1 ? b = u.lastIndexOf("@") : b = u.lastIndexOf("@", v), b !== -1 && (S = u.slice(0, b), u = u.slice(b + 1), this.auth = decodeURIComponent(S)), v = -1;
    for (var y = 0; y < pr.length; y++) {
      var m = u.indexOf(pr[y]);
      m !== -1 && (v === -1 || m < v) && (v = m);
    }
    v === -1 && (v = u.length), this.host = u.slice(0, v), u = u.slice(v), this.parseHost(), this.hostname = this.hostname || "";
    var E = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!E)
      for (var _ = this.hostname.split(/\./), y = 0, T = _.length; y < T; y++) {
        var x = _[y];
        if (x && !x.match(yr)) {
          for (var D = "", O = 0, N = x.length; O < N; O++)
            x.charCodeAt(O) > 127 ? D += "x" : D += x[O];
          if (!D.match(yr)) {
            var M = _.slice(0, y), H = _.slice(y + 1), re = x.match(ku);
            re && (M.push(re[1]), H.unshift(re[2])), H.length && (u = "/" + H.join(".") + u), this.hostname = M.join(".");
            break;
          }
        }
      }
    this.hostname.length > Ou ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), E || (this.hostname = Uu.toASCII(this.hostname));
    var le = this.port ? ":" + this.port : "", _e = this.hostname || "";
    this.host = _e + le, this.href += this.host, E && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), u[0] !== "/" && (u = "/" + u));
  }
  if (!Mu[l])
    for (var y = 0, T = bn.length; y < T; y++) {
      var ce = bn[y];
      if (u.indexOf(ce) !== -1) {
        var pe = encodeURIComponent(ce);
        pe === ce && (pe = escape(ce)), u = u.split(ce).join(pe);
      }
    }
  var fe = u.indexOf("#");
  fe !== -1 && (this.hash = u.substr(fe), u = u.slice(0, fe));
  var be = u.indexOf("?");
  if (be !== -1 ? (this.search = u.substr(be), this.query = u.substr(be + 1), t && (this.query = In.parse(this.query)), u = u.slice(0, be)) : t && (this.search = "", this.query = {}), u && (this.pathname = u), tt[l] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
    var le = this.pathname || "", Ye = this.search || "";
    this.path = le + Ye;
  }
  return this.href = this.format(), this;
};
function Nu(n) {
  return Pe.isString(n) && (n = Mn(n)), n instanceof Ce ? n.format() : Ce.prototype.format.call(n);
}
Ce.prototype.format = function() {
  var n = this.auth || "";
  n && (n = encodeURIComponent(n), n = n.replace(/%3A/i, ":"), n += "@");
  var t = this.protocol || "", e = this.pathname || "", i = this.hash || "", o = !1, r = "";
  this.host ? o = n + this.host : this.hostname && (o = n + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && Pe.isObject(this.query) && Object.keys(this.query).length && (r = In.stringify(this.query));
  var a = this.search || r && "?" + r || "";
  return t && t.substr(-1) !== ":" && (t += ":"), this.slashes || (!t || tt[t]) && o !== !1 ? (o = "//" + (o || ""), e && e.charAt(0) !== "/" && (e = "/" + e)) : o || (o = ""), i && i.charAt(0) !== "#" && (i = "#" + i), a && a.charAt(0) !== "?" && (a = "?" + a), e = e.replace(/[?#]/g, function(u) {
    return encodeURIComponent(u);
  }), a = a.replace("#", "%23"), t + o + e + a + i;
};
Ce.prototype.resolve = function(n) {
  return this.resolveObject(Mn(n, !1, !0)).format();
};
Ce.prototype.resolveObject = function(n) {
  if (Pe.isString(n)) {
    var t = new Ce();
    t.parse(n, !1, !0), n = t;
  }
  for (var e = new Ce(), i = Object.keys(this), o = 0; o < i.length; o++) {
    var r = i[o];
    e[r] = this[r];
  }
  if (e.hash = n.hash, n.href === "")
    return e.href = e.format(), e;
  if (n.slashes && !n.protocol) {
    for (var a = Object.keys(n), u = 0; u < a.length; u++) {
      var h = a[u];
      h !== "protocol" && (e[h] = n[h]);
    }
    return tt[e.protocol] && e.hostname && !e.pathname && (e.path = e.pathname = "/"), e.href = e.format(), e;
  }
  if (n.protocol && n.protocol !== e.protocol) {
    if (!tt[n.protocol]) {
      for (var s = Object.keys(n), l = 0; l < s.length; l++) {
        var d = s[l];
        e[d] = n[d];
      }
      return e.href = e.format(), e;
    }
    if (e.protocol = n.protocol, !n.host && !An[n.protocol]) {
      for (var T = (n.pathname || "").split("/"); T.length && !(n.host = T.shift()); )
        ;
      n.host || (n.host = ""), n.hostname || (n.hostname = ""), T[0] !== "" && T.unshift(""), T.length < 2 && T.unshift(""), e.pathname = T.join("/");
    } else
      e.pathname = n.pathname;
    if (e.search = n.search, e.query = n.query, e.host = n.host || "", e.auth = n.auth, e.hostname = n.hostname || n.host, e.port = n.port, e.pathname || e.search) {
      var v = e.pathname || "", y = e.search || "";
      e.path = v + y;
    }
    return e.slashes = e.slashes || n.slashes, e.href = e.format(), e;
  }
  var m = e.pathname && e.pathname.charAt(0) === "/", S = n.host || n.pathname && n.pathname.charAt(0) === "/", b = S || m || e.host && n.pathname, E = b, _ = e.pathname && e.pathname.split("/") || [], T = n.pathname && n.pathname.split("/") || [], x = e.protocol && !tt[e.protocol];
  if (x && (e.hostname = "", e.port = null, e.host && (_[0] === "" ? _[0] = e.host : _.unshift(e.host)), e.host = "", n.protocol && (n.hostname = null, n.port = null, n.host && (T[0] === "" ? T[0] = n.host : T.unshift(n.host)), n.host = null), b = b && (T[0] === "" || _[0] === "")), S)
    e.host = n.host || n.host === "" ? n.host : e.host, e.hostname = n.hostname || n.hostname === "" ? n.hostname : e.hostname, e.search = n.search, e.query = n.query, _ = T;
  else if (T.length)
    _ || (_ = []), _.pop(), _ = _.concat(T), e.search = n.search, e.query = n.query;
  else if (!Pe.isNullOrUndefined(n.search)) {
    if (x) {
      e.hostname = e.host = _.shift();
      var D = e.host && e.host.indexOf("@") > 0 ? e.host.split("@") : !1;
      D && (e.auth = D.shift(), e.host = e.hostname = D.shift());
    }
    return e.search = n.search, e.query = n.query, (!Pe.isNull(e.pathname) || !Pe.isNull(e.search)) && (e.path = (e.pathname ? e.pathname : "") + (e.search ? e.search : "")), e.href = e.format(), e;
  }
  if (!_.length)
    return e.pathname = null, e.search ? e.path = "/" + e.search : e.path = null, e.href = e.format(), e;
  for (var O = _.slice(-1)[0], N = (e.host || n.host || _.length > 1) && (O === "." || O === "..") || O === "", M = 0, H = _.length; H >= 0; H--)
    O = _[H], O === "." ? _.splice(H, 1) : O === ".." ? (_.splice(H, 1), M++) : M && (_.splice(H, 1), M--);
  if (!b && !E)
    for (; M--; M)
      _.unshift("..");
  b && _[0] !== "" && (!_[0] || _[0].charAt(0) !== "/") && _.unshift(""), N && _.join("/").substr(-1) !== "/" && _.push("");
  var re = _[0] === "" || _[0] && _[0].charAt(0) === "/";
  if (x) {
    e.hostname = e.host = re ? "" : _.length ? _.shift() : "";
    var D = e.host && e.host.indexOf("@") > 0 ? e.host.split("@") : !1;
    D && (e.auth = D.shift(), e.host = e.hostname = D.shift());
  }
  return b = b || e.host && _.length, b && !re && _.unshift(""), _.length ? e.pathname = _.join("/") : (e.pathname = null, e.path = null), (!Pe.isNull(e.pathname) || !Pe.isNull(e.search)) && (e.path = (e.pathname ? e.pathname : "") + (e.search ? e.search : "")), e.auth = n.auth || e.auth, e.slashes = e.slashes || n.slashes, e.href = e.format(), e;
};
Ce.prototype.parseHost = function() {
  var n = this.host, t = Pu.exec(n);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), n = n.substr(0, n.length - t.length)), n && (this.hostname = n);
};
var Bu = "_self", Lu = function(n) {
  var t = window.open(n, Bu);
  return t ? Promise.resolve(t) : Promise.reject();
}, ju = function(n) {
  window.sessionStorage.setItem("oauth_state", n);
}, Ku = function() {
  var n = window.sessionStorage.getItem("oauth_state");
  return window.sessionStorage.removeItem("oauth_state"), n;
}, Vu = function(n) {
  window.sessionStorage.setItem("ouath_pkce_key", n);
}, qu = function() {
  var n = window.sessionStorage.getItem("ouath_pkce_key");
  return window.sessionStorage.removeItem("ouath_pkce_key"), n;
}, Hu = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default", nn = function(n, t, e) {
  xe.dispatch("auth", { event: n, data: t, message: e }, "Auth", Hu);
}, Qe = new Ee("OAuth"), Gu = (
  /** @class */
  function() {
    function n(t) {
      var e = t.config, i = t.cognitoClientId, o = t.scopes, r = o === void 0 ? [] : o;
      if (this._urlOpener = e.urlOpener || Lu, this._config = e, this._cognitoClientId = i, !this.isValidScopes(r))
        throw Error("scopes must be a String Array");
      this._scopes = r;
    }
    return n.prototype.isValidScopes = function(t) {
      return Array.isArray(t) && t.every(function(e) {
        return typeof e == "string";
      });
    }, n.prototype.oauthSignIn = function(t, e, i, o, r, a) {
      t === void 0 && (t = "code"), r === void 0 && (r = Dt.Cognito);
      var u = this._generateState(32), h = a ? u + "-" + Ki(a) : u;
      ju(h);
      var s = this._generateRandom(128);
      Vu(s);
      var l = this._generateChallenge(s), d = "S256", v = this._scopes.join(" "), y = Object.entries(ne(ne({ redirect_uri: i, response_type: t, client_id: o, identity_provider: r, scope: v, state: h }, t === "code" ? { code_challenge: l } : {}), t === "code" ? { code_challenge_method: d } : {})).map(function(S) {
        var b = Fe(S, 2), E = b[0], _ = b[1];
        return encodeURIComponent(E) + "=" + encodeURIComponent(_);
      }).join("&"), m = "https://" + e + "/oauth2/authorize?" + y;
      Qe.debug("Redirecting to " + m), this._urlOpener(m, i);
    }, n.prototype._handleCodeFlow = function(t) {
      return j(this, void 0, void 0, function() {
        var e, i, o, r, a, u, h, s, l, d, v, y, m, S, b, E;
        return K(this, function(_) {
          switch (_.label) {
            case 0:
              return e = (Be(t).query || "").split("&").map(function(T) {
                return T.split("=");
              }).reduce(function(T, x) {
                var D, O = Fe(x, 2), N = O[0], M = O[1];
                return ne(ne({}, T), (D = {}, D[N] = M, D));
              }, { code: void 0 }).code, i = Be(t).pathname || "/", o = Be(this._config.redirectSignIn).pathname || "/", !e || i !== o ? [
                2
                /*return*/
              ] : (r = "https://" + this._config.domain + "/oauth2/token", nn("codeFlow", {}, "Retrieving tokens from " + r), a = $e(this._config) ? this._cognitoClientId : this._config.clientID, u = $e(this._config) ? this._config.redirectSignIn : this._config.redirectUri, h = qu(), s = ne({
                grant_type: "authorization_code",
                code: e,
                client_id: a,
                redirect_uri: u
              }, h ? { code_verifier: h } : {}), Qe.debug("Calling token endpoint: " + r + " with", s), l = Object.entries(s).map(function(T) {
                var x = Fe(T, 2), D = x[0], O = x[1];
                return encodeURIComponent(D) + "=" + encodeURIComponent(O);
              }).join("&"), d = {
                category: on.Auth,
                action: sn.FederatedSignIn
              }, [4, fetch(r, {
                method: "POST",
                headers: (E = {
                  "Content-Type": "application/x-www-form-urlencoded"
                }, E[zs] = Un(d), E),
                body: l
              })]);
            case 1:
              return [4, _.sent().json()];
            case 2:
              if (v = _.sent(), y = v.access_token, m = v.refresh_token, S = v.id_token, b = v.error, b)
                throw new Error(b);
              return [2, {
                accessToken: y,
                refreshToken: m,
                idToken: S
              }];
          }
        });
      });
    }, n.prototype._handleImplicitFlow = function(t) {
      return j(this, void 0, void 0, function() {
        var e, i, o;
        return K(this, function(r) {
          return e = (Be(t).hash || "#").substr(1).split("&").map(function(a) {
            return a.split("=");
          }).reduce(function(a, u) {
            var h, s = Fe(u, 2), l = s[0], d = s[1];
            return ne(ne({}, a), (h = {}, h[l] = d, h));
          }, {
            id_token: void 0,
            access_token: void 0
          }), i = e.id_token, o = e.access_token, nn("implicitFlow", {}, "Got tokens from " + t), Qe.debug("Retrieving implicit tokens from " + t + " with"), [2, {
            accessToken: o,
            idToken: i,
            refreshToken: null
          }];
        });
      });
    }, n.prototype.handleAuthResponse = function(t) {
      return j(this, void 0, void 0, function() {
        var e, i, o, r, a, u, h;
        return K(this, function(s) {
          switch (s.label) {
            case 0:
              if (s.trys.push([0, 5, , 6]), e = t ? ne(ne({}, (Be(t).hash || "#").substr(1).split("&").map(function(l) {
                return l.split("=");
              }).reduce(function(l, d) {
                var v = Fe(d, 2), y = v[0], m = v[1];
                return l[y] = m, l;
              }, {})), (Be(t).query || "").split("&").map(function(l) {
                return l.split("=");
              }).reduce(function(l, d) {
                var v = Fe(d, 2), y = v[0], m = v[1];
                return l[y] = m, l;
              }, {})) : {}, i = e.error, o = e.error_description, i)
                throw new Error(o);
              return r = this._validateState(e), Qe.debug("Starting " + this._config.responseType + " flow with " + t), this._config.responseType !== "code" ? [3, 2] : (a = [{}], [4, this._handleCodeFlow(t)]);
            case 1:
              return [2, ne.apply(void 0, [ne.apply(void 0, a.concat([s.sent()])), { state: r }])];
            case 2:
              return u = [{}], [4, this._handleImplicitFlow(t)];
            case 3:
              return [2, ne.apply(void 0, [ne.apply(void 0, u.concat([s.sent()])), { state: r }])];
            case 4:
              return [3, 6];
            case 5:
              throw h = s.sent(), Qe.debug("Error handling auth response.", h), h;
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype._validateState = function(t) {
      if (t) {
        var e = Ku(), i = t.state;
        if (e && e !== i)
          throw new Error("Invalid state in OAuth flow");
        return i;
      }
    }, n.prototype.signOut = function() {
      return j(this, void 0, void 0, function() {
        var t, e, i;
        return K(this, function(o) {
          return t = "https://" + this._config.domain + "/logout?", e = $e(this._config) ? this._cognitoClientId : this._config.oauth.clientID, i = $e(this._config) ? this._config.redirectSignOut : this._config.returnTo, t += Object.entries({
            client_id: e,
            logout_uri: encodeURIComponent(i)
          }).map(function(r) {
            var a = Fe(r, 2), u = a[0], h = a[1];
            return u + "=" + h;
          }).join("&"), nn("oAuthSignOut", { oAuth: "signOut" }, "Signing out from " + t), Qe.debug("Signing out from " + t), [2, this._urlOpener(t, i)];
        });
      });
    }, n.prototype._generateState = function(t) {
      for (var e = "", i = t, o = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"; i > 0; --i)
        e += o[Math.round(Math.random() * (o.length - 1))];
      return e;
    }, n.prototype._generateChallenge = function(t) {
      var e = new We.Sha256();
      e.update(t);
      var i = e.digestSync(), o = G.Buffer.from(i).toString("base64"), r = this._base64URL(o);
      return r;
    }, n.prototype._base64URL = function(t) {
      return t.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }, n.prototype._generateRandom = function(t) {
      var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~", i = new Uint8Array(t);
      if (typeof window < "u" && window.crypto)
        window.crypto.getRandomValues(i);
      else
        for (var o = 0; o < t; o += 1)
          i[o] = Math.random() * e.length | 0;
      return this._bufferToString(i);
    }, n.prototype._bufferToString = function(t) {
      for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = [], o = 0; o < t.byteLength; o += 1) {
        var r = t[o] % e.length;
        i.push(e[r]);
      }
      return i.join("");
    }, n;
  }()
);
const $u = Gu, Wu = function(n) {
  if (Oe().isBrowser && window.location) {
    var t = window.location.href;
    n({ url: t });
  } else if (!Oe().isNode)
    throw new Error("Not supported");
};
var te;
(function(n) {
  n.DEFAULT_MSG = "Authentication Error", n.EMPTY_EMAIL = "Email cannot be empty", n.EMPTY_PHONE = "Phone number cannot be empty", n.EMPTY_USERNAME = "Username cannot be empty", n.INVALID_USERNAME = "The username should either be a string or one of the sign in types", n.EMPTY_PASSWORD = "Password cannot be empty", n.EMPTY_CODE = "Confirmation code cannot be empty", n.SIGN_UP_ERROR = "Error creating account", n.NO_MFA = "No valid MFA method provided", n.INVALID_MFA = "Invalid MFA type", n.EMPTY_CHALLENGE = "Challenge response cannot be empty", n.NO_USER_SESSION = "Failed to get the session because the user is empty", n.NETWORK_ERROR = "Network Error", n.DEVICE_CONFIG = "Device tracking has not been configured in this User Pool", n.AUTOSIGNIN_ERROR = "Please use your credentials to sign in";
})(te || (te = {}));
var Yu = new Ee("AuthError"), Me = (
  /** @class */
  function(n) {
    qr(t, n);
    function t(e) {
      var i = this, o = zu[e], r = o.message, a = o.log;
      return i = n.call(this, r) || this, i.constructor = t, Object.setPrototypeOf(i, t.prototype), i.name = "AuthError", i.log = a || r, Yu.error(i.log), i;
    }
    return t;
  }(Error)
), Ju = (
  /** @class */
  function(n) {
    qr(t, n);
    function t(e) {
      var i = n.call(this, e) || this;
      return i.constructor = t, Object.setPrototypeOf(i, t.prototype), i.name = "NoUserPoolError", i;
    }
    return t;
  }(Me)
), zu = {
  noConfig: {
    message: te.DEFAULT_MSG,
    log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
  },
  missingAuthConfig: {
    message: te.DEFAULT_MSG,
    log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
  },
  emptyUsername: {
    message: te.EMPTY_USERNAME
  },
  // TODO: should include a list of valid sign-in types
  invalidUsername: {
    message: te.INVALID_USERNAME
  },
  emptyPassword: {
    message: te.EMPTY_PASSWORD
  },
  emptyCode: {
    message: te.EMPTY_CODE
  },
  signUpError: {
    message: te.SIGN_UP_ERROR,
    log: "The first parameter should either be non-null string or object"
  },
  noMFA: {
    message: te.NO_MFA
  },
  invalidMFA: {
    message: te.INVALID_MFA
  },
  emptyChallengeResponse: {
    message: te.EMPTY_CHALLENGE
  },
  noUserSession: {
    message: te.NO_USER_SESSION
  },
  deviceConfig: {
    message: te.DEVICE_CONFIG
  },
  networkError: {
    message: te.NETWORK_ERROR
  },
  autoSignInError: {
    message: te.AUTOSIGNIN_ERROR
  },
  default: {
    message: te.DEFAULT_MSG
  }
}, I = new Ee("AuthClass"), mr = "aws.cognito.signin.user.admin", Zu = 10 * 1e3, Xu = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default", B = function(n, t, e) {
  xe.dispatch("auth", { event: n, data: t, message: e }, "Auth", Xu);
}, Qu = 60, ec = 3 * 60 * 1e3, tc = (
  /** @class */
  function() {
    function n(t) {
      var e = this;
      this.userPool = null, this.user = null, this.oAuthFlowInProgress = !1, this.autoSignInInitiated = !1, this.inflightSessionPromise = null, this.inflightSessionPromiseCounter = 0, this.Credentials = Kr, this.wrapRefreshSessionCallback = function(i) {
        var o = function(r, a) {
          return a ? B("tokenRefresh", void 0, "New token retrieved") : B("tokenRefresh_failure", r, "Failed to retrieve new token"), i(r, a);
        };
        return o;
      }, this.configure(t), this.currentCredentials = this.currentCredentials.bind(this), this.currentUserCredentials = this.currentUserCredentials.bind(this), xe.listen("auth", function(i) {
        var o = i.payload, r = o.event;
        switch (r) {
          case "verify":
          case "signIn":
            e._storage.setItem("amplify-signin-with-hostedUI", "false");
            break;
          case "signOut":
            e._storage.removeItem("amplify-signin-with-hostedUI");
            break;
          case "cognitoHostedUI":
            e._storage.setItem("amplify-signin-with-hostedUI", "true");
            break;
        }
      }), cu(), gr(Yt.framework), Yt.observeFrameworkChanges(function() {
        gr(Yt.framework);
      });
    }
    return n.prototype.getModuleName = function() {
      return "Auth";
    }, n.prototype.configure = function(t) {
      var e = this;
      if (!t)
        return this._config || {};
      I.debug("configure Auth");
      var i = Object.assign({}, this._config, Rr(t).Auth, t);
      this._config = i;
      var o = this._config, r = o.userPoolId, a = o.userPoolWebClientId, u = o.cookieStorage, h = o.oauth, s = o.region, l = o.identityPoolId, d = o.mandatorySignIn, v = o.refreshHandlers, y = o.identityPoolRegion, m = o.clientMetadata, S = o.endpoint, b = o.storage;
      if (!b)
        u ? this._storage = new bu(u) : this._storage = t.ssr ? new Ys() : new Dr().getStorage();
      else {
        if (!this._isValidAuthStorage(b))
          throw I.error("The storage in the Auth config is not valid!"), new Error("Empty storage object");
        this._storage = b;
      }
      if (this._storageSync = Promise.resolve(), typeof this._storage.sync == "function" && (this._storageSync = this._storage.sync()), r) {
        var E = {
          UserPoolId: r,
          ClientId: a,
          endpoint: S
        };
        E.Storage = this._storage, this.userPool = new _u(E, this.wrapRefreshSessionCallback);
      }
      this.Credentials.configure({
        mandatorySignIn: d,
        region: s,
        userPoolId: r,
        identityPoolId: l,
        refreshHandlers: v,
        storage: this._storage,
        identityPoolRegion: y
      });
      var _ = h ? $e(this._config.oauth) ? h : h.awsCognito : void 0;
      if (_) {
        var T = Object.assign({
          cognitoClientId: a,
          UserPoolId: r,
          domain: _.domain,
          scopes: _.scope,
          redirectSignIn: _.redirectSignIn,
          redirectSignOut: _.redirectSignOut,
          responseType: _.responseType,
          Storage: this._storage,
          urlOpener: _.urlOpener,
          clientMetadata: m
        }, _.options);
        this._oAuthHandler = new $u({
          scopes: T.scopes,
          config: T,
          cognitoClientId: T.cognitoClientId
        });
        var x = {};
        Wu(function(O) {
          var N = O.url;
          x[N] || (x[N] = !0, e._handleAuthResponse(N));
        });
      }
      if (B("configured", null, "The Auth category has been configured successfully"), !this.autoSignInInitiated && typeof this._storage.getItem == "function") {
        var D = this.isTrueStorageValue("amplify-polling-started");
        D && (B("autoSignIn_failure", null, V.AutoSignInError), this._storage.removeItem("amplify-auto-sign-in")), this._storage.removeItem("amplify-polling-started");
      }
      return this._config;
    }, n.prototype.signUp = function(t) {
      for (var e = this, i = [], o = 1; o < arguments.length; o++)
        i[o - 1] = arguments[o];
      var r, a, u;
      if (!this.userPool)
        return this.rejectNoUserPool();
      var h = null, s = null, l = [], d = null, v, y = { enabled: !1 }, m = {}, S = {};
      if (t && typeof t == "string") {
        h = t, s = i ? i[0] : null;
        var b = i ? i[1] : null, E = i ? i[2] : null;
        b && l.push(new et({ Name: "email", Value: b })), E && l.push(new et({
          Name: "phone_number",
          Value: E
        }));
      } else if (t && typeof t == "object") {
        h = t.username, s = t.password, t && t.clientMetadata ? v = t.clientMetadata : this._config.clientMetadata && (v = this._config.clientMetadata);
        var _ = t.attributes;
        _ && Object.keys(_).map(function(x) {
          l.push(new et({ Name: x, Value: _[x] }));
        });
        var T = t.validationData;
        T && (d = [], Object.keys(T).map(function(x) {
          d.push(new et({
            Name: x,
            Value: T[x]
          }));
        })), y = (r = t.autoSignIn) !== null && r !== void 0 ? r : { enabled: !1 }, y.enabled && (this._storage.setItem("amplify-auto-sign-in", "true"), m = (a = y.validationData) !== null && a !== void 0 ? a : {}, S = (u = y.clientMetaData) !== null && u !== void 0 ? u : {});
      } else
        return this.rejectAuthError(V.SignUpError);
      return h ? s ? (I.debug("signUp attrs:", l), I.debug("signUp validation data:", d), new Promise(function(x, D) {
        e.userPool.signUp(h, s, l, d, function(O, N) {
          O ? (B("signUp_failure", O, h + " failed to signup"), D(O)) : (B("signUp", N, h + " has signed up successfully"), y.enabled && e.handleAutoSignIn(h, s, m, S, N), x(N));
        }, v);
      })) : this.rejectAuthError(V.EmptyPassword) : this.rejectAuthError(V.EmptyUsername);
    }, n.prototype.handleAutoSignIn = function(t, e, i, o, r) {
      this.autoSignInInitiated = !0;
      var a = new ur({
        Username: t,
        Password: e,
        ValidationData: i,
        ClientMetadata: o
      });
      r.userConfirmed ? this.signInAfterUserConfirmed(a) : this._config.signUpVerificationMethod === "link" ? this.handleLinkAutoSignIn(a) : this.handleCodeAutoSignIn(a);
    }, n.prototype.handleCodeAutoSignIn = function(t) {
      var e = this, i = function(o) {
        var r = o.payload;
        r.event === "confirmSignUp" && e.signInAfterUserConfirmed(t, i);
      };
      xe.listen("auth", i);
    }, n.prototype.handleLinkAutoSignIn = function(t) {
      var e = this;
      this._storage.setItem("amplify-polling-started", "true");
      var i = Date.now(), o = setInterval(function() {
        Date.now() - i > ec ? (clearInterval(o), B("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in."), e._storage.removeItem("amplify-auto-sign-in")) : e.signInAfterUserConfirmed(t, null, o);
      }, 5e3);
    }, n.prototype.signInAfterUserConfirmed = function(t, e, i) {
      return j(this, void 0, void 0, function() {
        var o, r, a = this;
        return K(this, function(u) {
          switch (u.label) {
            case 0:
              o = this.createCognitoUser(t.getUsername()), u.label = 1;
            case 1:
              return u.trys.push([1, 3, , 4]), [4, o.authenticateUser(t, this.authCallbacks(o, function(h) {
                B("autoSignIn", h, t.getUsername() + " has signed in successfully"), e && xe.remove("auth", e), i && (clearInterval(i), a._storage.removeItem("amplify-polling-started")), a._storage.removeItem("amplify-auto-sign-in");
              }, function(h) {
                I.error(h), a._storage.removeItem("amplify-auto-sign-in");
              }))];
            case 2:
              return u.sent(), [3, 4];
            case 3:
              return r = u.sent(), I.error(r), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.confirmSignUp = function(t, e, i) {
      var o = this;
      if (!this.userPool)
        return this.rejectNoUserPool();
      if (!t)
        return this.rejectAuthError(V.EmptyUsername);
      if (!e)
        return this.rejectAuthError(V.EmptyCode);
      var r = this.createCognitoUser(t), a = i && typeof i.forceAliasCreation == "boolean" ? i.forceAliasCreation : !0, u;
      return i && i.clientMetadata ? u = i.clientMetadata : this._config.clientMetadata && (u = this._config.clientMetadata), new Promise(function(h, s) {
        r.confirmRegistration(e, a, function(l, d) {
          if (l)
            s(l);
          else {
            B("confirmSignUp", d, t + " has been confirmed successfully");
            var v = o.isTrueStorageValue("amplify-auto-sign-in");
            v && !o.autoSignInInitiated && (B("autoSignIn_failure", null, V.AutoSignInError), o._storage.removeItem("amplify-auto-sign-in")), h(d);
          }
        }, u);
      });
    }, n.prototype.isTrueStorageValue = function(t) {
      var e = this._storage.getItem(t);
      return e ? e === "true" : !1;
    }, n.prototype.resendSignUp = function(t, e) {
      if (e === void 0 && (e = this._config.clientMetadata), !this.userPool)
        return this.rejectNoUserPool();
      if (!t)
        return this.rejectAuthError(V.EmptyUsername);
      var i = this.createCognitoUser(t);
      return new Promise(function(o, r) {
        i.resendConfirmationCode(function(a, u) {
          a ? r(a) : o(u);
        }, e);
      });
    }, n.prototype.signIn = function(t, e, i) {
      if (i === void 0 && (i = this._config.clientMetadata), !this.userPool)
        return this.rejectNoUserPool();
      var o = null, r = null, a = {};
      if (typeof t == "string")
        o = t, r = e;
      else if (Qs(t))
        typeof e < "u" && I.warn("The password should be defined under the first parameter object!"), o = t.username, r = t.password, a = t.validationData;
      else
        return this.rejectAuthError(V.InvalidUsername);
      if (!o)
        return this.rejectAuthError(V.EmptyUsername);
      var u = new ur({
        Username: o,
        Password: r,
        ValidationData: a,
        ClientMetadata: i
      });
      return r ? this.signInWithPassword(u) : this.signInWithoutPassword(u);
    }, n.prototype.authCallbacks = function(t, e, i) {
      var o = this, r = this;
      return {
        onSuccess: function(a) {
          return j(o, void 0, void 0, function() {
            var u, h, s, l;
            return K(this, function(d) {
              switch (d.label) {
                case 0:
                  I.debug(a), delete t.challengeName, delete t.challengeParam, d.label = 1;
                case 1:
                  return d.trys.push([1, 4, 5, 9]), [4, this.Credentials.clear()];
                case 2:
                  return d.sent(), [4, this.Credentials.set(a, "session")];
                case 3:
                  return u = d.sent(), I.debug("succeed to get cognito credentials", u), [3, 9];
                case 4:
                  return h = d.sent(), I.debug("cannot get cognito credentials", h), [3, 9];
                case 5:
                  return d.trys.push([5, 7, , 8]), [4, this.currentUserPoolUser()];
                case 6:
                  return s = d.sent(), r.user = s, B("signIn", s, "A user " + t.getUsername() + " has been signed in"), e(s), [3, 8];
                case 7:
                  return l = d.sent(), I.error("Failed to get the signed in user", l), i(l), [3, 8];
                case 8:
                  return [
                    7
                    /*endfinally*/
                  ];
                case 9:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        },
        onFailure: function(a) {
          I.debug("signIn failure", a), B("signIn_failure", a, t.getUsername() + " failed to signin"), i(a);
        },
        customChallenge: function(a) {
          I.debug("signIn custom challenge answer required"), t.challengeName = "CUSTOM_CHALLENGE", t.challengeParam = a, e(t);
        },
        mfaRequired: function(a, u) {
          I.debug("signIn MFA required"), t.challengeName = a, t.challengeParam = u, e(t);
        },
        mfaSetup: function(a, u) {
          I.debug("signIn mfa setup", a), t.challengeName = a, t.challengeParam = u, e(t);
        },
        newPasswordRequired: function(a, u) {
          I.debug("signIn new password"), t.challengeName = "NEW_PASSWORD_REQUIRED", t.challengeParam = {
            userAttributes: a,
            requiredAttributes: u
          }, e(t);
        },
        totpRequired: function(a, u) {
          I.debug("signIn totpRequired"), t.challengeName = a, t.challengeParam = u, e(t);
        },
        selectMFAType: function(a, u) {
          I.debug("signIn selectMFAType", a), t.challengeName = a, t.challengeParam = u, e(t);
        }
      };
    }, n.prototype.signInWithPassword = function(t) {
      var e = this;
      if (this.pendingSignIn)
        throw new Error("Pending sign-in attempt already in progress");
      var i = this.createCognitoUser(t.getUsername());
      return this.pendingSignIn = new Promise(function(o, r) {
        i.authenticateUser(t, e.authCallbacks(i, function(a) {
          e.pendingSignIn = null, o(a);
        }, function(a) {
          e.pendingSignIn = null, r(a);
        }));
      }), this.pendingSignIn;
    }, n.prototype.signInWithoutPassword = function(t) {
      var e = this, i = this.createCognitoUser(t.getUsername());
      return i.setAuthenticationFlowType("CUSTOM_AUTH"), new Promise(function(o, r) {
        i.initiateAuth(t, e.authCallbacks(i, o, r));
      });
    }, n.prototype.getMFAOptions = function(t) {
      return new Promise(function(e, i) {
        t.getMFAOptions(function(o, r) {
          if (o) {
            I.debug("get MFA Options failed", o), i(o);
            return;
          }
          I.debug("get MFA options success", r), e(r);
        });
      });
    }, n.prototype.getPreferredMFA = function(t, e) {
      var i = this, o = this;
      return new Promise(function(r, a) {
        var u = i._config.clientMetadata, h = e ? e.bypassCache : !1;
        t.getUserData(function(s, l) {
          return j(i, void 0, void 0, function() {
            var d, v;
            return K(this, function(y) {
              switch (y.label) {
                case 0:
                  if (!s)
                    return [3, 5];
                  if (I.debug("getting preferred mfa failed", s), !this.isSessionInvalid(s))
                    return [3, 4];
                  y.label = 1;
                case 1:
                  return y.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(t)];
                case 2:
                  return y.sent(), [3, 4];
                case 3:
                  return d = y.sent(), a(new Error("Session is invalid due to: " + s.message + " and failed to clean up invalid session: " + d.message)), [
                    2
                    /*return*/
                  ];
                case 4:
                  return a(s), [
                    2
                    /*return*/
                  ];
                case 5:
                  return v = o._getMfaTypeFromUserData(l), v ? (r(v), [
                    2
                    /*return*/
                  ]) : (a("invalid MFA Type"), [
                    2
                    /*return*/
                  ]);
              }
            });
          });
        }, { bypassCache: h, clientMetadata: u });
      });
    }, n.prototype._getMfaTypeFromUserData = function(t) {
      var e = null, i = t.PreferredMfaSetting;
      if (i)
        e = i;
      else {
        var o = t.UserMFASettingList;
        if (o)
          o.length === 0 ? e = "NOMFA" : I.debug("invalid case for getPreferredMFA", t);
        else {
          var r = t.MFAOptions;
          r ? e = "SMS_MFA" : e = "NOMFA";
        }
      }
      return e;
    }, n.prototype._getUserData = function(t, e) {
      var i = this;
      return new Promise(function(o, r) {
        t.getUserData(function(a, u) {
          return j(i, void 0, void 0, function() {
            var h;
            return K(this, function(s) {
              switch (s.label) {
                case 0:
                  if (!a)
                    return [3, 5];
                  if (I.debug("getting user data failed", a), !this.isSessionInvalid(a))
                    return [3, 4];
                  s.label = 1;
                case 1:
                  return s.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(t)];
                case 2:
                  return s.sent(), [3, 4];
                case 3:
                  return h = s.sent(), r(new Error("Session is invalid due to: " + a.message + " and failed to clean up invalid session: " + h.message)), [
                    2
                    /*return*/
                  ];
                case 4:
                  return r(a), [
                    2
                    /*return*/
                  ];
                case 5:
                  o(u), s.label = 6;
                case 6:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, e);
      });
    }, n.prototype.setPreferredMFA = function(t, e) {
      return j(this, void 0, void 0, function() {
        var i, o, r, a, u, h, s, l = this;
        return K(this, function(d) {
          switch (d.label) {
            case 0:
              return i = this._config.clientMetadata, [4, this._getUserData(t, {
                bypassCache: !0,
                clientMetadata: i
              })];
            case 1:
              switch (o = d.sent(), r = null, a = null, u = e, u) {
                case "TOTP":
                  return [3, 2];
                case "SOFTWARE_TOKEN_MFA":
                  return [3, 2];
                case "SMS":
                  return [3, 3];
                case "SMS_MFA":
                  return [3, 3];
                case "NOMFA":
                  return [3, 4];
              }
              return [3, 6];
            case 2:
              return a = {
                PreferredMfa: !0,
                Enabled: !0
              }, [3, 7];
            case 3:
              return r = {
                PreferredMfa: !0,
                Enabled: !0
              }, [3, 7];
            case 4:
              return h = o.UserMFASettingList, [4, this._getMfaTypeFromUserData(o)];
            case 5:
              if (s = d.sent(), s === "NOMFA")
                return [2, Promise.resolve("No change for mfa type")];
              if (s === "SMS_MFA")
                r = {
                  PreferredMfa: !1,
                  Enabled: !1
                };
              else if (s === "SOFTWARE_TOKEN_MFA")
                a = {
                  PreferredMfa: !1,
                  Enabled: !1
                };
              else
                return [2, this.rejectAuthError(V.InvalidMFA)];
              return h && h.length !== 0 && h.forEach(function(v) {
                v === "SMS_MFA" ? r = {
                  PreferredMfa: !1,
                  Enabled: !1
                } : v === "SOFTWARE_TOKEN_MFA" && (a = {
                  PreferredMfa: !1,
                  Enabled: !1
                });
              }), [3, 7];
            case 6:
              return I.debug("no validmfa method provided"), [2, this.rejectAuthError(V.NoMFA)];
            case 7:
              return [2, new Promise(function(v, y) {
                t.setUserMfaPreference(r, a, function(m, S) {
                  if (m)
                    return I.debug("Set user mfa preference error", m), y(m);
                  I.debug("Set user mfa success", S), I.debug("Caching the latest user data into local"), t.getUserData(function(b, E) {
                    return j(l, void 0, void 0, function() {
                      var _;
                      return K(this, function(T) {
                        switch (T.label) {
                          case 0:
                            if (!b)
                              return [3, 5];
                            if (I.debug("getting user data failed", b), !this.isSessionInvalid(b))
                              return [3, 4];
                            T.label = 1;
                          case 1:
                            return T.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(t)];
                          case 2:
                            return T.sent(), [3, 4];
                          case 3:
                            return _ = T.sent(), y(new Error("Session is invalid due to: " + b.message + " and failed to clean up invalid session: " + _.message)), [
                              2
                              /*return*/
                            ];
                          case 4:
                            return [2, y(b)];
                          case 5:
                            return [2, v(S)];
                        }
                      });
                    });
                  }, {
                    bypassCache: !0,
                    clientMetadata: i
                  });
                });
              })];
          }
        });
      });
    }, n.prototype.disableSMS = function(t) {
      return new Promise(function(e, i) {
        t.disableMFA(function(o, r) {
          if (o) {
            I.debug("disable mfa failed", o), i(o);
            return;
          }
          I.debug("disable mfa succeed", r), e(r);
        });
      });
    }, n.prototype.enableSMS = function(t) {
      return new Promise(function(e, i) {
        t.enableMFA(function(o, r) {
          if (o) {
            I.debug("enable mfa failed", o), i(o);
            return;
          }
          I.debug("enable mfa succeed", r), e(r);
        });
      });
    }, n.prototype.setupTOTP = function(t) {
      return new Promise(function(e, i) {
        t.associateSoftwareToken({
          onFailure: function(o) {
            I.debug("associateSoftwareToken failed", o), i(o);
          },
          associateSecretCode: function(o) {
            I.debug("associateSoftwareToken success", o), e(o);
          }
        });
      });
    }, n.prototype.verifyTotpToken = function(t, e) {
      I.debug("verification totp token", t, e);
      var i;
      t && typeof t.getSignInUserSession == "function" && (i = t.getSignInUserSession());
      var o = i == null ? void 0 : i.isValid();
      return new Promise(function(r, a) {
        t.verifySoftwareToken(e, "My TOTP device", {
          onFailure: function(u) {
            I.debug("verifyTotpToken failed", u), a(u);
          },
          onSuccess: function(u) {
            o || B("signIn", t, "A user " + t.getUsername() + " has been signed in"), B("verify", t, "A user " + t.getUsername() + " has been verified"), I.debug("verifyTotpToken success", u), r(u);
          }
        });
      });
    }, n.prototype.confirmSignIn = function(t, e, i, o) {
      var r = this;
      if (o === void 0 && (o = this._config.clientMetadata), !e)
        return this.rejectAuthError(V.EmptyCode);
      var a = this;
      return new Promise(function(u, h) {
        t.sendMFACode(e, {
          onSuccess: function(s) {
            return j(r, void 0, void 0, function() {
              var l, d, v, y;
              return K(this, function(m) {
                switch (m.label) {
                  case 0:
                    I.debug(s), m.label = 1;
                  case 1:
                    return m.trys.push([1, 4, 5, 10]), [4, this.Credentials.clear()];
                  case 2:
                    return m.sent(), [4, this.Credentials.set(s, "session")];
                  case 3:
                    return l = m.sent(), I.debug("succeed to get cognito credentials", l), [3, 10];
                  case 4:
                    return d = m.sent(), I.debug("cannot get cognito credentials", d), [3, 10];
                  case 5:
                    a.user = t, m.label = 6;
                  case 6:
                    return m.trys.push([6, 8, , 9]), [4, this.currentUserPoolUser()];
                  case 7:
                    return v = m.sent(), t.attributes = v.attributes, [3, 9];
                  case 8:
                    return y = m.sent(), I.debug("cannot get updated Cognito User", y), [3, 9];
                  case 9:
                    return B("signIn", t, "A user " + t.getUsername() + " has been signed in"), u(t), [
                      7
                      /*endfinally*/
                    ];
                  case 10:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          },
          onFailure: function(s) {
            I.debug("confirm signIn failure", s), h(s);
          }
        }, i, o);
      });
    }, n.prototype.completeNewPassword = function(t, e, i, o) {
      var r = this;
      if (i === void 0 && (i = {}), o === void 0 && (o = this._config.clientMetadata), !e)
        return this.rejectAuthError(V.EmptyPassword);
      var a = this;
      return new Promise(function(u, h) {
        t.completeNewPasswordChallenge(e, i, {
          onSuccess: function(s) {
            return j(r, void 0, void 0, function() {
              var l, d;
              return K(this, function(v) {
                switch (v.label) {
                  case 0:
                    I.debug(s), v.label = 1;
                  case 1:
                    return v.trys.push([1, 4, 5, 6]), [4, this.Credentials.clear()];
                  case 2:
                    return v.sent(), [4, this.Credentials.set(s, "session")];
                  case 3:
                    return l = v.sent(), I.debug("succeed to get cognito credentials", l), [3, 6];
                  case 4:
                    return d = v.sent(), I.debug("cannot get cognito credentials", d), [3, 6];
                  case 5:
                    return a.user = t, B("signIn", t, "A user " + t.getUsername() + " has been signed in"), u(t), [
                      7
                      /*endfinally*/
                    ];
                  case 6:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          },
          onFailure: function(s) {
            I.debug("completeNewPassword failure", s), B("completeNewPassword_failure", s, r.user + " failed to complete the new password flow"), h(s);
          },
          mfaRequired: function(s, l) {
            I.debug("signIn MFA required"), t.challengeName = s, t.challengeParam = l, u(t);
          },
          mfaSetup: function(s, l) {
            I.debug("signIn mfa setup", s), t.challengeName = s, t.challengeParam = l, u(t);
          },
          totpRequired: function(s, l) {
            I.debug("signIn mfa setup", s), t.challengeName = s, t.challengeParam = l, u(t);
          }
        }, o);
      });
    }, n.prototype.sendCustomChallengeAnswer = function(t, e, i) {
      var o = this;
      return i === void 0 && (i = this._config.clientMetadata), this.userPool ? e ? new Promise(function(r, a) {
        t.sendCustomChallengeAnswer(e, o.authCallbacks(t, r, a), i);
      }) : this.rejectAuthError(V.EmptyChallengeResponse) : this.rejectNoUserPool();
    }, n.prototype.deleteUserAttributes = function(t, e) {
      var i = this;
      return new Promise(function(o, r) {
        i.userSession(t).then(function(a) {
          t.deleteAttributes(e, function(u, h) {
            return u ? r(u) : o(h);
          });
        });
      });
    }, n.prototype.deleteUser = function() {
      return j(this, void 0, void 0, function() {
        var t, e, i = this;
        return K(this, function(o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 2, , 3]), [4, this._storageSync];
            case 1:
              return o.sent(), [3, 3];
            case 2:
              throw t = o.sent(), I.debug("Failed to sync cache info into memory", t), new Error(t);
            case 3:
              return e = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true", [2, new Promise(function(r, a) {
                return j(i, void 0, void 0, function() {
                  var u, h = this;
                  return K(this, function(s) {
                    if (this.userPool)
                      if (u = this.userPool.getCurrentUser(), u)
                        u.getSession(function(l, d) {
                          return j(h, void 0, void 0, function() {
                            var v, y = this;
                            return K(this, function(m) {
                              switch (m.label) {
                                case 0:
                                  if (!l)
                                    return [3, 5];
                                  if (I.debug("Failed to get the user session", l), !this.isSessionInvalid(l))
                                    return [3, 4];
                                  m.label = 1;
                                case 1:
                                  return m.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(u)];
                                case 2:
                                  return m.sent(), [3, 4];
                                case 3:
                                  return v = m.sent(), a(new Error("Session is invalid due to: " + l.message + " and failed to clean up invalid session: " + v.message)), [
                                    2
                                    /*return*/
                                  ];
                                case 4:
                                  return [2, a(l)];
                                case 5:
                                  u.deleteUser(function(S, b) {
                                    if (S)
                                      a(S);
                                    else {
                                      B("userDeleted", b, "The authenticated user has been deleted."), u.signOut(), y.user = null;
                                      try {
                                        y.cleanCachedItems();
                                      } catch {
                                        I.debug("failed to clear cached items");
                                      }
                                      e ? y.oAuthSignOutRedirect(r, a) : (B("signOut", y.user, "A user has been signed out"), r(b));
                                    }
                                  }), m.label = 6;
                                case 6:
                                  return [
                                    2
                                    /*return*/
                                  ];
                              }
                            });
                          });
                        });
                      else
                        return I.debug("Failed to get user from user pool"), [2, a(new Error("No current user."))];
                    else
                      I.debug("no Congito User pool"), a(new Error("Cognito User pool does not exist"));
                    return [
                      2
                      /*return*/
                    ];
                  });
                });
              })];
          }
        });
      });
    }, n.prototype.updateUserAttributes = function(t, e, i) {
      var o = this;
      i === void 0 && (i = this._config.clientMetadata);
      var r = [], a = this;
      return new Promise(function(u, h) {
        a.userSession(t).then(function(s) {
          for (var l in e)
            if (l !== "sub" && l.indexOf("_verified") < 0) {
              var d = {
                Name: l,
                Value: e[l]
              };
              r.push(d);
            }
          t.updateAttributes(r, function(v, y, m) {
            if (v)
              return B("updateUserAttributes_failure", v, "Failed to update attributes"), h(v);
            var S = o.createUpdateAttributesResultList(e, m == null ? void 0 : m.CodeDeliveryDetailsList);
            return B("updateUserAttributes", S, "Attributes successfully updated"), u(y);
          }, i);
        });
      });
    }, n.prototype.createUpdateAttributesResultList = function(t, e) {
      var i = {};
      return Object.keys(t).forEach(function(o) {
        i[o] = {
          isUpdated: !0
        };
        var r = e == null ? void 0 : e.find(function(a) {
          return a.AttributeName === o;
        });
        r && (i[o].isUpdated = !1, i[o].codeDeliveryDetails = r);
      }), i;
    }, n.prototype.userAttributes = function(t) {
      var e = this;
      return new Promise(function(i, o) {
        e.userSession(t).then(function(r) {
          t.getUserAttributes(function(a, u) {
            a ? o(a) : i(u);
          });
        });
      });
    }, n.prototype.verifiedContact = function(t) {
      var e = this;
      return this.userAttributes(t).then(function(i) {
        var o = e.attributesToObject(i), r = {}, a = {};
        return o.email && (o.email_verified ? a.email = o.email : r.email = o.email), o.phone_number && (o.phone_number_verified ? a.phone_number = o.phone_number : r.phone_number = o.phone_number), {
          verified: a,
          unverified: r
        };
      });
    }, n.prototype.isErrorWithMessage = function(t) {
      return typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "message");
    }, n.prototype.isTokenRevokedError = function(t) {
      return this.isErrorWithMessage(t) && t.message === "Access Token has been revoked";
    }, n.prototype.isRefreshTokenRevokedError = function(t) {
      return this.isErrorWithMessage(t) && t.message === "Refresh Token has been revoked";
    }, n.prototype.isUserDisabledError = function(t) {
      return this.isErrorWithMessage(t) && t.message === "User is disabled.";
    }, n.prototype.isUserDoesNotExistError = function(t) {
      return this.isErrorWithMessage(t) && t.message === "User does not exist.";
    }, n.prototype.isRefreshTokenExpiredError = function(t) {
      return this.isErrorWithMessage(t) && t.message === "Refresh Token has expired";
    }, n.prototype.isPasswordResetRequiredError = function(t) {
      return this.isErrorWithMessage(t) && t.message === "Password reset required for the user";
    }, n.prototype.isSignedInHostedUI = function() {
      return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    }, n.prototype.isSessionInvalid = function(t) {
      return this.isUserDisabledError(t) || this.isUserDoesNotExistError(t) || this.isTokenRevokedError(t) || this.isRefreshTokenRevokedError(t) || this.isRefreshTokenExpiredError(t) || this.isPasswordResetRequiredError(t);
    }, n.prototype.cleanUpInvalidSession = function(t) {
      return j(this, void 0, void 0, function() {
        var e = this;
        return K(this, function(i) {
          switch (i.label) {
            case 0:
              t.signOut(), this.user = null, i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, this.cleanCachedItems()];
            case 2:
              return i.sent(), [3, 4];
            case 3:
              return i.sent(), I.debug("failed to clear cached items"), [3, 4];
            case 4:
              return this.isSignedInHostedUI() ? [2, new Promise(function(o, r) {
                e.oAuthSignOutRedirect(o, r);
              })] : (B("signOut", this.user, "A user has been signed out"), [
                2
                /*return*/
              ]);
          }
        });
      });
    }, n.prototype.currentUserPoolUser = function(t) {
      var e = this;
      return this.userPool ? new Promise(function(i, o) {
        e._storageSync.then(function() {
          return j(e, void 0, void 0, function() {
            var r, a, u, h, s, l, d, v = this;
            return K(this, function(y) {
              switch (y.label) {
                case 0:
                  return this.isOAuthInProgress() ? (I.debug("OAuth signIn in progress, waiting for resolution..."), [4, new Promise(function(m) {
                    var S = setTimeout(function() {
                      I.debug("OAuth signIn in progress timeout"), xe.remove("auth", b), m();
                    }, Zu);
                    xe.listen("auth", b);
                    function b(E) {
                      var _ = E.payload, T = _.event;
                      (T === "cognitoHostedUI" || T === "cognitoHostedUI_failure") && (I.debug("OAuth signIn resolved: " + T), clearTimeout(S), xe.remove("auth", b), m());
                    }
                  })]) : [3, 2];
                case 1:
                  y.sent(), y.label = 2;
                case 2:
                  if (r = this.userPool.getCurrentUser(), !r)
                    return I.debug("Failed to get user from user pool"), o("No current user"), [
                      2
                      /*return*/
                    ];
                  y.label = 3;
                case 3:
                  return y.trys.push([3, 7, , 8]), [4, this._userSession(r)];
                case 4:
                  return a = y.sent(), u = t ? t.bypassCache : !1, u ? [4, this.Credentials.clear()] : [3, 6];
                case 5:
                  y.sent(), y.label = 6;
                case 6:
                  if (h = this._config.clientMetadata, s = a.getAccessToken().decodePayload().scope, l = s === void 0 ? "" : s, l.split(" ").includes(mr))
                    r.getUserData(function(m, S) {
                      return j(v, void 0, void 0, function() {
                        var b, E, _, T, x, D, O;
                        return K(this, function(N) {
                          switch (N.label) {
                            case 0:
                              if (!m)
                                return [3, 7];
                              if (I.debug("getting user data failed", m), !this.isSessionInvalid(m))
                                return [3, 5];
                              N.label = 1;
                            case 1:
                              return N.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(r)];
                            case 2:
                              return N.sent(), [3, 4];
                            case 3:
                              return b = N.sent(), o(new Error("Session is invalid due to: " + m.message + " and failed to clean up invalid session: " + b.message)), [
                                2
                                /*return*/
                              ];
                            case 4:
                              return o(m), [3, 6];
                            case 5:
                              i(r), N.label = 6;
                            case 6:
                              return [
                                2
                                /*return*/
                              ];
                            case 7:
                              for (E = S.PreferredMfaSetting || "NOMFA", _ = [], T = 0; T < S.UserAttributes.length; T++)
                                x = {
                                  Name: S.UserAttributes[T].Name,
                                  Value: S.UserAttributes[T].Value
                                }, D = new et(x), _.push(D);
                              return O = this.attributesToObject(_), Object.assign(r, { attributes: O, preferredMFA: E }), [2, i(r)];
                          }
                        });
                      });
                    }, { bypassCache: u, clientMetadata: h });
                  else
                    return I.debug("Unable to get the user data because the " + mr + " is not in the scopes of the access token"), [2, i(r)];
                  return [3, 8];
                case 7:
                  return d = y.sent(), o(d), [3, 8];
                case 8:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }).catch(function(r) {
          return I.debug("Failed to sync cache info into memory", r), o(r);
        });
      }) : this.rejectNoUserPool();
    }, n.prototype.isOAuthInProgress = function() {
      return this.oAuthFlowInProgress;
    }, n.prototype.currentAuthenticatedUser = function(t) {
      return j(this, void 0, void 0, function() {
        var e, i, o, r, a;
        return K(this, function(u) {
          switch (u.label) {
            case 0:
              I.debug("getting current authenticated user"), e = null, u.label = 1;
            case 1:
              return u.trys.push([1, 3, , 4]), [4, this._storageSync];
            case 2:
              return u.sent(), [3, 4];
            case 3:
              throw i = u.sent(), I.debug("Failed to sync cache info into memory", i), i;
            case 4:
              try {
                o = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")), o && (e = ne(ne({}, o.user), { token: o.token }));
              } catch {
                I.debug("cannot load federated user from auth storage");
              }
              return e ? (this.user = e, I.debug("get current authenticated federated user", this.user), [2, this.user]) : [3, 5];
            case 5:
              I.debug("get current authenticated userpool user"), r = null, u.label = 6;
            case 6:
              return u.trys.push([6, 8, , 9]), [4, this.currentUserPoolUser(t)];
            case 7:
              return r = u.sent(), [3, 9];
            case 8:
              return a = u.sent(), a === "No userPool" && I.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID"), I.debug("The user is not authenticated by the error", a), [2, Promise.reject("The user is not authenticated")];
            case 9:
              return this.user = r, [2, this.user];
          }
        });
      });
    }, n.prototype.currentSession = function() {
      var t = this;
      return I.debug("Getting current session"), this.userPool ? new Promise(function(e, i) {
        t.currentUserPoolUser().then(function(o) {
          t.userSession(o).then(function(r) {
            e(r);
          }).catch(function(r) {
            I.debug("Failed to get the current session", r), i(r);
          });
        }).catch(function(o) {
          I.debug("Failed to get the current user", o), i(o);
        });
      }) : Promise.reject(new Error("No User Pool in the configuration."));
    }, n.prototype._userSession = function(t) {
      return j(this, void 0, void 0, function() {
        var e, i, o = this;
        return K(this, function(r) {
          switch (r.label) {
            case 0:
              if (!t)
                return I.debug("the user is null"), [2, this.rejectAuthError(V.NoUserSession)];
              e = this._config.clientMetadata, this.inflightSessionPromiseCounter === 0 && (this.inflightSessionPromise = new Promise(function(a, u) {
                t.getSession(function(h, s) {
                  return j(o, void 0, void 0, function() {
                    var l;
                    return K(this, function(d) {
                      switch (d.label) {
                        case 0:
                          if (!h)
                            return [3, 5];
                          if (I.debug("Failed to get the session from user", t), !this.isSessionInvalid(h))
                            return [3, 4];
                          d.label = 1;
                        case 1:
                          return d.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(t)];
                        case 2:
                          return d.sent(), [3, 4];
                        case 3:
                          return l = d.sent(), u(new Error("Session is invalid due to: " + h.message + " and failed to clean up invalid session: " + l.message)), [
                            2
                            /*return*/
                          ];
                        case 4:
                          return u(h), [
                            2
                            /*return*/
                          ];
                        case 5:
                          return I.debug("Succeed to get the user session", s), a(s), [
                            2
                            /*return*/
                          ];
                      }
                    });
                  });
                }, { clientMetadata: e });
              })), this.inflightSessionPromiseCounter++, r.label = 1;
            case 1:
              return r.trys.push([1, , 3, 4]), [4, this.inflightSessionPromise];
            case 2:
              return i = r.sent(), t.signInUserSession = i, [2, i];
            case 3:
              return this.inflightSessionPromiseCounter--, [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.userSession = function(t) {
      return this._userSession(t);
    }, n.prototype.currentUserCredentials = function() {
      return j(this, void 0, void 0, function() {
        var t, e, i = this;
        return K(this, function(o) {
          switch (o.label) {
            case 0:
              I.debug("Getting current user credentials"), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this._storageSync];
            case 2:
              return o.sent(), [3, 4];
            case 3:
              throw t = o.sent(), I.debug("Failed to sync cache info into memory", t), t;
            case 4:
              e = null;
              try {
                e = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
              } catch (r) {
                I.debug("failed to get or parse item aws-amplify-federatedInfo", r);
              }
              return e ? [2, this.Credentials.refreshFederatedToken(e)] : [2, this.currentSession().then(function(r) {
                return I.debug("getting session success", r), i.Credentials.set(r, "session");
              }).catch(function() {
                return I.debug("getting guest credentials"), i.Credentials.set(null, "guest");
              })];
          }
        });
      });
    }, n.prototype.currentCredentials = function() {
      return I.debug("getting current credentials"), this.Credentials.get();
    }, n.prototype.verifyUserAttribute = function(t, e, i) {
      return i === void 0 && (i = this._config.clientMetadata), new Promise(function(o, r) {
        t.getAttributeVerificationCode(e, {
          onSuccess: function(a) {
            return o(a);
          },
          onFailure: function(a) {
            return r(a);
          }
        }, i);
      });
    }, n.prototype.verifyUserAttributeSubmit = function(t, e, i) {
      return i ? new Promise(function(o, r) {
        t.verifyAttribute(e, i, {
          onSuccess: function(a) {
            o(a);
          },
          onFailure: function(a) {
            r(a);
          }
        });
      }) : this.rejectAuthError(V.EmptyCode);
    }, n.prototype.verifyCurrentUserAttribute = function(t) {
      var e = this;
      return e.currentUserPoolUser().then(function(i) {
        return e.verifyUserAttribute(i, t);
      });
    }, n.prototype.verifyCurrentUserAttributeSubmit = function(t, e) {
      var i = this;
      return i.currentUserPoolUser().then(function(o) {
        return i.verifyUserAttributeSubmit(o, t, e);
      });
    }, n.prototype.cognitoIdentitySignOut = function(t, e) {
      return j(this, void 0, void 0, function() {
        var i, o, r = this;
        return K(this, function(a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 2, , 3]), [4, this._storageSync];
            case 1:
              return a.sent(), [3, 3];
            case 2:
              throw i = a.sent(), I.debug("Failed to sync cache info into memory", i), i;
            case 3:
              return o = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true", [2, new Promise(function(u, h) {
                if (t && t.global) {
                  I.debug("user global sign out", e);
                  var s = r._config.clientMetadata;
                  e.getSession(function(l, d) {
                    return j(r, void 0, void 0, function() {
                      var v, y = this;
                      return K(this, function(m) {
                        switch (m.label) {
                          case 0:
                            if (!l)
                              return [3, 5];
                            if (I.debug("failed to get the user session", l), !this.isSessionInvalid(l))
                              return [3, 4];
                            m.label = 1;
                          case 1:
                            return m.trys.push([1, 3, , 4]), [4, this.cleanUpInvalidSession(e)];
                          case 2:
                            return m.sent(), [3, 4];
                          case 3:
                            return v = m.sent(), h(new Error("Session is invalid due to: " + l.message + " and failed to clean up invalid session: " + v.message)), [
                              2
                              /*return*/
                            ];
                          case 4:
                            return [2, h(l)];
                          case 5:
                            return e.globalSignOut({
                              onSuccess: function(S) {
                                if (I.debug("global sign out success"), o)
                                  y.oAuthSignOutRedirect(u, h);
                                else
                                  return u();
                              },
                              onFailure: function(S) {
                                return I.debug("global sign out failed", S), h(S);
                              }
                            }), [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  }, { clientMetadata: s });
                } else
                  I.debug("user sign out", e), e.signOut(function() {
                    if (o)
                      r.oAuthSignOutRedirect(u, h);
                    else
                      return u();
                  });
              })];
          }
        });
      });
    }, n.prototype.oAuthSignOutRedirect = function(t, e) {
      var i = Oe().isBrowser;
      i ? this.oAuthSignOutRedirectOrReject(e) : this.oAuthSignOutAndResolve(t);
    }, n.prototype.oAuthSignOutAndResolve = function(t) {
      this._oAuthHandler.signOut(), t();
    }, n.prototype.oAuthSignOutRedirectOrReject = function(t) {
      this._oAuthHandler.signOut(), setTimeout(function() {
        return t(Error("Signout timeout fail"));
      }, 3e3);
    }, n.prototype.signOut = function(t) {
      return j(this, void 0, void 0, function() {
        var e;
        return K(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), [4, this.cleanCachedItems()];
            case 1:
              return i.sent(), [3, 3];
            case 2:
              return i.sent(), I.debug("failed to clear cached items"), [3, 3];
            case 3:
              return this.userPool ? (e = this.userPool.getCurrentUser(), e ? [4, this.cognitoIdentitySignOut(t, e)] : [3, 5]) : [3, 7];
            case 4:
              return i.sent(), [3, 6];
            case 5:
              I.debug("no current Cognito user"), i.label = 6;
            case 6:
              return [3, 8];
            case 7:
              I.debug("no Cognito User pool"), i.label = 8;
            case 8:
              return B("signOut", this.user, "A user has been signed out"), this.user = null, [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.cleanCachedItems = function() {
      return j(this, void 0, void 0, function() {
        return K(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.Credentials.clear()];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.changePassword = function(t, e, i, o) {
      var r = this;
      return o === void 0 && (o = this._config.clientMetadata), new Promise(function(a, u) {
        r.userSession(t).then(function(h) {
          t.changePassword(e, i, function(s, l) {
            return s ? (I.debug("change password failure", s), u(s)) : a(l);
          }, o);
        });
      });
    }, n.prototype.forgotPassword = function(t, e) {
      if (e === void 0 && (e = this._config.clientMetadata), !this.userPool)
        return this.rejectNoUserPool();
      if (!t)
        return this.rejectAuthError(V.EmptyUsername);
      var i = this.createCognitoUser(t);
      return new Promise(function(o, r) {
        i.forgotPassword({
          onSuccess: function() {
            o();
          },
          onFailure: function(a) {
            I.debug("forgot password failure", a), B("forgotPassword_failure", a, t + " forgotPassword failed"), r(a);
          },
          inputVerificationCode: function(a) {
            B("forgotPassword", i, t + " has initiated forgot password flow"), o(a);
          }
        }, e);
      });
    }, n.prototype.forgotPasswordSubmit = function(t, e, i, o) {
      if (o === void 0 && (o = this._config.clientMetadata), !this.userPool)
        return this.rejectNoUserPool();
      if (!t)
        return this.rejectAuthError(V.EmptyUsername);
      if (!e)
        return this.rejectAuthError(V.EmptyCode);
      if (!i)
        return this.rejectAuthError(V.EmptyPassword);
      var r = this.createCognitoUser(t);
      return new Promise(function(a, u) {
        r.confirmPassword(e, i, {
          onSuccess: function(h) {
            B("forgotPasswordSubmit", r, t + " forgotPasswordSubmit successful"), a(h);
          },
          onFailure: function(h) {
            B("forgotPasswordSubmit_failure", h, t + " forgotPasswordSubmit failed"), u(h);
          }
        }, o);
      });
    }, n.prototype.currentUserInfo = function() {
      return j(this, void 0, void 0, function() {
        var t, h, e, i, o, r, a, u, h;
        return K(this, function(s) {
          switch (s.label) {
            case 0:
              return t = this.Credentials.getCredSource(), !t || t === "aws" || t === "userPool" ? [4, this.currentUserPoolUser().catch(function(l) {
                return I.error(l);
              })] : [3, 9];
            case 1:
              if (h = s.sent(), !h)
                return [2, null];
              s.label = 2;
            case 2:
              return s.trys.push([2, 8, , 9]), [4, this.userAttributes(h)];
            case 3:
              e = s.sent(), i = this.attributesToObject(e), o = null, s.label = 4;
            case 4:
              return s.trys.push([4, 6, , 7]), [4, this.currentCredentials()];
            case 5:
              return o = s.sent(), [3, 7];
            case 6:
              return r = s.sent(), I.debug("Failed to retrieve credentials while getting current user info", r), [3, 7];
            case 7:
              return a = {
                id: o ? o.identityId : void 0,
                username: h.getUsername(),
                attributes: i
              }, [2, a];
            case 8:
              return u = s.sent(), I.error("currentUserInfo error", u), [2, {}];
            case 9:
              return t === "federated" ? (h = this.user, [2, h || {}]) : [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.federatedSignIn = function(t, e, i) {
      return j(this, void 0, void 0, function() {
        var o, h, r, a, u, h, s, l, d, v, y, m;
        return K(this, function(S) {
          switch (S.label) {
            case 0:
              if (!this._config.identityPoolId && !this._config.userPoolId)
                throw new Error("Federation requires either a User Pool or Identity Pool in config");
              if (typeof t > "u" && this._config.identityPoolId && !this._config.userPoolId)
                throw new Error("Federation with Identity Pools requires tokens passed as arguments");
              return Qt(t) || Zs(t) || Xs(t) || typeof t > "u" ? (o = t || {
                provider: Dt.Cognito
              }, h = Qt(o) ? o.provider : o.customProvider, r = (Qt(o), o.customState), this._config.userPoolId && (a = $e(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID, u = $e(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri, this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, u, a, h, r)), [3, 4]) : [3, 1];
            case 1:
              h = t;
              try {
                s = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user), s && I.warn("There is already a signed in user: " + s + ` in your app.
																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.`);
              } catch {
              }
              return l = e.token, d = e.identity_id, v = e.expires_at, [4, this.Credentials.set({ provider: h, token: l, identity_id: d, user: i, expires_at: v }, "federation")];
            case 2:
              return y = S.sent(), [4, this.currentAuthenticatedUser()];
            case 3:
              return m = S.sent(), B("signIn", m, "A user " + m.username + " has been signed in"), I.debug("federated sign in credentials", y), [2, y];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype._handleAuthResponse = function(t) {
      return j(this, void 0, void 0, function() {
        var e, i, o, r, a, u, h, s, l, d, v, y, m, S;
        return K(this, function(b) {
          switch (b.label) {
            case 0:
              if (this.oAuthFlowInProgress)
                return I.debug("Skipping URL " + t + " current flow in progress"), [
                  2
                  /*return*/
                ];
              b.label = 1;
            case 1:
              if (b.trys.push([1, , 8, 9]), this.oAuthFlowInProgress = !0, !this._config.userPoolId)
                throw new Error("OAuth responses require a User Pool defined in config");
              if (B("parsingCallbackUrl", { url: t }, "The callback url is being parsed"), e = t || (Oe().isBrowser ? window.location.href : ""), i = !!(Be(e).query || "").split("&").map(function(E) {
                return E.split("=");
              }).find(function(E) {
                var _ = Fe(E, 1), T = _[0];
                return T === "code" || T === "error";
              }), o = !!(Be(e).hash || "#").substr(1).split("&").map(function(E) {
                return E.split("=");
              }).find(function(E) {
                var _ = Fe(E, 1), T = _[0];
                return T === "access_token" || T === "error";
              }), !(i || o))
                return [3, 7];
              this._storage.setItem("amplify-redirected-from-hosted-ui", "true"), b.label = 2;
            case 2:
              return b.trys.push([2, 6, , 7]), [4, this._oAuthHandler.handleAuthResponse(e)];
            case 3:
              return r = b.sent(), a = r.accessToken, u = r.idToken, h = r.refreshToken, s = r.state, l = new mn({
                IdToken: new vn({ IdToken: u }),
                RefreshToken: new yn({
                  RefreshToken: h
                }),
                AccessToken: new gn({
                  AccessToken: a
                })
              }), d = void 0, this._config.identityPoolId ? [4, this.Credentials.set(l, "session")] : [3, 5];
            case 4:
              d = b.sent(), I.debug("AWS credentials", d), b.label = 5;
            case 5:
              return v = /-/.test(s), y = this.createCognitoUser(l.getIdToken().decodePayload()["cognito:username"]), y.setSignInUserSession(l), window && typeof window.history < "u" && window.history.replaceState(window.history.state, "", this._config.oauth.redirectSignIn), B("signIn", y, "A user " + y.getUsername() + " has been signed in"), B("cognitoHostedUI", y, "A user " + y.getUsername() + " has been signed in via Cognito Hosted UI"), v && (m = s.split("-").splice(1).join("-"), B("customOAuthState", Vi(m), "State for user " + y.getUsername())), [2, d];
            case 6:
              return S = b.sent(), I.debug("Error in cognito hosted auth response", S), window && typeof window.history < "u" && window.history.replaceState(window.history.state, "", this._config.oauth.redirectSignIn), B("signIn_failure", S, "The OAuth response flow failed"), B("cognitoHostedUI_failure", S, "A failure occurred when returning to the Cognito Hosted UI"), B("customState_failure", S, "A failure occurred when returning state"), [3, 7];
            case 7:
              return [3, 9];
            case 8:
              return this.oAuthFlowInProgress = !1, [
                7
                /*endfinally*/
              ];
            case 9:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.essentialCredentials = function(t) {
      return {
        accessKeyId: t.accessKeyId,
        sessionToken: t.sessionToken,
        secretAccessKey: t.secretAccessKey,
        identityId: t.identityId,
        authenticated: t.authenticated
      };
    }, n.prototype.attributesToObject = function(t) {
      var e = this, i = {};
      return t && t.map(function(o) {
        o.Name === "email_verified" || o.Name === "phone_number_verified" ? i[o.Name] = e.isTruthyString(o.Value) || o.Value === !0 : i[o.Name] = o.Value;
      }), i;
    }, n.prototype.isTruthyString = function(t) {
      return typeof t.toLowerCase == "function" && t.toLowerCase() === "true";
    }, n.prototype.createCognitoUser = function(t) {
      var e = {
        Username: t,
        Pool: this.userPool
      };
      e.Storage = this._storage;
      var i = this._config.authenticationFlowType, o = new wn(e);
      return i && o.setAuthenticationFlowType(i), o;
    }, n.prototype._isValidAuthStorage = function(t) {
      return !!t && typeof t.getItem == "function" && typeof t.setItem == "function" && typeof t.removeItem == "function" && typeof t.clear == "function";
    }, n.prototype.noUserPoolErrorHandler = function(t) {
      return t && (!t.userPoolId || !t.identityPoolId) ? V.MissingAuthConfig : V.NoConfig;
    }, n.prototype.rejectAuthError = function(t) {
      return Promise.reject(new Me(t));
    }, n.prototype.rejectNoUserPool = function() {
      var t = this.noUserPoolErrorHandler(this._config);
      return Promise.reject(new Ju(t));
    }, n.prototype.rememberDevice = function() {
      return j(this, void 0, void 0, function() {
        var t, e;
        return K(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), [4, this.currentUserPoolUser()];
            case 1:
              return t = i.sent(), [3, 3];
            case 2:
              return e = i.sent(), I.debug("The user is not authenticated by the error", e), [2, Promise.reject("The user is not authenticated")];
            case 3:
              return t.getCachedDeviceKeyAndPassword(), [2, new Promise(function(o, r) {
                t.setDeviceStatusRemembered({
                  onSuccess: function(a) {
                    o(a);
                  },
                  onFailure: function(a) {
                    a.code === "InvalidParameterException" ? r(new Me(V.DeviceConfig)) : a.code === "NetworkError" ? r(new Me(V.NetworkError)) : r(a);
                  }
                });
              })];
          }
        });
      });
    }, n.prototype.forgetDevice = function() {
      return j(this, void 0, void 0, function() {
        var t, e;
        return K(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), [4, this.currentUserPoolUser()];
            case 1:
              return t = i.sent(), [3, 3];
            case 2:
              return e = i.sent(), I.debug("The user is not authenticated by the error", e), [2, Promise.reject("The user is not authenticated")];
            case 3:
              return t.getCachedDeviceKeyAndPassword(), [2, new Promise(function(o, r) {
                t.forgetDevice({
                  onSuccess: function(a) {
                    o(a);
                  },
                  onFailure: function(a) {
                    a.code === "InvalidParameterException" ? r(new Me(V.DeviceConfig)) : a.code === "NetworkError" ? r(new Me(V.NetworkError)) : r(a);
                  }
                });
              })];
          }
        });
      });
    }, n.prototype.fetchDevices = function() {
      return j(this, void 0, void 0, function() {
        var t, e;
        return K(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), [4, this.currentUserPoolUser()];
            case 1:
              return t = i.sent(), [3, 3];
            case 2:
              throw e = i.sent(), I.debug("The user is not authenticated by the error", e), new Error("The user is not authenticated");
            case 3:
              return t.getCachedDeviceKeyAndPassword(), [2, new Promise(function(o, r) {
                var a = {
                  onSuccess: function(u) {
                    var h = u.Devices.map(function(s) {
                      var l = s.DeviceAttributes.find(function(v) {
                        var y = v.Name;
                        return y === "device_name";
                      }) || {}, d = {
                        id: s.DeviceKey,
                        name: l.Value
                      };
                      return d;
                    });
                    o(h);
                  },
                  onFailure: function(u) {
                    u.code === "InvalidParameterException" ? r(new Me(V.DeviceConfig)) : u.code === "NetworkError" ? r(new Me(V.NetworkError)) : r(u);
                  }
                };
                t.listDevices(Qu, null, a);
              })];
          }
        });
      });
    }, n;
  }()
), pt = new tc(null);
Ot.register(pt);
const nc = async () => {
  const n = await pt.currentAuthenticatedUser() || {}, { attributes: t } = n || {};
  return t ? {
    email: t.email,
    emailVerified: t.email_verified,
    name: t.name,
    sub: t.sub,
    providerName: JSON.parse(t.identities)[0].providerName || ""
  } : void 0;
}, rc = (n) => {
  const [t, e] = Sr(), i = Xr(), { isFeatureOn: o, isFeatureInitialized: r } = _r("login-options"), { isLoading: a } = wr({
    queryKey: ["user", r],
    queryFn: nc,
    enabled: !t && o && r && n,
    onSuccess: async (s) => {
      e(s);
    }
  });
  rn(() => {
    const s = xe.listen("auth", async ({ payload: { event: l, data: d } }) => {
      switch (l) {
        case "signIn":
        case "cognitoHostedUI": {
          i.invalidateQueries(["user"]);
          break;
        }
        case "signOut":
          i.setQueryData(["user"], void 0);
          break;
        case "signIn_failure":
        case "cognitoHostedUI_failure":
          console.error("Sign in failure", d);
          break;
      }
    });
    return () => {
      s();
    };
  }, []);
  const u = Ln((s) => {
    pt.federatedSignIn({ provider: s });
  }, []), h = Ln(() => {
    pt.signOut();
  }, []);
  return Qr(
    () => ({
      login: u,
      logout: h,
      user: t,
      isLoading: a
    }),
    [u, h, t, a]
  );
}, ic = (n) => {
  console.log("Initialize Cognito Amplify config");
  const {
    identityPoolId: t,
    region: e,
    userPoolId: i,
    userPoolWebClientId: o,
    domain: r,
    responseType: a,
    signInUrl: u,
    signOutUrl: h
  } = n, s = {
    Auth: {
      identityPoolId: t,
      region: e,
      userPoolId: i,
      userPoolWebClientId: o,
      storage: sessionStorage,
      oauth: {
        domain: r,
        scope: ["email", "openid", "phone", "profile", "aws.cognito.signin.user.admin"],
        redirectSignIn: u ?? `${window.location.origin}/login/sso`,
        redirectSignOut: h ?? `${window.location.origin}/`,
        responseType: a
      }
    }
  };
  Ot.configure(s), pt.configure({ oauth: s.Auth.oauth });
}, oc = {
  login: () => {
  },
  logout: () => {
  },
  isLoading: !1,
  user: void 0
}, sc = ei(oc), mc = ({
  config: n,
  children: t
}) => {
  const [e, i] = Sr(!1), o = ti(), { isFeatureOn: r, isFeatureInitialized: a } = _r("login-options"), { data: u, refetch: h } = wr({
    queryKey: ["cognitoConfigData"],
    queryFn: () => {
      var l;
      return ni(
        n,
        `cognito_config_${o}_${(l = n == null ? void 0 : n.env) == null ? void 0 : l.toLowerCase()}`
      ).then((d) => d ? JSON.parse(d) : null).catch((d) => (console.error("Failed to fetch config ", d), null));
    },
    enabled: !1
  });
  rn(() => {
    n && r && h();
  }, [n, a]), rn(() => {
    u && (ic(u), i(!0));
  }, [u]);
  const s = rc(e);
  return /* @__PURE__ */ Zr.jsx(sc.Provider, { value: s, children: t });
};
export {
  Ot as A,
  mc as C,
  xe as H,
  vc as I,
  Ge as N,
  Yn as P,
  Dr as S,
  zs as U,
  sc as a,
  Oe as b,
  We as c,
  Ee as d,
  Bi as e,
  Kr as f,
  Un as g,
  G as h,
  pc as i,
  ji as j,
  pt as k,
  on as l,
  yc as m,
  Vn as n,
  Be as p,
  rc as u
};
